const O2Line3dView = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2Line3dView",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M19.45 18.62a.829.829 0 0 0-.826.825c0 .456.374.825.826.825h1.2c-1.944 1.282-4.925 2.07-8.237 2.07-5.712 0-10.344-2.526-10.344-5.588 0-1.037.537-1.906 1.243-2.606v.95c0 .288.163.58.413.706L12 20.563h.043c.043.043.082.043.125.043h.043c.082 0 .125.044.207.044.081 0 .124 0 .206-.044h.043c.043 0 .082-.043.125-.043h.043l8.275-4.757c.25-.163.413-.412.413-.705V5.338a.31.31 0 0 0-.081-.164c-.044-.043-.082-.124-.125-.163l-.043-.043c-.044-.043-.082-.082-.125-.082h-.043L12.826.125a.757.757 0 0 0-.826 0L3.725 4.882l-.043.043c-.044.043-.082.043-.125.081l-.043.044a.6.6 0 0 0-.125.163c-.043.043-.043.125-.082.163v6.706C1.407 13.406.413 15.019.413 16.8c0 4.013 5.256 7.2 12 7.2 3.85 0 7.281-.994 9.518-2.606v1.363c0 .456.375.825.826.825a.829.829 0 0 0 .825-.825v-4.138H19.45ZM4.963 7.036l6.62 3.806v7.613l-6.62-3.806V7.037Zm8.28 11.376v-7.57l6.62-3.806v7.613l-6.62 3.763Zm-.83-16.632 6.619 3.806-6.62 3.807-6.618-3.807 6.619-3.806Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2Line4G = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2Line4G",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M0 12c0 6.62 5.386 12 12 12s12-5.386 12-12S18.614 0 12 0 0 5.38 0 12Zm1.717 0C1.717 6.33 6.329 1.717 12 1.717c5.67 0 10.283 4.612 10.283 10.283 0 5.67-4.612 10.283-10.283 10.283-5.67 0-10.283-4.612-10.283-10.283Zm13.71 4.283A4.286 4.286 0 0 1 11.145 12a4.286 4.286 0 0 1 7.284-3.06c.34.329.345.872.01 1.212a.852.852 0 0 1-1.211.01 2.567 2.567 0 0 0-1.8-.734 2.572 2.572 0 1 0 2.424 3.433h-1.738a.857.857 0 0 1 0-1.711h2.743c.471 0 .855.384.855.855a4.285 4.285 0 0 1-4.283 4.278Zm-6.427 0a.857.857 0 0 1-.856-.855v-.856H4.717a.86.86 0 0 1-.768-.471.861.861 0 0 1 .082-.9l3.856-5.144a.865.865 0 0 1 .685-.34H9c.472 0 .856.384.856.855v4.284h.427a.857.857 0 0 1 0 1.71h-.427v.856a.858.858 0 0 1-.856.861Zm-2.572-3.427h1.71v-2.282l-1.71 2.282Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2Line5G = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2Line5G",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M12 24C5.4 24 0 18.6 0 12S5.4 0 12 0s12 5.4 12 12-5.4 12-12 12Zm0-22.286C6.34 1.714 1.714 6.34 1.714 12c0 5.66 4.627 10.286 10.286 10.286 5.66 0 10.286-4.627 10.286-10.286 0-5.66-4.632-10.286-10.286-10.286ZM7.282 16.286H5.568a.861.861 0 0 1-.86-.859c0-.47.39-.859.86-.859h1.714c.643 0 .902-.514.902-1.027 0-.557-.34-1.114-.902-1.114H4.714V7.714H9c.475 0 .86.388.86.859 0 .475-.39.859-.86.859H6.427v1.286h.86c1.454 0 2.615 1.244 2.615 2.828-.004 1.54-1.118 2.74-2.62 2.74Zm7.718 0A4.3 4.3 0 0 1 10.714 12 4.3 4.3 0 0 1 15 7.714c1.114 0 2.189.427 3 1.243.34.34.34.859 0 1.2-.34.34-.86.34-1.2 0a2.517 2.517 0 0 0-1.8-.73A2.58 2.58 0 0 0 12.427 12 2.58 2.58 0 0 0 15 14.573c1.114 0 2.054-.73 2.443-1.714h-1.757a.861.861 0 0 1-.859-.859c0-.47.389-.86.86-.86h2.74c.475 0 .86.39.86.86-.005 2.357-1.93 4.286-4.287 4.286Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineAPI = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineAPI",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M22.166 7.448h-.295a3.85 3.85 0 0 0-.377-.857l.21-.214a.855.855 0 0 0 .253-.598.855.855 0 0 0-.253-.598l-1.22-1.284a.784.784 0 0 0-.587-.258.784.784 0 0 0-.586.258l-.21.214a4.993 4.993 0 0 0-.839-.34v-.34a.849.849 0 0 0-.839-.857h-.296l-.166-.34-.043-.088A4.077 4.077 0 0 0 13.347 0h-7.27C3.85 0 2 1.888 2 4.16v15.68C2 22.156 3.85 24 6.076 24h7.395c2.269 0 4.076-1.888 4.076-4.16v-3.99c.167-.044.296-.126.42-.214a.855.855 0 0 0 .252-.598v-.302c.296-.088.549-.214.839-.384l.21.214c.333.34.839.34 1.177 0l1.259-1.285c.333-.34.333-.856 0-1.245l-.21-.214c.124-.258.253-.56.334-.856h.333a.849.849 0 0 0 .839-.857V8.353c.005-.521-.371-.905-.834-.905Zm-10.884-1.07.21.213a5.21 5.21 0 0 0-.334.857h-.339a.849.849 0 0 0-.839.856v1.756a.85.85 0 0 0 .84.856h.295c.086.302.21.56.377.856l-.21.214a.817.817 0 0 0-.253.598c0 .17.043.385.253.599l1.258 1.284c.334.34.882.34 1.221 0l.21-.214c.252.126.548.258.839.34v.384a.85.85 0 0 0 .839.857h.21v3.43H3.677V4.704H11.7l-.42.427a.817.817 0 0 0-.252.599c0 .17.043.433.253.647ZM6.076 1.7h7.27c.76 0 1.431.34 1.894.944-.296.127-.463.428-.463.774H3.807C4.103 2.43 5.022 1.7 6.077 1.7Zm7.395 20.581H6.076c-1.091 0-1.973-.73-2.27-1.712h11.977c-.339.982-1.264 1.712-2.312 1.712Zm8.276-12.606h-.882l-.124.516c-.123.515-.296 1.026-.586 1.416l-.253.428.63.598-.673.686-.586-.598-.425.258c-.505.301-.925.515-1.387.598l-.506.088v.9h-.925v-.9l-.505-.127c-.506-.126-.968-.301-1.388-.598l-.419-.258-.586.598-.672-.686.586-.598-.253-.428c-.296-.516-.505-.944-.586-1.416l-.08-.521h-.883v-.944h.882l.124-.516c.124-.516.296-.988.586-1.416l.253-.428-.586-.598.672-.686.586.598.42-.258c.505-.302.924-.516 1.387-.598l.505-.088v-.856h.925v.905l.506.127c.505.126.968.301 1.387.598l.42.258.586-.642.672.686-.586.598.253.428c.296.516.505.944.586 1.416l.086.516h.839v.944Zm-6.47-3.474c-1.177.516-1.93 1.712-1.93 3.002 0 1.8 1.387 3.26 3.108 3.26 1.259 0 2.393-.813 2.899-2.014.462-1.202.21-2.618-.672-3.557-.888-.95-2.232-1.202-3.404-.691Zm2.937 3.776c-.296.73-.968 1.202-1.721 1.202-1.011 0-1.85-.9-1.85-1.97 0-.813.462-1.543 1.135-1.845.672-.302 1.468-.126 2.016.428.549.555.715 1.41.42 2.185Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineAccessories = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineAccessories",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M11.914 0a3.925 3.925 0 0 1 3.922 3.923h-.01v2.126a2.83 2.83 0 0 1 .657 1.81v6.533c0 .522-.259.977-.656 1.255v4.426a3.925 3.925 0 0 1-3.923 3.922H5.352a3.925 3.925 0 0 1-3.922-3.922V3.923A3.929 3.929 0 0 1 5.357 0h6.557Zm3.046 14.627c.124 0 .22-.105.22-.22v-.005h-.01V7.845c0-.838-.684-1.523-1.522-1.523-.522 0-1.198.225-1.524.484v2.093c.317.263 1.002.484 1.524.484h.435c.37 0 .656.287.656.656v4.368c0 .124.106.22.22.22Zm-3.056 7.64H5.357a2.181 2.181 0 0 1-2.18-2.18V3.923c0-1.207.983-2.18 2.18-2.18h6.547c1.207 0 2.18.982 2.18 2.18v1.13a3.153 3.153 0 0 0-.436-.038c-.772 0-2.122.354-2.711 1.14a.644.644 0 0 0-.125.397v2.625c0 .143.048.277.125.397.531.714 1.695 1.068 2.485 1.13v3.722c0 .522.26.972.657 1.255v4.425c.014 1.174-.973 2.16-2.175 2.16ZM19.76 5.018c.771 0 2.122.36 2.71 1.14a.52.52 0 0 1 .11.383v2.615a.644.644 0 0 1-.124.398c-.526.714-1.695 1.073-2.485 1.13v3.717c0 .838-.685 1.523-1.523 1.523a1.527 1.527 0 0 1-1.523-1.523V7.855a2.841 2.841 0 0 1 2.835-2.836Zm1.537 3.89-.006.004h-.003V6.82c-.316-.263-1.001-.484-1.523-.484-.838 0-1.523.685-1.523 1.524v6.556c0 .125.105.22.22.22.125 0 .22-.105.22-.22v-4.368c0-.368.302-.656.656-.656h.436c.52 0 1.19-.222 1.517-.479h.006v-.005ZM5.357 3.055h3.492c.478 0 .876.397.876.876a.88.88 0 0 1-.876.877H5.357a.883.883 0 0 1-.876-.877.88.88 0 0 1 .876-.876Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineAddCaller = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineAddCaller",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M6.878 24c-1.718 0-3.201-.561-4.315-1.67l-1.66-1.642a2.808 2.808 0 0 1-.85-1.977c0-.668.245-1.287.705-1.748l2.477-2.505a2.417 2.417 0 0 1 1.877-.71 2.827 2.827 0 0 1 1.848.825l1.733 1.718c.576.572 1.45.466 2.083.279 1.09-.322 2.333-1.143 3.494-2.319 1.157-1.166 1.959-2.41 2.27-3.494.183-.634.274-1.512-.302-2.079l-1.732-1.723a2.82 2.82 0 0 1-.85-1.982c0-.667.245-1.286.706-1.747L16.852.72A2.438 2.438 0 0 1 18.73.005a2.794 2.794 0 0 1 1.848.826l1.656 1.641c1.665 1.647 2.126 4.133 1.315 7.003-.783 2.765-2.669 5.712-5.463 8.525-2.803 2.827-5.745 4.762-8.505 5.578-.941.278-1.848.422-2.703.422Zm-1.886-8.549a.758.758 0 0 0-.538.207l-2.486 2.515a.734.734 0 0 0-.206.533c0 .278.124.556.345.773l1.656 1.641c1.541 1.526 3.754 1.291 5.343.82 2.448-.72 5.208-2.548 7.77-5.135 2.55-2.573 4.335-5.342 5.031-7.79.447-1.59.667-3.797-.873-5.319l-1.656-1.642a1.133 1.133 0 0 0-.73-.335.78.78 0 0 0-.58.206L15.58 4.43a.734.734 0 0 0-.207.532c0 .279.125.557.346.773l1.733 1.719c.912.902 1.176 2.236.744 3.763-.394 1.377-1.325 2.846-2.698 4.233-1.382 1.397-2.846 2.348-4.224 2.76-1.521.447-2.86.202-3.777-.7L5.76 15.787a1.133 1.133 0 0 0-.73-.336h-.038Zm1.877-10.29h3.422c.47 0 .86.383.86.854 0 .47-.385.854-.855.854H6.874v3.422c0 .47-.384.855-.855.855a.856.856 0 0 1-.854-.855V6.87H1.742a.856.856 0 0 1-.854-.854c0-.47.384-.855.854-.855H5.16V1.738c0-.47.384-.855.854-.855s.855.384.855.855V5.16Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineAdd = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineAdd",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M22.882 11.127H13.09V.883A.88.88 0 0 0 12.206 0a.88.88 0 0 0-.883.883v10.23H1.08a.88.88 0 0 0-.883.882c0 .485.398.883.883.883h10.23v10.23a.88.88 0 0 0 .882.882.88.88 0 0 0 .883-.882v-10.22h9.783a.88.88 0 0 0 .883-.883.862.862 0 0 0-.859-.878Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineAirplane = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineAirplane",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "m18.422 23-4.767-8.072-4.43 4.49a2.606 2.606 0 0 1-3.107.41L0 16.349l1.615-1.592a2.604 2.604 0 0 1 2.483-.654l2.099.554 3.597-3.542-8.14-4.624 2.213-2.178a2.604 2.604 0 0 1 2.482-.654l8.69 2.295L19.255 1.8c1.08-1.064 2.848-1.07 3.929 0a2.702 2.702 0 0 1 0 3.87l-4.216 4.152 2.33 8.56a2.512 2.512 0 0 1-.664 2.445L18.422 23Zm-4.418-10.916 4.784 8.1.591-.582a.782.782 0 0 0 .208-.771l-2.589-9.524 4.936-4.862a.99.99 0 0 0 0-1.42 1.027 1.027 0 0 0-1.44 0l-4.937 4.863-9.67-2.55a.828.828 0 0 0-.782.204l-.59.583 8.138 4.629L6.72 16.59l-3.078-.815a.832.832 0 0 0-.777.2l4.131 2.35a.82.82 0 0 0 .98-.127l6.028-6.115Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineAirtime = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineAirtime",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M14.7 0c1.482 0 2.819.79 3.567 2.056 2.14.505 3.738 2.462 3.733 4.798v.038c-.01 2.106-1.31 3.894-3.128 4.595v8.23C18.872 22.082 17 24 14.695 24H7.176C4.872 24 3 22.08 3 19.718V4.282C3 1.92 4.872 0 7.176 0H14.7Zm-.005 1.716H7.176c-1.235 0-2.267.927-2.465 2.144h8.663a4.835 4.835 0 0 1 2.62-1.77 2.418 2.418 0 0 0-1.299-.374Zm.005 20.562H7.176c-1.24 0-2.267-.926-2.47-2.144h12.46c-.198 1.218-1.23 2.144-2.466 2.144ZM4.675 18.424h12.53v-6.619h-.012a4.653 4.653 0 0 1-1.844-.378l-3.557.982.952-3.647a4.99 4.99 0 0 1-.192-3.191H4.674v12.853Zm16.08-11.52c-.021 1.995-1.61 3.613-3.562 3.613a3.55 3.55 0 0 1-1.529-.351l-.209-.099-1.893.521.508-1.941-.096-.214a3.678 3.678 0 0 1-.342-1.568c0-2.012 1.599-3.652 3.578-3.652 1.946 0 3.534 1.618 3.55 3.608v.082h-.005Zm-4.177-2.188c0-.357.279-.642.626-.642a.63.63 0 0 1 .626.636v2.144a.631.631 0 0 1-.626.642h-1.668a.631.631 0 0 1-.626-.642c0-.356.278-.642.626-.642h1.043V4.716Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineAlert = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineAlert",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M22.968 18.773a12.094 12.094 0 0 1-2.4-7.2V8.568C20.568 3.85 16.723 0 12 0 7.277 0 3.427 3.85 3.427 8.568v3.005c0 2.573-.854 5.14-2.4 7.2a.848.848 0 0 0-.077.893.873.873 0 0 0 .768.475h6.888a3.431 3.431 0 1 0 6.806 0h6.889a.858.858 0 0 0 .768-.475.894.894 0 0 0-.101-.893Zm-9.26 1.795c0 .94-.767 1.709-1.708 1.709-.94 0-1.709-.768-1.709-1.709 0-.144.02-.293.058-.427h3.312a2.1 2.1 0 0 1 .048.427ZM3.303 18.432a13.813 13.813 0 0 0 1.839-6.86V8.569c0-3.778 3.081-6.86 6.859-6.86s6.86 3.082 6.86 6.86v3.005c0 2.4.642 4.78 1.838 6.859H3.302Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineApps = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineApps",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M8.309 11.078h-5.54A2.774 2.774 0 0 1 0 8.308V2.77A2.774 2.774 0 0 1 2.77 0h5.539a2.774 2.774 0 0 1 2.77 2.77v5.539a2.774 2.774 0 0 1-2.77 2.77Zm-5.54-9.23a.928.928 0 0 0-.921.922v5.539c0 .504.418.921.922.921h5.539a.928.928 0 0 0 .921-.921v-5.54a.928.928 0 0 0-.921-.921h-5.54Zm18.461 9.23h-5.539a2.774 2.774 0 0 1-2.77-2.77V2.77A2.774 2.774 0 0 1 15.692 0h5.54A2.774 2.774 0 0 1 24 2.77v5.539a2.774 2.774 0 0 1-2.77 2.77Zm-5.539-9.23a.928.928 0 0 0-.921.922v5.539c0 .504.417.921.921.921h5.54a.928.928 0 0 0 .921-.921v-5.54a.928.928 0 0 0-.922-.921h-5.539ZM8.31 24H2.77A2.774 2.774 0 0 1 0 21.23v-5.539a2.774 2.774 0 0 1 2.77-2.77h5.539a2.774 2.774 0 0 1 2.77 2.77v5.54A2.774 2.774 0 0 1 8.308 24Zm-5.54-9.23a.928.928 0 0 0-.921.921v5.54c0 .503.418.921.922.921H8.31a.928.928 0 0 0 .921-.922v-5.539a.928.928 0 0 0-.921-.921H2.77ZM21.23 24h-5.539a2.774 2.774 0 0 1-2.77-2.77v-5.539a2.774 2.774 0 0 1 2.77-2.77h5.54A2.774 2.774 0 0 1 24 15.692v5.54A2.774 2.774 0 0 1 21.23 24Zm-5.539-9.23a.928.928 0 0 0-.921.921v5.54c0 .503.417.921.921.921h5.54a.928.928 0 0 0 .921-.922v-5.539a.928.928 0 0 0-.922-.921h-5.539Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineArrowDouble1 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineArrowDouble1",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M7.075 20.597c-.475 0-.902-.173-1.243-.514L.005 14.174 5.832 8.18c.514-.513 1.33-.643 2.054-.34.687.302 1.157.902 1.157 1.588v1.757h7.714v3.34c.043.044.216.087.259.087l4.67-4.713-4.713-4.796a.896.896 0 0 0-.26.087v3.427h-5.995a.856.856 0 0 1-.854-.854.86.86 0 0 1 .854-.855H15V5.15c0-.686.427-1.286 1.157-1.588.73-.303 1.54-.173 2.054.34L24 9.892l-5.827 5.91c-.514.513-1.33.643-2.055.34-.686-.302-1.113-.902-1.113-1.588v-1.67H7.286V9.455c-.043-.043-.216-.086-.259-.086l-4.67 4.795 4.67 4.713a.896.896 0 0 0 .26-.086v-3.34h5.995c.475 0 .854.388.854.853a.863.863 0 0 1-.854.855H9v1.67c0 .687-.427 1.287-1.157 1.59a1.561 1.561 0 0 1-.768.177Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineArrowDouble2 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineArrowDouble2",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M11.438 24H3v-8.443c0-.687.427-1.33 1.114-1.627.6-.216 1.454-.216 1.886.216l1.286 1.286L16.714 6l2.4 2.4c.086.086.172 0 .172-.086v-6.6h-6.6c-.086 0-.13.13-.086.172.557.6 2.4 2.4 2.4 2.4l-7.502 7.498-1.287-1.286 6.216-6.212L11.141 3c-.427-.427-.427-1.286-.216-1.886C11.227.427 11.87 0 12.557 0H21v8.443c0 .687-.427 1.33-1.114 1.627-.6.216-1.454.216-1.886-.216l-1.286-1.286L7.282 18l-2.4-2.4c-.087-.086-.173 0-.173.086v6.6h6.6c.086 0 .13-.13.086-.172l-2.4-2.4 7.498-7.498 1.286 1.286-6.206 6.212L12.859 21c.427.427.427 1.286.216 1.886-.302.687-.95 1.114-1.637 1.114Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineArrowDouble3 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineArrowDouble3",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M12.542 24h8.256v-8.443c0-.687-.417-1.33-1.09-1.627-.585-.216-1.425-.216-1.842.216l-1.258 1.286L7.392 6 5.045 8.4c-.082.086-.168 0-.168-.086v-6.6h6.451c.082 0 .13.13.082.172-.548.6-2.348 2.4-2.348 2.4l7.335 7.498 1.257-1.286-6.072-6.212L12.84 3c.418-.427.418-1.286.211-1.886C12.754.427 12.125 0 11.458 0H3.202v8.443c0 .687.417 1.33 1.09 1.627.585.216 1.425.216 1.842-.216l1.258-1.286L16.608 18l2.347-2.4c.082-.086.168 0 .168.086v6.6h-6.451c-.082 0-.13-.13-.082-.172l2.348-2.4-7.335-7.503-1.257 1.287 6.076 6.216L11.165 21c-.418.427-.418 1.286-.211 1.886.292.687.921 1.114 1.588 1.114Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineArrowDown",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M15.524 0c-.456 0-.83.389-.83.86v10.07h6.014c.413 0 .663.34.744.643.043.13.168.557-.125.859l-9.326 9.211-9.326-9.211c-.293-.302-.211-.73-.125-.86.125-.258.374-.642.744-.642h6.014V.86c0-.476-.374-.86-.83-.86-.456 0-.83.389-.83.86v8.356H3.294c-.994 0-1.906.686-2.28 1.67-.374.941-.211 2.016.5 2.703L12 24l10.49-10.373c.706-.73.874-1.757.5-2.74-.413-.99-1.287-1.671-2.28-1.671h-4.354V.859c0-.47-.375-.859-.83-.859Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineArrowLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineArrowLeft",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M12.043 23.563a2.55 2.55 0 0 1-1.713-.686L.005 11.995 10.33 1.157c.73-.73 1.756-.903 2.702-.514.989.427 1.54 1.33 1.54 2.357v4.498h8.569c.475 0 .854.388.854.854a.863.863 0 0 1-.854.854H12.859v-6.21c0-.428-.216-.687-.475-.774a.682.682 0 0 0-.816.13l-9.206 9.643 9.21 9.682c.303.302.687.173.817.13.259-.13.475-.39.475-.817v-6.21h10.282c.475 0 .854.388.854.854a.86.86 0 0 1-.854.854h-8.573v4.498c0 1.027-.514 1.968-1.541 2.356a2.486 2.486 0 0 1-.989.221Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineArrowRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineArrowRight",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M11.96 23.566a2.55 2.55 0 0 0 1.712-.687L24 11.995 13.672 1.15c-.729-.73-1.756-.902-2.701-.513-1.027.389-1.54 1.33-1.54 2.356v4.502H.858A.861.861 0 0 0 0 8.353c0 .47.389.859.859.859h10.29v-6.22c0-.427.215-.686.474-.772a.682.682 0 0 1 .816.13l9.214 9.64-9.223 9.69c-.303.302-.687.172-.816.13-.26-.13-.475-.39-.475-.817V14.78H.859a.861.861 0 0 0-.859.859c0 .47.389.859.859.859h8.576v4.501c0 1.027.513 1.973 1.54 2.357.298.124.639.21.984.21Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineArrowUp",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M8.477 24c.456 0 .83-.389.83-.86V13.07H3.293c-.413 0-.663-.34-.744-.643-.043-.13-.168-.557.125-.859L12 2.357l9.326 9.211c.293.302.212.73.125.86-.125.258-.374.642-.744.642h-6.014v10.07c0 .476.374.86.83.86.456 0 .83-.389.83-.86v-8.356h4.354c.994 0 1.906-.686 2.28-1.67.375-.941.211-2.016-.5-2.703L12 0 1.512 10.373c-.706.73-.874 1.757-.5 2.74.414.99 1.287 1.671 2.28 1.671h4.354v8.357c0 .47.375.859.83.859Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineArrowBottomLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineArrowBottomLeft",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M22.45 5.606a2.636 2.636 0 0 0-2.847.572l-3.321 3.321L7.037.255a.866.866 0 0 0-1.215 0 .866.866 0 0 0 0 1.214l9.975 9.974.153.068c.524.225.682.067 1.546-.797l3.312-3.312a.865.865 0 0 1 .97-.202.767.767 0 0 1 .484.74v14.35H7.997a.761.761 0 0 1-.73-.504c-.115-.283-.125-.71.192-1.027l3.975-3.974.067-.154c.173-.427.201-.514-.797-1.536l-.931-.936-8.304-8.342a.866.866 0 0 0-1.215 0 .866.866 0 0 0 0 1.214L9.5 16.277 6.245 19.53a2.675 2.675 0 0 0-.571 2.904C6.072 23.395 6.955 24 7.987 24H23.99V7.925c0-1.037-.59-1.93-1.54-2.319Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineArrowBottomRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineArrowBottomRight",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M16 23.998H0V7.925c0-1.041.59-1.934 1.545-2.323a2.636 2.636 0 0 1 2.846.572l3.321 3.32L16.965.252a.866.866 0 0 1 1.215 0 .866.866 0 0 1 0 1.215l-9.863 9.852c-.605.605-1.07.144-1.828-.614L3.177 7.393a.876.876 0 0 0-.97-.207.767.767 0 0 0-.484.74v14.359h14.292c.475 0 .672-.35.73-.504a.955.955 0 0 0-.192-1.032l-4.459-4.458L22.537 5.818a.866.866 0 0 1 1.215 0 .866.866 0 0 1 0 1.215l-9.253 9.253 3.254 3.254c.758.758.979 1.895.57 2.903-.407.95-1.29 1.555-2.322 1.555Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineAttachment = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineAttachment",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M17.715 25a4.339 4.339 0 0 1-3.098-1.303L1.79 10.63A6.23 6.23 0 0 1 0 6.226c0-1.662.637-3.225 1.789-4.404A6.003 6.003 0 0 1 6.113 0a6.04 6.04 0 0 1 4.325 1.822l13.297 13.532a.934.934 0 0 1 0 1.303.893.893 0 0 1-1.28 0L9.159 3.125A4.23 4.23 0 0 0 6.113 1.84a4.23 4.23 0 0 0-3.045 1.285 4.379 4.379 0 0 0-1.262 3.101c0 1.174.446 2.27 1.262 3.102l12.829 13.066a2.542 2.542 0 0 0 3.635 0 2.657 2.657 0 0 0 0-3.703L6.704 5.631a.842.842 0 0 0-1.175 0 .85.85 0 0 0-.244.601c0 .23.087.443.244.602l11.595 11.81a.934.934 0 0 1 0 1.303.893.893 0 0 1-1.28 0L4.25 8.13a2.726 2.726 0 0 1 0-3.803 2.608 2.608 0 0 1 3.74 0l12.828 13.066c1.708 1.74 1.708 4.57 0 6.303A4.372 4.372 0 0 1 17.715 25Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineAwardWinningBusinessNetwork = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineAwardWinningBusinessNetwork",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M20.355 1.303h1.072C22.884 1.303 24 2.333 24 3.66v3.866c0 2.357-1.758 4.24-4.029 4.498a8.371 8.371 0 0 1-7.114 5.787v.642h1.716c.344 0 .641.167.77.469l1.931 3.856a.79.79 0 0 1-.043.815c-.172.215-.426.388-.728.388H7.502a.839.839 0 0 1-.728-.388c-.173-.216-.173-.556-.043-.815l1.925-3.865c.13-.298.427-.47.772-.47h1.714v-.642c-3.516-.34-6.385-2.87-7.243-6.213C1.63 11.378 0 9.576 0 7.09V3.875a2.582 2.582 0 0 1 2.572-2.572h1.069V.877c0-.47.388-.858.857-.858h14.999c.47 0 .858.388.858.858v.426Zm-10.41 18.86-1.073 2.141h6.256l-1.111-2.141H9.945ZM1.715 7.09V3.875c0-.426.426-.857.857-.857h1.074v6.817c-1.16-.302-1.931-1.332-1.931-2.745Zm3.64 2.4c0 3.645 3.004 6.644 6.645 6.644 3.64 0 6.644-2.999 6.64-6.644V1.734H5.356V9.49Zm16.93-1.97c0 1.285-.814 2.358-1.974 2.66 0-.13.011-.247.022-.365.01-.117.022-.234.022-.364V3.018h1.072c.346 0 .858.172.858.642v3.86Zm-6.64-3.645c0-.34.298-.642.642-.642.34 0 .642.302.642.642v7.885c0 .34-.297.642-.642.642a.658.658 0 0 1-.641-.642V3.875ZM13.457 5.59a.658.658 0 0 0-.642.642v5.485c0 .345.302.642.642.642a.658.658 0 0 0 .642-.642V6.232a.658.658 0 0 0-.642-.642Zm-2.912 2.4a.658.658 0 0 0-.642.642v3.128c0 .345.302.642.642.642s.642-.297.642-.642V8.632a.633.633 0 0 0-.642-.642ZM7.713 9.92a.658.658 0 0 0-.642.643v1.159c0 .345.301.642.642.642a.66.66 0 0 0 .641-.642v-1.16a.651.651 0 0 0-.641-.641Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineBag = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineBag",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M20.06 5.436h-3.304v-.68a4.756 4.756 0 1 0-9.512 0v.68H3.94L2.033 21.193v.091c0 1.629.905 2.716 2.26 2.716h15.404c1.36 0 2.26-1.087 2.26-2.716L20.061 5.436Zm-11.005-.68A2.94 2.94 0 0 1 12 1.81a2.937 2.937 0 0 1 2.945 2.946v.68h-5.89v-.68ZM19.697 22.19H4.299c-.408 0-.45-.59-.45-.858l1.724-14.08H18.48l1.677 14.08c-.005.268-.053.858-.46.858Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineBatteryCharged = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineBatteryCharged",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M16.714 24H7.29a2.576 2.576 0 0 1-2.573-2.573V4.714A2.576 2.576 0 0 1 7.291 2.14h1.282V0h6.859v2.146h1.282a2.576 2.576 0 0 1 2.572 2.572v16.714A2.575 2.575 0 0 1 16.714 24ZM7.29 3.854a.856.856 0 0 0-.854.855v16.713c0 .47.384.855.854.855h9.432c.47 0 .855-.384.855-.855V4.714a.856.856 0 0 0-.855-.855h-3V1.714h-3.427v2.145H7.291v-.005Zm3.423 14.458A.87.87 0 0 0 11.89 18l3-5.146a.847.847 0 0 0 .004-.859.847.847 0 0 0-.739-.427h-2.793l2.25-3.85a.855.855 0 0 0-.306-1.176.855.855 0 0 0-1.176.308l-3 5.145a.847.847 0 0 0-.005.86.847.847 0 0 0 .739.427h2.794l-2.252 3.854a.855.855 0 0 0 .308 1.176Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineBenefit = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineBenefit",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "m20.625 12 2.646-2.86a.865.865 0 0 0 .187-.847.85.85 0 0 0-.651-.577l-3.828-.765.447-3.86a.853.853 0 0 0-.348-.792.877.877 0 0 0-.867-.088l-3.546 1.617L12.748.44a.86.86 0 0 0-1.502 0L9.329 3.828 5.783 2.21a.864.864 0 0 0-1.215.88l.453 3.86-3.828.765a.867.867 0 0 0-.651.577.85.85 0 0 0 .187.847L3.375 12 .73 14.86a.865.865 0 0 0-.187.847.85.85 0 0 0 .651.577l3.828.765-.453 3.86c-.033.308.1.61.348.792a.876.876 0 0 0 .867.088l3.546-1.617 1.917 3.388a.86.86 0 0 0 1.502 0l1.917-3.388 3.546 1.617a.877.877 0 0 0 .867-.088.842.842 0 0 0 .348-.792l-.447-3.86 3.828-.765a.867.867 0 0 0 .651-.577.85.85 0 0 0-.187-.847L20.625 12Zm-2.767 3.52a.852.852 0 0 0-.685.94l.364 3.13-2.877-1.315a.866.866 0 0 0-1.11.357l-1.553 2.75-1.552-2.744a.855.855 0 0 0-.751-.44.916.916 0 0 0-.36.077l-2.877 1.314.365-3.129a.86.86 0 0 0-.685-.94l-3.104-.622 2.143-2.32a.86.86 0 0 0 0-1.166L3.033 9.09l3.104-.622a.852.852 0 0 0 .685-.94l-.365-3.13 2.878 1.315a.866.866 0 0 0 1.11-.357l1.552-2.74 1.552 2.745a.862.862 0 0 0 1.11.358l2.878-1.315-.364 3.13a.86.86 0 0 0 .685.94l3.104.621-2.143 2.321a.86.86 0 0 0 0 1.166l2.143 2.32-3.104.617Zm-4.988-3.95h2.58c.474 0 .861.385.861.858a.861.861 0 0 1-.862.858h-2.58v2.58a.86.86 0 0 1-1.722 0v-2.58h-2.59a.86.86 0 0 1-.863-.858.86.86 0 0 1 .862-.858h2.59V8.99a.861.861 0 0 1 1.724 0v2.58Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineBoltOns = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineBoltOns",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M18 1.5H6L0 12l6 10.5h12L24 12 18 1.5Zm-.982 19.288H6.982L1.958 12l5.018-8.788h10.042L22.042 12l-5.024 8.788ZM16.872 12c0 .472-.38.856-.847.856h-3.179v3.214c0 .472-.38.856-.846.856a.852.852 0 0 1-.846-.855v-3.215h-3.18A.852.852 0 0 1 7.129 12c0-.472.38-.856.847-.856h3.179V7.93c0-.471.38-.855.846-.855.466 0 .846.384.846.855v3.215h3.18c.466 0 .846.384.846.856Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineBoost = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineBoost",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M19.594 5.945a1.54 1.54 0 0 1-1.539 1.54 1.544 1.544 0 0 1-1.538-1.54c0-.845.693-1.538 1.538-1.538.846 0 1.539.693 1.539 1.538Zm4.148-4.441-.76.76a4.472 4.472 0 0 1-.559 5.626l-7.045 7.046 1.443 5.564-3.14 3.455-3.668-3.647-.857.857-6.318-6.32.907-.907L.031 10.05l3.506-2.87 5.529 1.444 7.045-7.04a4.511 4.511 0 0 1 3.145-1.33 4.424 4.424 0 0 1 2.502.743l.739-.738a.88.88 0 0 1 1.245 1.246ZM4.991 12.693l2.632-2.627-3.664-.953-1.341 1.094 2.373 2.486Zm8.944 3.686-2.677 2.683 2.362 2.345 1.262-1.387-.947-3.64Zm7.237-13.55-.26-.266a2.603 2.603 0 0 0-1.64-.546 2.735 2.735 0 0 0-1.916.811L5.33 14.846l3.827 3.827L21.172 6.644a2.698 2.698 0 0 0 0-3.816ZM5.092 18.91a.66.66 0 0 0-.935 0L.194 22.873A.66.66 0 0 0 .662 24c.17 0 .338-.062.468-.192l3.962-3.962a.66.66 0 0 0 0-.936Zm-4.43.688c.17 0 .338-.062.468-.192l1.759-1.764a.66.66 0 0 0 0-.936.66.66 0 0 0-.936 0L.194 18.465a.66.66 0 0 0 0 .935.64.64 0 0 0 .468.198Zm5.698 1.516-1.758 1.759A.66.66 0 0 0 5.07 24a.653.653 0 0 0 .467-.192l1.759-1.758a.66.66 0 0 0 0-.936.66.66 0 0 0-.936 0Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineBusinessApps = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineBusinessApps",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M21.229.222h-5.542c-1.524 0-2.771 1.23-2.771 2.745v5.49c0 1.51 1.24 2.744 2.77 2.744h5.543c1.524 0 2.771-1.229 2.771-2.745V2.961c0-1.51-1.24-2.739-2.771-2.739Zm.928 8.229a.919.919 0 0 1-.922.913h-5.542a.919.919 0 0 1-.922-.913V2.96a.92.92 0 0 1 .922-.913h5.542a.92.92 0 0 1 .922.913v5.49Zm-13.85 4.57H2.771C1.247 13.021 0 14.251 0 15.766v5.49C0 22.765 1.24 24 2.771 24h5.542c1.525 0 2.771-1.229 2.771-2.745v-5.49c-.006-1.515-1.252-2.744-2.777-2.744Zm.922 8.229a.919.919 0 0 1-.922.912H2.771a.919.919 0 0 1-.922-.912v-5.49a.92.92 0 0 1 .922-.913h5.542a.92.92 0 0 1 .922.913v5.49h-.006ZM8.496 2.515A2.997 2.997 0 0 0 5.536 0a2.997 2.997 0 0 0-2.96 2.516C1.14 2.616 0 3.804 0 5.25v3.202c0 1.51 1.24 2.744 2.771 2.744h5.542c1.525 0 2.771-1.229 2.771-2.744V5.249c-.006-1.45-1.146-2.633-2.588-2.733ZM5.536 1.37c.644 0 1.2.375 1.46.913h-2.92a1.62 1.62 0 0 1 1.46-.913ZM9.23 8.451a.919.919 0 0 1-.922.913H2.771a.919.919 0 0 1-.922-.913V5.249c0-.503.414-.912.922-.912h5.542c.508 0 .922.41.922.912v3.202h-.006Zm12 4.57h-5.542c-1.524 0-2.771 1.23-2.771 2.745v5.49c0 1.51 1.24 2.744 2.77 2.744h5.543c1.523 0 2.77-1.229 2.77-2.745v-5.49c0-1.515-1.24-2.744-2.771-2.744Zm.928 8.229a.919.919 0 0 1-.922.912h-5.542a.919.919 0 0 1-.922-.912v-5.49a.92.92 0 0 1 .922-.913h5.542a.92.92 0 0 1 .922.913v5.49Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineBusinessPlan = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineBusinessPlan",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M6.667 18.361v1.35a.895.895 0 0 1-.887.901.895.895 0 0 1-.888-.9v-1.35c0-.497.398-.901.888-.901.489 0 .887.398.887.9Zm3.334-3.838a.895.895 0 0 0-.888.9v4.283c0 .496.398.9.888.9a.895.895 0 0 0 .887-.9v-4.277a.89.89 0 0 0-.887-.906Zm4.226-3.151a.895.895 0 0 0-.887.9v7.44c0 .496.398.9.887.9.49 0 .887-.404.887-.9v-7.44c0-.496-.398-.9-.887-.9ZM18.67 8.44a.895.895 0 0 0-.888.9v10.372c0 .496.399.9.888.9s.887-.404.887-.9V9.34c0-.496-.398-.9-.887-.9ZM24 7.99v13.303C24 22.783 22.805 24 21.332 24H2.668C1.2 24 0 22.788 0 21.293V7.99C0 6.5 1.195 5.283 2.668 5.283h3.885C7.133 2.84 9.42 1 12.003 1c2.554 0 4.67 1.772 5.228 4.283h4.107C22.805 5.283 24 6.495 24 7.989ZM8.504 5.056h6.798c-.552-1.35-1.814-2.256-3.3-2.256a3.87 3.87 0 0 0-3.498 2.256ZM22.225 7.99c0-.496-.398-.9-.887-.9H2.668a.895.895 0 0 0-.887.9v13.304c0 .497.398.9.887.9h18.664c.49 0 .887-.404.887-.9V7.99h.006Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineBusiness = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineBusiness",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M21.202 4.637h-4.647C16.277 2.567 14.347.955 12 .955c-2.347 0-4.325 1.613-4.555 3.682H2.798a2.77 2.77 0 0 0-2.76 2.76V20.28a2.77 2.77 0 0 0 2.76 2.76h18.404a2.77 2.77 0 0 0 2.76-2.76V7.397a2.77 2.77 0 0 0-2.76-2.76ZM12 2.798c1.334 0 2.438.783 2.712 1.843H9.283c.279-1.06 1.383-1.843 2.717-1.843ZM2.798 6.475h18.404c.504 0 .921.413.921.922v3.681H1.877V7.397c0-.504.413-.922.921-.922Zm18.404 14.726H2.798a.925.925 0 0 1-.921-.921v-7.363h20.241v7.358a.916.916 0 0 1-.916.927Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineCalendar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineCalendar",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M17.568 2.573h3.86A2.578 2.578 0 0 1 24 5.14V24H0V5.14a2.578 2.578 0 0 1 2.573-2.567h3.85V.859A.86.86 0 0 1 7.282 0c.475 0 .859.389.859.86v1.713h7.713V.859c0-.475.39-.859.86-.859s.859.384.854.86v1.713ZM6.432 4.286h-3.86a.858.858 0 0 0-.858.86v3H22.3v-3a.861.861 0 0 0-.86-.86h-3.859V6a.858.858 0 1 1-1.718 0V4.286H8.15V6c0 .475-.388.86-.859.86A.861.861 0 0 1 6.432 6V4.286Zm-4.718 18V9.86h20.572v12.427H1.714Zm7.459-11.184H8.4c-.514 0-1.54.216-2.102.644a.84.84 0 0 0-.13 1.2c.302.384.86.427 1.243.172.13-.086.687-.259.984-.259h.773c.6 0 1.114.514 1.114 1.157s-.47 1.157-1.114 1.157H8.016a.907.907 0 0 0-.902.902c0 .519.384.898.902.898h1.157c.6 0 1.113.513 1.113 1.157 0 .643-.47 1.156-1.113 1.156H8.4c-.302 0-.86-.172-.984-.259-.384-.302-.94-.259-1.243.13-.303.384-.26.94.13 1.243.556.427 1.583.643 2.102.643h.773c1.584 0 2.87-1.33 2.87-2.913a3.04 3.04 0 0 0-.816-2.06c.514-.513.816-1.243.816-2.059-.005-1.584-1.291-2.909-2.875-2.909Zm7.113.168a.777.777 0 0 0-.859 0l-1.968 1.114a.81.81 0 0 0-.302 1.157.81.81 0 0 0 1.157.302L15 13.46v6.687a.858.858 0 1 0 1.718-.001V12c-.004-.298-.177-.6-.432-.73Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineCallCentreOperator = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineCallCentreOperator",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M16.682 11.575h1.32A2.58 2.58 0 0 0 20.576 9v-.244c0-4.663-3.708-8.587-8.26-8.75C9.96-.072 7.735.777 6.052 2.408a8.536 8.536 0 0 0-2.624 6.174c0 .48.379.859.858.859.48 0 .859-.38.859-.859A6.82 6.82 0 0 1 7.24 3.646a6.844 6.844 0 0 1 5.013-1.924c3.636.13 6.606 3.291 6.606 7.038v.244c0 .47-.38.859-.859.859h-.585c.096-.408.158-.84.158-1.286a5.574 5.574 0 0 0-5.57-5.57c-3.07 0-5.569 2.5-5.569 5.57 0 1.756.82 3.325 2.097 4.351-3.094.945-5.104 3.171-5.104 5.958v4.255c0 .48.379.859.858.859.48 0 .859-.379.859-.859v-4.255c0-2.748 2.888-4.74 6.86-4.74 3.972 0 6.86 2.001 6.86 4.74v4.255c0 .48.379.859.858.859.48 0 .86-.379.86-.859v-4.255c0-2.801-2.01-5.013-5.105-5.958a5.418 5.418 0 0 0 1.204-1.353ZM8.148 8.582A3.855 3.855 0 0 1 12 4.73a3.855 3.855 0 0 1 3.852 3.852c0 .451-.077.878-.225 1.286h-2.773a.852.852 0 0 0-.859.858c0 .48.38.859.859.859h1.559a3.82 3.82 0 0 1-2.418.859 3.868 3.868 0 0 1-3.847-3.862Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineCallback = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineCallback",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "m23.255 19.256-4.683.666-.674-4.639a.871.871 0 0 1 .74-.983.877.877 0 0 1 .994.733l.258 1.778a9.649 9.649 0 0 0 1.587-5.311c0-5.383-4.425-9.767-9.86-9.767-5.436 0-9.861 4.384-9.861 9.767 0 5.383 4.425 9.767 9.86 9.767 1.24 0 2.446-.223 3.585-.667a.874.874 0 0 1 1.133.494.863.863 0 0 1-.5 1.123 11.62 11.62 0 0 1-4.223.783C5.205 23 0 17.839 0 11.5S5.21 0 11.61 0c6.4 0 11.611 5.161 11.611 11.5 0 2.25-.656 4.411-1.873 6.267l1.65-.234a.877.877 0 0 1 .992.734.869.869 0 0 1-.735.989ZM13.39 10.56c.09-.317.14-.744-.13-1.005l-.986-.967c-.673-.661-.713-1.711-.085-2.339l1.414-1.411c.628-.628 1.688-.6 2.361.061l.943.922c2.08 2.04 1.194 6.278-1.97 9.44-2.164 2.121-4.492 3.044-6.399 3.044-1.268 0-2.35-.406-3.085-1.14l-.931-.933c-.668-.666-.696-1.716-.062-2.339l1.425-1.4c.634-.622 1.694-.583 2.361.084l.976.978c.264.266.696.216 1.015.127.59-.166 1.274-.605 1.913-1.233.628-.628 1.072-1.3 1.24-1.889Zm1.262.356c-.23.805-.774 1.655-1.576 2.46l-.006.006c-.813.795-1.671 1.334-2.485 1.561-.93.262-1.75.095-2.305-.46l-.976-.978a.468.468 0 0 0-.32-.145.247.247 0 0 0-.18.067L5.38 14.822c-.118.117-.084.345.073.5l.931.934c1.352 1.35 4.65 1.005 7.623-1.912 2.877-2.877 3.343-6.25 1.974-7.594l-.942-.922c-.157-.156-.387-.184-.505-.072l-1.413 1.41c-.113.117-.079.345.078.495l.987.967c.567.555.73 1.366.466 2.289Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineCalls = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineCalls",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M6.851 23.952h-.038c-1.747-.01-3.25-.6-4.353-1.728L.833 20.568c-1.066-1.075-1.114-2.764-.115-3.753l2.51-2.481a2.443 2.443 0 0 1 1.747-.706h.01c.724 0 1.454.322 1.986.855L8.69 16.22c.283.283.667.427 1.151.437h.01c1.233 0 2.87-.903 4.392-2.405 1.511-1.521 2.404-3.168 2.404-4.401 0-.485-.144-.873-.437-1.152l-1.737-1.718a2.823 2.823 0 0 1-.854-1.987c0-.667.254-1.3.705-1.766l2.481-2.51c.999-.999 2.683-.95 3.763.115l1.656 1.636c1.114 1.104 1.718 2.607 1.728 4.354.02 3.354-2.121 7.434-5.865 11.216l-.058.058c-3.762 3.724-7.832 5.855-11.178 5.855ZM4.97 15.37a.72.72 0 0 0-.514.202l-2.51 2.481c-.321.322-.264.893.125 1.291L3.708 21c.787.797 1.833 1.19 3.11 1.2 2.908.01 6.522-1.939 9.973-5.36l.048-.049c3.422-3.45 5.37-7.084 5.361-9.973-.01-1.291-.408-2.338-1.2-3.11L19.345 2.07c-.39-.389-.97-.446-1.292-.125l-2.49 2.51a.741.741 0 0 0-.202.524c0 .273.125.542.34.758l1.738 1.718c.62.61.95 1.435.95 2.385.01 1.704-1.055 3.763-2.918 5.645-1.881 1.862-3.945 2.918-5.644 2.918-.95-.01-1.776-.331-2.385-.95l-1.719-1.738a1.018 1.018 0 0 0-.753-.345Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineCamera = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineCamera",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M23.995 19.72a2.553 2.553 0 0 1-2.557 2.567H2.572A2.575 2.575 0 0 1 0 19.715v-12a2.575 2.575 0 0 1 2.572-2.571h2.644l3.176-3.177a.866.866 0 0 1 .604-.254H15c.225 0 .446.086.604.254l3.177 3.177h2.643a2.575 2.575 0 0 1 2.572 2.571V19.72ZM2.572 6.856a.856.856 0 0 0-.854.854v12.005c0 .47.384.854.854.854h18.866c.47 0 .854-.383.854-.854v-12a.856.856 0 0 0-.854-.854h-3.004a.827.827 0 0 1-.604-.254L14.653 3.43H9.366L6.19 6.607a.866.866 0 0 1-.605.254l-3.013-.005Zm9.433 12a6.008 6.008 0 0 1-6.003-6.002 6.004 6.004 0 0 1 6.003-5.998c3.31 0 6.002 2.697 6.002 6.008 0 3.31-2.692 5.992-6.002 5.992Zm0-10.287a4.286 4.286 0 0 0 0 8.57 4.286 4.286 0 0 0 0-8.57Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineCertificate = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineCertificate",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "m21.898 19.775-2.645-4.545c1.503-1.589 2.412-3.771 2.412-6.14 0-4.999-4.096-9.09-9.101-9.09-5.005 0-9.102 4.091-9.102 9.09 0 2.316.863 4.458 2.32 6.047l-2.687 4.638a.697.697 0 0 0 .047.774c.18.227.454.32.728.227l3.595-1.048 1.09 3.771c.093.274.32.454.594.501h.093c.228 0 .455-.134.595-.36l2.686-4.686 2.686 4.685a.702.702 0 0 0 .594.361h.093a.748.748 0 0 0 .595-.5l1.095-3.772 3.595 1.048c.274.093.548 0 .729-.227.122-.227.122-.5-.012-.774Zm-9.334-17.96c4.008 0 7.283 3.271 7.283 7.275 0 4.004-3.275 7.275-7.283 7.275-4.01 0-7.284-3.27-7.284-7.275 0-4.004 3.275-7.274 7.284-7.274Zm-3.14 19.776-.822-2.864a.708.708 0 0 0-.32-.407c-.135-.093-.362-.093-.502-.047l-2.593.774 1.684-2.863a9.13 9.13 0 0 0 4.644 2.002l-2.092 3.405Zm7.83-3.364c-.18-.047-.361-.047-.501.046-.134.094-.274.227-.32.408l-.822 2.863-1.998-3.45a8.953 8.953 0 0 0 4.69-1.91l1.637 2.817-2.686-.774Zm-6.648-4.906 6.234-6.227a.885.885 0 0 0 0-1.274.878.878 0 0 0-1.276 0L10.6 10.778 9.01 9.189a.887.887 0 0 0-1.277 0 .885.885 0 0 0 0 1.275l2.873 2.857Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineCharger = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineCharger",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M23.995 9.332C23.995 6.4 21.595 4 18.663 4s-5.331 2.4-5.331 5.332v8.888c0 1.91-1.78 3.556-3.777 3.556a3.567 3.567 0 0 1-3.556-3.556v-2.222c2.443-.447 4.223-2.577 4.223-5.111v-6H8.226v-3.55a.89.89 0 0 0-1.78 0v3.556h-2.67V1.337A.892.892 0 0 0 2.89.449a.896.896 0 0 0-.893.888v3.556H0v5.998c0 2.534 1.78 4.665 4.223 5.111v2.222c0 2.933 2.4 5.332 5.332 5.332 3.023 0 5.557-2.443 5.557-5.332V9.332a3.567 3.567 0 0 1 3.556-3.556 3.564 3.564 0 0 1 3.556 3.556v8.441c0 .49.404.888.888.888.49 0 .888-.403.888-.888l-.005-8.441ZM1.78 10.887V6.663h6.666v4.224c0 1.823-1.511 3.33-3.33 3.33-1.82 0-3.336-1.507-3.336-3.33Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineChat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineChat",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M19.637 1h-6.983C10.246 1 8.29 2.971 8.29 5.399v.44H4.364C1.955 5.838 0 7.808 0 10.236v4.399a4.406 4.406 0 0 0 3.492 4.314v3.171a.878.878 0 0 0 .871.879c.23 0 .453-.09.62-.26l3.67-3.7h2.693c2.408 0 4.364-1.97 4.364-4.398v-.074l3.312 3.34a.869.869 0 0 0 .95.192.878.878 0 0 0 .536-.811v-3.171A4.401 4.401 0 0 0 24 9.803V5.405C24 2.97 22.045 1 19.637 1ZM13.96 14.642c0 1.453-1.173 2.641-2.62 2.641H8.285a.85.85 0 0 0-.615.26l-2.435 2.455v-1.836a.876.876 0 0 0-.872-.879c-1.441 0-2.62-1.183-2.62-2.641v-4.4c0-1.452 1.173-2.64 2.62-2.64H8.29v2.201c0 2.428 1.956 4.4 4.364 4.4h1.307v.439Zm8.296-4.839c0 1.454-1.173 2.642-2.62 2.642a.876.876 0 0 0-.872.879v1.836l-2.435-2.456a.873.873 0 0 0-.615-.259H12.66c-1.441 0-2.62-1.183-2.62-2.642V5.405c0-1.454 1.173-2.642 2.62-2.642h6.983c1.442 0 2.62 1.183 2.62 2.642v4.398h-.005Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineCheck",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "m7.862 20.947-7.54-7.953c-.466-.466-.408-1.23.057-1.637.466-.466 1.23-.408 1.637.057l5.904 6.082L22.013 3.523a1.134 1.134 0 0 1 1.637 0 1.134 1.134 0 0 1 0 1.637L7.862 20.947Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineCheckout = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineCheckout",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M19.291 18.432c-.043 0-.086 0-.125.005-.019 0-.043-.005-.062-.005H7.858l-.759-2.966h13.719L24 2.774H3.854l-.158-.628A2.541 2.541 0 0 0 1.234.23h-.39a.846.846 0 0 0 0 1.69h.39c.384 0 .72.264.816.638l4.094 15.994a2.755 2.755 0 0 0-1.968 2.635c0 1.522 1.248 2.75 2.78 2.75 1.53 0 2.778-1.233 2.778-2.75 0-.374-.076-.734-.216-1.06h7.205a2.703 2.703 0 0 0-.216 1.06c0 1.522 1.248 2.75 2.78 2.75 1.54 0 2.779-1.228 2.779-2.75a2.766 2.766 0 0 0-2.775-2.755Zm2.535-13.968-2.328 9.317H6.668L4.285 4.464h17.54ZM7.733 21.922c-.207.206-.48.321-.773.321-.6 0-1.09-.475-1.09-1.056 0-.283.11-.542.312-.744a1.07 1.07 0 0 1 .773-.321c.6 0 1.09.475 1.09 1.056 0 .283-.106.547-.312.744Zm12.331 0a1.07 1.07 0 0 1-.773.321c-.6 0-1.09-.475-1.09-1.056 0-.283.111-.542.313-.744a1.07 1.07 0 0 1 .772-.321c.6 0 1.09.475 1.09 1.056a.994.994 0 0 1-.312.744Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineCircleCross = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineCircleCross",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M12 0C5.38 0 0 5.38 0 12s5.38 12 12 12 12-5.38 12-12S18.62 0 12 0Zm0 22.291C6.326 22.291 1.709 17.674 1.709 12S6.326 1.709 12 1.709 22.291 6.326 22.291 12 17.674 22.291 12 22.291ZM16.536 6.25a.866.866 0 0 1 1.214 0 .866.866 0 0 1 0 1.214L13.214 12l4.527 4.536a.866.866 0 0 1 0 1.214.86.86 0 0 1-.605.255.871.871 0 0 1-.605-.255l-4.536-4.536L7.46 17.75a.843.843 0 0 1-1.21 0 .866.866 0 0 1 0-1.214L10.787 12 6.25 7.464a.866.866 0 0 1 0-1.214.866.866 0 0 1 1.214 0L12 10.786l4.536-4.536Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineCircuits = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineCircuits",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M1.582 7.39c.632 0 1.171-.378 1.426-.922h7.233l2.55-2.599c.301.177.65.29 1.02.29 1.124 0 2.04-.934 2.04-2.08S14.935 0 13.811 0s-2.04.933-2.04 2.08c0 .26.052.501.133.726L9.673 5.08H3.008a1.577 1.577 0 0 0-1.426-.921C.707 4.159 0 4.878 0 5.77c0 .893.707 1.62 1.582 1.62Zm12.223-6.002c.377 0 .678.313.678.691a.69.69 0 0 1-.678.691.69.69 0 0 1-.678-.69.69.69 0 0 1 .678-.692Zm8.155 9.694c-.887 0-1.629.578-1.913 1.382H3.008a1.577 1.577 0 0 0-1.426-.922c-.875 0-1.582.72-1.582 1.613 0 .892.707 1.612 1.582 1.612.632 0 1.171-.378 1.426-.921h17.04c.283.803 1.025 1.382 1.912 1.382 1.124 0 2.04-.933 2.04-2.08a2.052 2.052 0 0 0-2.04-2.066Zm0 2.77a.686.686 0 0 1-.678-.691.69.69 0 0 1 .678-.691.69.69 0 0 1 .678.69.69.69 0 0 1-.678.692Zm0 5.995a2 2 0 0 0-.881.213l-4.057-3.904H6.63a1.577 1.577 0 0 0-1.425-.922c-.876 0-1.583.72-1.583 1.613 0 .892.707 1.612 1.583 1.612.631 0 1.17-.378 1.425-.921h9.847l3.64 3.503a2.124 2.124 0 0 0-.197.88c0 1.146.915 2.079 2.04 2.079 1.124 0 2.04-.933 2.04-2.08 0-1.145-.916-2.073-2.04-2.073Zm0 2.77a.686.686 0 0 1-.678-.69.69.69 0 0 1 .678-.692.69.69 0 0 1 .678.692.69.69 0 0 1-.678.69ZM14.657 8.773H6.63a1.577 1.577 0 0 0-1.425-.922c-.876 0-1.583.721-1.583 1.613s.707 1.613 1.583 1.613c.631 0 1.17-.379 1.425-.922h8.59l5.714-5.824c.301.177.65.29 1.02.29 1.124 0 2.04-.934 2.04-2.08S23.084.467 21.96.467c-1.125 0-2.04.933-2.04 2.079 0 .26.052.502.133.726l-5.396 5.5ZM21.96 1.85c.377 0 .678.313.678.691a.69.69 0 0 1-.678.691.69.69 0 0 1-.678-.691c0-.378.301-.691.678-.691Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineCleaning = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineCleaning",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M16.133 3.61h2.016V.024h-7.843a.744.744 0 0 0-.495.22l-2.913 3.36a.617.617 0 0 0-.092.716c.092.22.36.403.63.403h1.79v2.688H5.818v13.9A2.696 2.696 0 0 0 8.506 24h6.273a2.696 2.696 0 0 0 2.688-2.688V7.42h-3.36V4.958l.043-.09.941 1.569c.135.22.36.317.581.317.134 0 .22-.044.36-.092.317-.177.403-.58.22-.94l-1.209-2.016.091-.092c.01-.004.999-.004.999-.004Zm-.451 17.702a.9.9 0 0 1-.898.897H8.515a.9.9 0 0 1-.897-.897v-12.1h8.064v12.1ZM10.532 7.42V4.06a.69.69 0 0 0-.673-.672H8.87l1.748-2.016H16.8v.897h-2.016a.647.647 0 0 0-.538.27l-1.344 1.79a.71.71 0 0 0-.134.403V7.42h-2.237Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineClickAndCollect = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineClickAndCollect",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M20.314 4.718V6h3.427v15.427A2.576 2.576 0 0 1 21.168 24H10.032a2.576 2.576 0 0 1-2.573-2.573v-2.035L6.47 17.75l-1.56 1.56-1.737 1.738L.125 18l1.733-1.738 1.564-1.564-2.505-1.503a.635.635 0 0 1-.307-.643.63.63 0 0 1 .47-.533l6.384-1.665c-.005-.024-.005-.048-.005-.072V6h3.427V4.718A4.722 4.722 0 0 1 15.6.005h.014a4.722 4.722 0 0 1 4.7 4.713Zm-4.71-3a3.011 3.011 0 0 0-3.004 3V6h6V4.718a3.006 3.006 0 0 0-2.995-3ZM6.687 16.075a.643.643 0 0 0-.532.183l-2.146 2.145-.835.835L1.939 18l.835-.835 2.146-2.146a.633.633 0 0 0 .182-.533.632.632 0 0 0-.307-.47l-1.9-1.142 7.315-1.91-1.906 7.295H8.28l-1.128-1.881a.613.613 0 0 0-.466-.303Zm14.492 6.207c.47 0 .854-.384.854-.855V7.718H9.178v2.194l1.766-.46a.644.644 0 0 1 .782.782l-2.548 9.772v1.421c0 .47.384.855.854.855h11.146Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineClose = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineClose",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "m13.205 11.952 10.44-10.44A.886.886 0 0 0 22.392.259L11.952 10.7 1.512.26A.887.887 0 0 0 .259 1.512l10.44 10.44L.26 22.392a.887.887 0 0 0 .624 1.512.88.88 0 0 0 .624-.26l10.445-10.44 10.44 10.44a.88.88 0 0 0 1.248 0 .886.886 0 0 0 0-1.252l-10.435-10.44Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineCloudFriends = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineCloudFriends",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M3.398 11.045c.456.134.715.61.58 1.065a.847.847 0 0 1-.82.61.85.85 0 0 1-.24-.034A4.085 4.085 0 0 1 0 8.785a4.079 4.079 0 0 1 4.895-3.988 6.753 6.753 0 0 1 12.756-.49.86.86 0 0 1-.49 1.109.86.86 0 0 1-1.108-.49 5.011 5.011 0 0 0-4.699-3.215A5.04 5.04 0 0 0 6.48 5.497a4.12 4.12 0 0 1 1.065 1.162.863.863 0 0 1-.283 1.18.863.863 0 0 1-1.18-.283 2.357 2.357 0 0 0-4.367 1.229c0 1.041.695 1.967 1.684 2.26Zm18.884-.115a4.065 4.065 0 0 1-1.253 2.932c1.82.763 2.966 2.227 2.971 4.022v3.599a.858.858 0 1 1-1.718 0v-3.6c0-1.67-1.81-2.884-4.3-2.884-.825 0-1.579.13-2.25.384a.855.855 0 1 1-.61-1.598c.024-.01.048-.018.072-.026l.072-.027a4.05 4.05 0 0 1-1.123-2.802 4.078 4.078 0 0 1 4.07-4.07 4.075 4.075 0 0 1 4.069 4.07Zm-10.193 4.578a4.04 4.04 0 0 0 1.195-2.874 4.064 4.064 0 0 0-4.06-4.06 4.068 4.068 0 0 0-4.06 4.06c0 1.118.456 2.135 1.19 2.87-1.905.738-3.12 2.23-3.12 4.074v3.56a.858.858 0 1 0 1.719 0v-3.56c0-1.66 1.794-2.865 4.27-2.865 2.477 0 4.272 1.204 4.272 2.865v3.56a.858.858 0 1 0 1.718 0v-3.56c-.01-1.838-1.224-3.33-3.124-4.07Zm-2.87-5.221a2.347 2.347 0 1 1 0 4.694 2.347 2.347 0 0 1 0-4.694Zm8.993-1.713a2.357 2.357 0 0 1 0 4.712 2.357 2.357 0 0 1 0-4.712Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineCocktail = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineCocktail",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M23.71 1.887A1.128 1.128 0 0 0 22.878 0H2.125c-.445 0-.847.26-1.027.672-.18.405-.108.882.194 1.215l10.09 11.255v8.603H9.7c-.618 0-1.121.506-1.121 1.127 0 .622.503 1.128 1.12 1.128h5.609c.617 0 1.12-.506 1.12-1.128 0-.621-.503-1.127-1.12-1.127h-1.68v-8.603L23.71 1.887Zm-19.065.376h15.712l-7.856 8.761-7.856-8.761Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineComment = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineComment",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M19.637 0h-6.983C10.246 0 8.29 1.971 8.29 4.399v.44H4.364C1.955 4.838 0 6.808 0 9.236v4.399a4.406 4.406 0 0 0 3.492 4.314v3.171a.878.878 0 0 0 .871.879c.23 0 .453-.09.62-.26l3.67-3.7h2.693c2.408 0 4.364-1.97 4.364-4.398v-.074l3.312 3.34a.869.869 0 0 0 .95.192.878.878 0 0 0 .536-.811v-3.171A4.401 4.401 0 0 0 24 8.803V4.405C24 1.97 22.045 0 19.637 0ZM13.96 13.642c0 1.453-1.173 2.641-2.62 2.641H8.285a.85.85 0 0 0-.615.26l-2.435 2.455v-1.836a.876.876 0 0 0-.872-.879c-1.441 0-2.62-1.183-2.62-2.641v-4.4c0-1.452 1.173-2.64 2.62-2.64H8.29v2.201c0 2.428 1.956 4.4 4.364 4.4h1.307v.439Zm8.296-4.839c0 1.454-1.173 2.642-2.62 2.642a.876.876 0 0 0-.872.879v1.836l-2.435-2.456a.873.873 0 0 0-.615-.259H12.66c-1.441 0-2.62-1.183-2.62-2.642V4.405c0-1.454 1.173-2.642 2.62-2.642h6.983c1.442 0 2.62 1.183 2.62 2.642v4.398h-.005Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineComputer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineComputer",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M24 1H0v17.256h7.503l-1.031 3.667c-.088.26 0 .52.126.735.17.215.428.342.685.342h9.428a.887.887 0 0 0 .686-.342.757.757 0 0 0 .126-.735l-1.026-3.661h7.497V1H24Zm-1.717 1.728v10.785H1.717V2.728h20.566Zm-6.685 18.55H8.402l.812-3.021h5.572l.812 3.02ZM1.717 16.533V14.81h20.566v1.723H1.717Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineConferenceCall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineConferenceCall",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M3.698 10.438a.67.67 0 0 0 .74-.585c.096-.854.972-1.411 2.223-1.411 1.303 0 2.355.608 2.446 1.41.04.342.33.592.66.592.023 0 .051 0 .08-.006a.667.667 0 0 0 .586-.739c-.108-.944-.78-1.73-1.764-2.179.41-.466.655-1.08.655-1.746a2.672 2.672 0 0 0-2.668-2.668 2.672 2.672 0 0 0-2.668 2.668c0 .683.261 1.303.682 1.775-.876.443-1.456 1.2-1.564 2.15a.682.682 0 0 0 .592.74ZM6.66 4.443a1.332 1.332 0 0 1 .001 2.662A1.333 1.333 0 0 1 5.33 5.774c0-.734.597-1.331 1.331-1.331Zm7.48 5.995a.673.673 0 0 0 .74-.585c.097-.86.973-1.411 2.224-1.411 1.303 0 2.355.608 2.447 1.41.04.342.33.592.66.592.022 0 .05 0 .08-.006a.667.667 0 0 0 .585-.739c-.108-.944-.78-1.73-1.764-2.179.41-.466.655-1.08.655-1.746a2.668 2.668 0 0 0-5.336 0c0 .683.261 1.303.682 1.775-.876.443-1.456 1.2-1.564 2.15a.682.682 0 0 0 .592.74Zm1.633-4.664a1.332 1.332 0 1 1 1.332 1.331 1.333 1.333 0 0 1-1.332-1.331ZM8.675 18.186c.41-.466.654-1.08.654-1.746a2.672 2.672 0 0 0-2.668-2.668 2.672 2.672 0 0 0-2.668 2.668c0 .682.262 1.303.683 1.775-.876.444-1.456 1.2-1.564 2.15a.673.673 0 0 0 .586.74.67.67 0 0 0 .74-.586c.096-.854.972-1.411 2.223-1.411 1.303 0 2.355.608 2.446 1.41.04.342.33.592.66.592.023 0 .051 0 .08-.005a.667.667 0 0 0 .586-.74c-.103-.944-.774-1.73-1.758-2.179ZM6.661 15.11a1.332 1.332 0 0 1 .001 2.662A1.333 1.333 0 0 1 5.33 16.44c0-.734.597-1.331 1.331-1.331Zm12.458 3.077c.41-.466.654-1.08.654-1.746a2.668 2.668 0 0 0-5.336 0c0 .682.262 1.303.683 1.775-.876.444-1.456 1.2-1.564 2.15a.673.673 0 0 0 .586.74.673.673 0 0 0 .74-.586c.096-.854.972-1.411 2.223-1.411 1.303 0 2.355.608 2.447 1.41.04.342.33.592.66.592.022 0 .05 0 .08-.005a.667.667 0 0 0 .585-.74c-.102-.944-.774-1.73-1.758-2.179Zm-3.345-1.746a1.332 1.332 0 1 1 1.332 1.331 1.333 1.333 0 0 1-1.332-1.331ZM20.883 0H3.112A3.112 3.112 0 0 0 0 3.112v17.776A3.112 3.112 0 0 0 3.112 24h17.776A3.112 3.112 0 0 0 24 20.888V3.112A3.12 3.12 0 0 0 20.883 0Zm1.337 20.883c0 .733-.598 1.33-1.332 1.33H3.112a1.333 1.333 0 0 1-1.331-1.33V3.112c0-.734.597-1.331 1.33-1.331h17.777c.734 0 1.331.597 1.331 1.33v17.772Zm-1.11-8.886c0 .37-.296.666-.665.666h-7.782v7.776c0 .37-.296.666-.666.666a.663.663 0 0 1-.665-.666v-7.776H3.555a.663.663 0 0 1-.665-.666c0-.37.296-.665.665-.665h7.777V3.555c0-.37.295-.665.665-.665.37 0 .666.296.666.665v7.777h7.776c.37 0 .671.295.671.665Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineContactUs = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineContactUs",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M20.924 9.268h.97C23.03 9.268 24 8.342 24 7.291V6.87C24 3.207 20.967.136 17.305.006a6.95 6.95 0 0 0-5.135 1.94A6.553 6.553 0 0 0 10.15 6.7c0 .336.293.633.633.633a.645.645 0 0 0 .634-.633 5.25 5.25 0 0 1 1.641-3.83c1.138-1.094 2.654-1.641 4.209-1.598 2.99.087 5.47 2.61 5.47 5.6v.423c0 .38-.421.715-.839.715h-.46a4.556 4.556 0 0 0-4.425-5.605c-2.53 0-4.468 2.063-4.468 4.55 0 1.348.59 2.567 1.555 3.407-.293.086-.547.21-.802.292-.422.212-.633.672-.422 1.095.211.422.672.633 1.094.422.926-.423 1.939-.634 3.071-.634 3.201.044 5.265 1.723 5.265 4.718 0 .46.38.84.84.84.46 0 .84-.38.84-.84 0-2.86-1.599-4.967-4.003-5.85.394-.336.686-.715.94-1.138ZM17.046 4.09a2.864 2.864 0 0 1 2.86 2.86c0 .38-.086.716-.21 1.056H17.04a.649.649 0 0 0-.633.634c0 .336.293.633.633.633h1.642c-.461.336-1.008.509-1.642.509a2.864 2.864 0 0 1-2.86-2.86c0-1.598 1.31-2.832 2.865-2.832Zm-6.9 11.283c.925-.84 1.516-2.02 1.516-3.37a4.556 4.556 0 0 0-4.55-4.549c-2.529 0-4.501 2.064-4.501 4.55 0 1.348.59 2.524 1.516 3.369C1.598 16.174 0 17.94 0 20.297c0 .46.38.84.84.84.46 0 .84-.38.84-.84 0-2.146 2.231-3.662 5.47-3.662 3.24 0 5.471 1.516 5.471 3.662 0 .46.38.84.84.84.461 0 .84-.38.84-.84.01-2.357-1.588-4.123-4.156-4.924Zm-2.99-6.234a2.864 2.864 0 0 1 2.86 2.86 2.864 2.864 0 0 1-2.86 2.86 2.833 2.833 0 0 1-2.86-2.855c0-1.555 1.304-2.865 2.86-2.865Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineCreditCard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineCreditCard",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M2.578 4.051h18.84A2.59 2.59 0 0 1 24 6.624v10.709a2.58 2.58 0 0 1-2.573 2.573H2.577a2.58 2.58 0 0 1-2.572-2.573V6.624a2.58 2.58 0 0 1 2.573-2.573Zm18.85 1.71H2.577a.867.867 0 0 0-.864.863v1.7h20.568v-1.71a.856.856 0 0 0-.855-.854Zm-.01 12.426H2.578a.856.856 0 0 1-.855-.854V10.05h20.559v7.282a.865.865 0 0 1-.864.854Zm-17.986-6h5.563c.475 0 .855.39.855.855a.85.85 0 0 1-.855.854H3.432a.85.85 0 0 1-.854-.854.85.85 0 0 1 .854-.855Zm8.136 0h3.005a.855.855 0 0 1-.005 1.71h-3a.85.85 0 0 1-.854-.855.85.85 0 0 1 .854-.855Zm8.995 0h-3.427a.85.85 0 0 0-.854.855.85.85 0 0 0 .854.854h3.427a.85.85 0 0 0 .855-.854.856.856 0 0 0-.855-.855Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineCross = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineCross",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M12 0C5.38 0 0 5.38 0 12s5.38 12 12 12 12-5.38 12-12S18.62 0 12 0Zm0 22.291C6.326 22.291 1.709 17.674 1.709 12S6.326 1.709 12 1.709 22.291 6.326 22.291 12 17.674 22.291 12 22.291ZM16.536 6.25a.866.866 0 0 1 1.214 0 .866.866 0 0 1 0 1.214L13.214 12l4.527 4.536a.866.866 0 0 1 0 1.214.86.86 0 0 1-.605.255.871.871 0 0 1-.605-.255l-4.536-4.536L7.46 17.75a.843.843 0 0 1-1.21 0 .866.866 0 0 1 0-1.214L10.787 12 6.25 7.464a.866.866 0 0 1 0-1.214.866.866 0 0 1 1.214 0L12 10.786l4.536-4.536Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineCustomPlans = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineCustomPlans",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M15.46 14.26V.903a.856.856 0 0 0-.854-.854.856.856 0 0 0-.854.854v13.359c-1.238.384-2.136 1.493-2.136 2.86 0 1.369.898 2.478 2.136 2.862v3.115c0 .47.384.854.854.854s.855-.384.855-.854v-3.115c1.238-.384 2.136-1.493 2.136-2.861s-.898-2.477-2.136-2.861Zm-.849 4.143a1.26 1.26 0 0 1-1.281-1.281 1.26 1.26 0 0 1 1.281-1.282 1.26 1.26 0 0 1 1.282 1.282 1.26 1.26 0 0 1-1.282 1.281Zm-6.83-2.136H3.34c.086-.254.173-.556.173-.854V12.85h2.563c.47 0 .854-.384.854-.855a.856.856 0 0 0-.854-.854H3.509V8.837c0-.94.768-1.709 1.709-1.709.427 0 .81.13 1.065.384.341.34.855.34 1.195 0a.826.826 0 0 0 0-1.195c-.556-.557-1.368-.898-2.26-.898a3.423 3.423 0 0 0-3.413 3.413v2.304H.95A.87.87 0 0 0 .096 12c0 .47.384.854.854.854h.855v2.564c0 .47-.384.854-.855.854a.852.852 0 1 0 0 1.704h6.83a.856.856 0 0 0 .855-.854.856.856 0 0 0-.854-.855ZM24 8.587c0-1.368-.898-2.476-2.136-2.86V.901a.852.852 0 1 0-1.704 0v4.824c-1.238.385-2.136 1.493-2.136 2.861s.898 2.477 2.136 2.861v11.654c0 .47.384.855.854.855s.855-.384.855-.855V11.443C23.102 11.06 24 9.951 24 8.587Zm-2.986 1.277a1.26 1.26 0 0 1-1.281-1.282 1.26 1.26 0 0 1 1.281-1.281 1.26 1.26 0 0 1 1.282 1.281c-.005.73-.557 1.282-1.282 1.282Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineCyberSecurity = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineCyberSecurity",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M19.282 7.286v1.282c1.42 0 2.563 1.157 2.577 2.573v10.281a2.58 2.58 0 0 1-2.573 2.573H4.718a2.58 2.58 0 0 1-2.572-2.573V11.141a2.58 2.58 0 0 1 2.572-2.573V7.286A7.287 7.287 0 0 1 12 .005c4.018 0 7.282 3.269 7.282 7.281ZM12 1.723a5.57 5.57 0 0 0-5.563 5.563v1.282h11.126V7.286A5.57 5.57 0 0 0 12 1.723Zm8.136 19.695a.856.856 0 0 1-.854.854H4.718a.856.856 0 0 1-.854-.854V11.146c0-.476.389-.855.854-.855h14.568c.476 0 .855.39.855.855v10.272h-.005ZM5.405 16.056c.057-.154 1.497-3.845 6.595-3.845s6.538 3.691 6.595 3.845a.598.598 0 0 1 0 .447c-.057.153-1.497 3.844-6.595 3.844s-6.538-3.69-6.595-3.845a.598.598 0 0 1 0-.446Zm1.3.22c.37.711 1.753 2.79 5.295 2.79 3.523 0 4.925-2.088 5.294-2.79-.37-.71-1.752-2.788-5.294-2.788-3.538 0-4.925 2.088-5.294 2.789Zm2.933.006A2.366 2.366 0 0 1 12 13.92c1.3 0 2.362 1.06 2.362 2.362 0 1.3-1.061 2.361-2.362 2.361-1.3 0-2.362-1.06-2.362-2.361Zm1.292-.005c0 .595.48 1.07 1.07 1.07.59 0 1.07-.475 1.07-1.07 0-.595-.48-1.07-1.07-1.07-.595 0-1.07.475-1.07 1.07Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineDataRollover = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineDataRollover",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M22.534 10.546a.832.832 0 0 1 1.2 0c.345.34.345.854.053 1.195l-3.173 3.172-3.172-3.172a.832.832 0 0 1 0-1.2.833.833 0 0 1 1.2 0l1.07 1.07c-.216-4.756-4.157-8.61-9-8.61a8.992 8.992 0 0 0-8.999 8.994 9 9 0 0 0 9 9 .86.86 0 0 1 .859.858c0 .476-.389.86-.86.86C4.8 22.713 0 17.913 0 12 0 6.087 4.8 1.287 10.708 1.292c5.783 0 10.54 4.627 10.712 10.367l1.114-1.113ZM10.713 6.86c-2.827 0-5.14 2.313-5.14 5.14 0 2.827 2.313 5.14 5.14 5.14 2.827 0 5.14-2.313 5.14-5.14 0-2.827-2.313-5.14-5.14-5.14Zm0 8.567A3.435 3.435 0 0 1 7.286 12a3.435 3.435 0 0 1 3.427-3.427A3.435 3.435 0 0 1 14.14 12a3.438 3.438 0 0 1-3.427 3.427Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineDataBonus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineDataBonus",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M17.401 11.752c.24-.375.381-.824.381-1.314a2.42 2.42 0 0 0-2.446-2.446H12.89a.889.889 0 0 0-.887.888v6.229c0 .489.398.887.887.887h2.89a2.42 2.42 0 0 0 2.446-2.446c0-.71-.318-1.348-.825-1.798Zm-3.623-1.98h1.553c.392 0 .665.274.665.666 0 .393-.273.666-.665.666h-1.553V9.773Zm2.002 4.45h-2.002V12.89h1.905c.416 0 .757.302.757.666.006.387-.267.665-.66.665Zm-4.665-2.225a3.958 3.958 0 0 1-3.999 4c-2.326 0-4.22-1.793-4.22-4a3.958 3.958 0 0 1 3.999-3.999c.625 0 1.814.103 2.69.808a.892.892 0 0 1 .137 1.251.892.892 0 0 1-1.252.137c-.324-.262-.916-.415-1.575-.415-1.269 0-2.225.955-2.225 2.224 0 1.223 1.098 2.224 2.446 2.224.95 0 1.718-.535 2.048-1.331H7.56a.889.889 0 0 1 0-1.775h2.668a.872.872 0 0 1 .887.876Zm10-6.667c0 .37-.295.666-.665.666h-1.109v1.109c0 .37-.296.666-.666.666a.663.663 0 0 1-.665-.666v-1.11H16.9a.663.663 0 0 1-.665-.665c0-.37.296-.665.666-.665h1.109v-1.11c0-.37.296-.665.665-.665.37 0 .666.296.666.665v1.11h1.11c.363 0 .665.295.665.665ZM21.339 0H2.668A2.672 2.672 0 0 0 0 2.668v18.664A2.672 2.672 0 0 0 2.668 24h18.664A2.672 2.672 0 0 0 24 21.332V2.662A2.666 2.666 0 0 0 21.338 0Zm.887 21.332c0 .49-.398.887-.887.887H2.668a.889.889 0 0 1-.887-.887V2.662c0-.489.398-.887.887-.887h18.664c.49 0 .887.398.887.887v18.67h.006Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineData = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineData",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M23 24h-5.742V0H23v24Zm-3.826-1.88h1.91V1.88h-1.91v20.24ZM14.871 24H9.129V8h5.742v16Zm-3.826-1.88h1.91V9.88h-1.91v12.24ZM6.742 24H1v-9.175h5.742V24Zm-3.826-1.88h1.91v-5.41h-1.91v5.41Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineDataCentre = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineDataCentre",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M20.378 0H8.128v3H5.064v3.001H2V24h14.878V8.574c0-1.415-1.182-2.573-2.628-2.573H6.812V4.718h10.502c.482 0 .874.384.874.855v14.57c0 .472.392.856.874.856a.866.866 0 0 0 .874-.855V5.573C19.936 4.157 18.754 3 17.309 3H9.876V1.717h10.502c.482 0 .874.384.874.856v14.57c0 .472.392.856.874.856a.866.866 0 0 0 .874-.856V2.573C23.006 1.157 21.824 0 20.378 0ZM15.13 16.715H3.753v-3.857H15.13v3.857ZM3.753 22.288v-4.284H15.13v4.284H3.753ZM15.13 8.574v3H3.753V7.719h10.503c.482 0 .874.384.874.856Zm-9.41 1.717h2.408c.347 0 .655-.302.655-.642s-.308-.641-.655-.641H5.719c-.347 0-.655.301-.655.641s.308.642.655.642Zm0 5.14h2.408c.347 0 .655-.301.655-.641s-.308-.642-.655-.642H5.719c-.347 0-.655.301-.655.642 0 .34.308.641.655.641Zm0 5.14h2.408c.347 0 .655-.301.655-.641s-.308-.642-.655-.642H5.719c-.347 0-.655.302-.655.642s.308.641.655.641Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineDelivery = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineDelivery",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "m24 12.72-8.218-8.218h-3.355v-.427A3.863 3.863 0 0 0 8.568.216H.859a.865.865 0 0 0-.859.86c0 .47.384.858.86.858h7.713c1.18 0 2.14.96 2.14 2.141v15.428H.86a.858.858 0 1 0 0 1.718h13.08a3.863 3.863 0 0 0 3.634 2.573 3.858 3.858 0 0 0 3.633-2.573H24v-8.5Zm-6.427 9.355a2.143 2.143 0 0 1-2.141-2.14c0-1.181.96-2.141 2.14-2.141 1.182 0 2.142.96 2.142 2.14 0 1.181-.96 2.141-2.141 2.141Zm3.83-2.572h.883v-6.068l-7.214-7.214h-2.64v13.282h1.31a3.86 3.86 0 0 1 3.83-3.428 3.864 3.864 0 0 1 3.831 3.428ZM.86 14.789h6.86a.858.858 0 1 0 0-1.719H.858a.858.858 0 1 0 0 1.719Zm3-4.287h-3A.854.854 0 0 1 0 9.649c0-.475.384-.86.86-.864h3a.858.858 0 1 1 0 1.718Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineDevice = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineDevice",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M8.14 0h7.72a4.29 4.29 0 0 1 4.28 4.286v15.428A4.294 4.294 0 0 1 15.855 24H8.141a4.294 4.294 0 0 1-4.287-4.286V4.286A4.294 4.294 0 0 1 8.141 0ZM5.574 5.573v12.859h12.859V5.572H5.572Zm2.568-3.86h7.713c1.272 0 2.328.927 2.535 2.141H5.606a2.578 2.578 0 0 1 2.535-2.14Zm0 20.573h7.718a2.57 2.57 0 0 0 2.53-2.14H5.606a2.574 2.574 0 0 0 2.535 2.14Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineDevices = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineDevices",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M21.438 0h-5.962C14.07 0 12.92 1.157 12.92 2.572V3H3.556C2.15 3 1 4.157 1 5.572v15.856C1 22.843 2.15 24 3.556 24h11.925c1.406 0 2.556-1.157 2.556-2.572v-4.284h3.407c1.406 0 2.556-1.157 2.556-2.572v-12C23.994 1.157 22.845 0 21.438 0Zm-6.812 4.289h7.663v8.567h-7.663V4.289Zm.85-2.572h5.962c.47 0 .85.384.85.855V3h-7.662v-.428c0-.471.381-.855.85-.855Zm-11.92 3h9.37V6H2.7v-.428c0-.428.426-.855.856-.855Zm11.92 17.566H3.556c-.425 0-.85-.427-.85-.855V21H16.33v.428c-.005.428-.43.855-.855.855Zm.85-2.572H2.7V7.29h10.22v7.283c0 1.415 1.15 2.572 2.556 2.572h.85v2.567Zm5.112-4.283h-5.962a.854.854 0 0 1-.85-.856v-.428h7.663v.428a.854.854 0 0 1-.85.856Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineDigitalBox = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineDigitalBox",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M23.994 12.485v-.012c0-.023-.006-.041-.012-.065a.798.798 0 0 0-.03-.172l-.035-.089c-.017-.047-.041-.088-.065-.136-.017-.03-.041-.053-.059-.083-.03-.035-.059-.07-.094-.107a.444.444 0 0 0-.083-.065c-.018-.011-.035-.035-.059-.047l-.065-.03c-.018-.011-.03-.023-.047-.03L16.06 8.41a.94.94 0 0 0-.738 0l-7.384 3.24c-.018.007-.03.024-.047.03-.024.012-.048.018-.065.03-.024.012-.036.03-.06.047-.029.024-.058.042-.082.071-.035.036-.065.072-.095.107a.71.71 0 0 0-.124.22c-.011.029-.03.059-.035.088-.018.054-.024.113-.03.166 0 .024-.011.048-.011.071v7.894a.93.93 0 0 0 .508.829l7.383 3.703a.63.63 0 0 0 .113.042c.023.006.047.017.07.023.077.018.154.03.23.03.078 0 .154-.012.231-.03.024-.006.047-.017.071-.023.036-.012.077-.024.112-.042l7.384-3.703a.924.924 0 0 0 .508-.83v-7.875c-.006-.006-.006-.006-.006-.012ZM15.69 10.27l5.21 2.287-5.21 2.608-5.21-2.614 5.21-2.281Zm-6.462 3.727 5.54 2.78v5.794l-5.54-2.779v-5.795Zm12.924 5.801-5.54 2.773v-5.8l5.54-2.78v5.807ZM7.047 8.794A2.806 2.806 0 0 0 4.613 7.4a2.779 2.779 0 0 0-2.77 2.78 2.774 2.774 0 0 0 2.77 2.778.924.924 0 0 1 0 1.849C2.067 14.808 0 12.734 0 10.18s2.067-4.628 4.613-4.628c.266 0 .526.03.786.077C6.374 2.33 9.433 0 12.919 0a7.865 7.865 0 0 1 7.56 5.772.922.922 0 1 1-1.778.492 6.023 6.023 0 0 0-5.782-4.415 6.013 6.013 0 0 0-5.79 4.45 4.56 4.56 0 0 1 1.513 1.564.931.931 0 0 1-.337 1.268.917.917 0 0 1-1.258-.337Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineDigitalServices = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineDigitalServices",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M10.666 1.713a5.556 5.556 0 0 1 5.567 5.567c0 .475.389.86.859.86a.861.861 0 0 0 .859-.86A7.28 7.28 0 0 0 10.666 0 7.277 7.277 0 0 0 3.38 7.28c0 .475.389.86.859.86s.859-.39.859-.86a5.553 5.553 0 0 1 5.567-5.567Zm-3 5.567c0-1.67 1.33-3 3-3s3 1.33 3 3c0 .475.388.86.858.86s.86-.39.86-.86a4.7 4.7 0 0 0-4.713-4.713A4.707 4.707 0 0 0 5.953 7.28a.857.857 0 1 0 1.713 0Zm9.94 4.42a2.42 2.42 0 0 1 .772-.13c1.2 0 2.14.941 2.155 2.146v4.07c0 .945-.384 2.485-1.714 2.999v2.356a.86.86 0 0 1-.859.859.861.861 0 0 1-.859-.859v-3a.86.86 0 0 1 .86-.858c.858 0 .858-1.503.858-1.503v-4.07a.406.406 0 0 0-.427-.426c-.254 0-.427.168-.427.427v.427c0 .47-.384.859-.859.859a.861.861 0 0 1-.859-.859v-1.286c0-.255-.168-.427-.427-.427-.254 0-.427.168-.427.427v.427c0 .47-.389.859-.86.859a.861.861 0 0 1-.858-.86v-1.712a.406.406 0 0 0-.427-.427c-.255 0-.427.168-.427.427v.854c0 .47-.39.859-.86.859a.861.861 0 0 1-.858-.86V7.28c0-.254-.168-.427-.428-.427-.254 0-.427.168-.427.427v8.557c0 .47-.384.859-.859.859a.861.861 0 0 1-.859-.86v.26c0 2.37 2.69 4.891 2.9 5.09l.013.011a.762.762 0 0 1 .303.643v1.287c0 .47-.384.859-.86.859a.861.861 0 0 1-.858-.86v-.902c-.86-.81-3.216-3.378-3.216-6.08v-.34c0-1.2.686-2.141 1.713-2.444V7.28c0-1.2.941-2.14 2.14-2.14 1.2 0 2.141.94 2.141 2.14v2.19c.125-.044.298-.044.427-.044.903 0 1.675.557 2.016 1.373a2.12 2.12 0 0 1 .557-.087 2.11 2.11 0 0 1 1.8.99Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineDisabled = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineDisabled",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "m21.971 19.89-1.274-4.73c-.289-1.08-1.394-1.929-2.522-1.929h-3.18l-1.857-6.753a3.562 3.562 0 0 0 1.53-2.925C14.668 1.597 13.094 0 11.155 0 9.216 0 7.642 1.592 7.642 3.553c0 1.041.447 1.977 1.16 2.627a2.587 2.587 0 0 0-.838 1.895v4.302c0 1.4 1.17 2.584 2.554 2.584h5.435c.06.352.093.716.093 1.074 0 3.443-2.767 6.24-6.17 6.24-3.405 0-6.171-2.797-6.171-6.24 0-2.209 1.116-4.209 2.99-5.349a.862.862 0 0 0 .288-1.179.841.841 0 0 0-1.165-.291C3.427 10.67 2 13.22 2 16.04 2 20.43 5.53 24 9.87 24s7.87-3.57 7.87-7.96a8.74 8.74 0 0 0-.071-1.074h.495c.365 0 .79.32.883.656l1.274 4.732a.85.85 0 0 0 .823.633.877.877 0 0 0 .828-1.096ZM11.15 1.725c.996 0 1.808.82 1.808 1.829a1.822 1.822 0 0 1-1.814 1.829 1.827 1.827 0 0 1-1.802-1.83c0-1.013.811-1.828 1.808-1.828Zm-.638 11.507c-.43 0-.85-.424-.85-.86V8.07c0-.435.42-.86.85-.86h1.057l1.656 6.027h-2.713v-.006Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineDisturb = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineDisturb",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "m23.75 22.536-3.32-3.321a11.286 11.286 0 0 0 3.143-7.857 11.29 11.29 0 0 0-3.321-8.034A11.298 11.298 0 0 0 12.217.002c-2.937 0-5.76 1.133-7.866 3.134L1.466.252A.857.857 0 1 0 .252 1.466L17.914 19.13A9.592 9.592 0 0 1 12.212 21c-1.492 0-2.932-.307-4.156-.888a.863.863 0 0 0-.59-.052L2.07 21.504l1.45-5.423a.85.85 0 0 0-.053-.586c-.59-1.248-.893-2.64-.893-4.132 0-1.474.293-2.846.869-4.085a.854.854 0 0 0-.413-1.137.854.854 0 0 0-1.138.413C1.207 8.022.862 9.64.862 11.363c0 1.636.311 3.172.921 4.574L.031 22.493a.858.858 0 0 0 .221.826.858.858 0 0 0 .825.22l6.537-1.747c1.388.605 2.971.922 4.598.922a11.29 11.29 0 0 0 6.936-2.352l3.388 3.388a.854.854 0 0 0 1.21 0 .862.862 0 0 0 .004-1.214ZM12.217 1.716c5.318 0 9.642 4.324 9.642 9.642a9.587 9.587 0 0 1-2.654 6.633L5.565 4.351a9.696 9.696 0 0 1 6.652-2.635Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineDocument = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineDocument",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M3 6.514 9.514 0H21v24H3V6.514ZM9 6V2.914L5.914 6H9Zm10.286 16.286H4.714V7.714h6v-6h8.572v20.572Zm-12-9a.858.858 0 1 0 .001 1.719h9.427c.47 0 .859-.384.859-.86a.858.858 0 0 0-.86-.859H7.287Zm9.428 4.287H7.286a.861.861 0 0 0-.859.859c0 .47.384.86.86.86h9.427c.47 0 .859-.385.859-.86a.861.861 0 0 0-.86-.86Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineDown",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M.047 6.431c0-.216.087-.427.26-.6a.833.833 0 0 1 1.2 0l10.54 10.546L22.588 5.83a.833.833 0 0 1 1.2 0 .832.832 0 0 1 0 1.2l-11.14 11.141a.833.833 0 0 1-1.2 0L.306 7.032a.834.834 0 0 1-.26-.6Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineDownload = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineDownload",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "m4.97 13.459 7.023 7.022 7.028-7.023c.556-.556.729-1.453.427-2.225-.298-.73-.94-1.157-1.67-1.157h-2.571V.866a.858.858 0 1 0-1.718 0v10.923h4.284s.044 0 .087.086c.043.125.043.298-.043.384l-5.824 5.824-5.824-5.824c-.086-.081-.086-.254-.043-.384.043-.086.086-.086.086-.086h4.284V.866A.86.86 0 0 0 8.78.861v9.21H6.207c-.729 0-1.367.428-1.669 1.157-.297.772-.125 1.674.432 2.23ZM0 21.422a2.578 2.578 0 0 0 2.571 2.57h18.843A2.6 2.6 0 0 0 24 21.423V12a.858.858 0 1 0-1.717 0v9.422a.86.86 0 0 1-.86.858H2.577a.86.86 0 0 1-.859-.858V12A.858.858 0 1 0 0 12v9.422Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineEShop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineEShop",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M15.79 0H8.21C5.887 0 4 1.92 4 4.285v15.43C4 22.08 5.887 24 8.21 24h7.58c2.323 0 4.21-1.92 4.21-4.285V4.29C20 1.926 18.113 0 15.79 0ZM5.682 18.436V5.575h12.636v12.861H5.682ZM8.21 1.717h7.58c1.25 0 2.286.928 2.49 2.146H5.72c.205-1.218 1.24-2.146 2.49-2.146Zm7.58 20.577H8.21c-1.25 0-2.285-.928-2.49-2.146h12.56c-.204 1.218-1.24 2.146-2.49 2.146Zm-.647-12.22-.884-1.98a.625.625 0 0 0-.836-.319.645.645 0 0 0-.313.85l.647 1.45h-3.514l.646-1.45a.645.645 0 0 0-.312-.85.625.625 0 0 0-.836.318l-.884 1.981h-2.28l1.229 5.514c.167.626.82 1.13 1.455 1.13h5.478c.63 0 1.283-.51 1.46-1.162l1.224-5.482h-2.28Zm-.167 5.174c-.022.072-.167.187-.238.187H9.261a.458.458 0 0 1-.231-.16l-.874-3.912h7.682l-.862 3.885Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineEdit = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineEdit",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M22.666 1.335a4.551 4.551 0 0 0-6.427 0l-.869.869-13.16 13.16a.853.853 0 0 0-.274.438L.03 22.91a.868.868 0 0 0 1.066 1.06l7.027-1.886a.873.873 0 0 0 .465-.24L21.192 9.24l.614-.614.87-.869a4.545 4.545 0 0 0-.01-6.422ZM2.094 21.907l1.123-4.205 3.077 3.077-4.2 1.128ZM7.974 20 4 16.027l11.99-11.99 3.973 3.975-11.99 11.99ZM21.442 6.533l-.255.255-3.974-3.975.255-.254a2.816 2.816 0 0 1 3.974 0 2.816 2.816 0 0 1 0 3.974Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineEmail = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineEmail",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "m11.044 0-8.76 8.874L15.24 22 24 13.126 11.044 0Zm9.139 11.796-6.17-1.678-1.657-6.25 7.827 7.928ZM4.779 8.874l5.937-6.015 2.115 7.98c.063.23.238.413.47.476l7.877 2.143-5.938 6.015L4.78 8.874Zm6.265 10.52a.89.89 0 0 1-.882.893H3.534a.89.89 0 0 1-.882-.894.89.89 0 0 1 .882-.893h6.628a.89.89 0 0 1 .882.893ZM5.74 16.705H.882A.89.89 0 0 1 0 15.813a.89.89 0 0 1 .882-.894H5.74a.89.89 0 0 1 .882.893.89.89 0 0 1-.882.894Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineEnvelope = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineEnvelope",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M23.112 4H.888A.883.883 0 0 0 0 4.875v14.25c0 .482.398.875.888.875h22.224c.49 0 .888-.393.888-.875V4.875A.883.883 0 0 0 23.112 4Zm-2.537 1.751L12 10.656 3.425 5.75h17.15Zm-18.8 12.498V6.834l9.775 5.595a.89.89 0 0 0 .888 0l9.787-5.595v11.41H1.775v.005Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineEscalator = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineEscalator",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M20.57 6.076h-3.857c-.625 0-1.174.247-1.679.752L12.428 9.41v-.126c0-.8-.384-1.508-.999-1.975.489-.565.78-1.294.78-2.095A3.22 3.22 0 0 0 8.992 2a3.22 3.22 0 0 0-3.215 3.215c0 .795.296 1.525.779 2.09a2.478 2.478 0 0 0-.993 1.98v6.934l-.137.138H3.429c-.894 0-1.8.373-2.414.998C.362 18.002 0 18.836 0 19.709 0 21.49 1.57 23 3.43 23h3.857c.548 0 .987-.143 1.415-.472l9.657-9.809h2.212c.943 0 1.827-.345 2.42-.938.652-.647 1.009-1.48 1.009-2.353.006-1.816-1.57-3.352-3.43-3.352ZM9 3.717a1.5 1.5 0 0 1 1.498 1.498c0 .823-.675 1.497-1.504 1.497A1.499 1.499 0 0 1 9 3.717ZM7.287 9.291c0-.554.554-.856 1.07-.856h1.262c.537 0 1.097.318 1.097.856v1.827l-3.43 3.406V9.291Zm14.49 1.278c-.268.269-.729.439-1.2.439h-2.93L7.62 21.2a.516.516 0 0 1-.34.093H3.43c-.927 0-1.712-.724-1.712-1.58 0-.406.181-.817.51-1.141a1.76 1.76 0 0 1 1.202-.494h2.71L16.248 8.045c.236-.235.367-.252.472-.252h3.857c.91 0 1.712.763 1.712 1.635 0 .4-.186.817-.51 1.141Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineEyeClosed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineEyeClosed",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "m23.738 22.536-4.626-4.626c2.059-1.33 3.686-3.259 4.756-5.572a.941.941 0 0 0 0-.686C21.77 6.982 17.139 3.94 12 3.94c-1.93 0-3.859.427-5.572 1.243L1.46.259a.832.832 0 0 0-1.2 0 .832.832 0 0 0 0 1.2L7.503 8.7a5.521 5.521 0 0 0-1.07 3.302 5.56 5.56 0 0 0 5.571 5.572 5.532 5.532 0 0 0 3.302-1.07l.984.983c-1.33.557-2.783.86-4.286.86a11.326 11.326 0 0 1-10.154-6.34c.6-1.286 1.459-2.4 2.529-3.34a.832.832 0 0 0 .043-1.2.832.832 0 0 0-1.2-.043C1.892 8.58.866 10.039.136 11.666a.94.94 0 0 0 0 .686C2.23 17.012 6.903 20.055 12 20.055c1.972 0 3.858-.427 5.571-1.243l4.972 4.972c.173.13.384.216.6.216a.843.843 0 0 0 .6-.26.834.834 0 0 0-.005-1.204ZM12 15.856a3.843 3.843 0 0 1-3.859-3.859c0-.772.216-1.458.6-2.058l5.313 5.312a3.69 3.69 0 0 1-2.054.605Zm3.258-1.8L9.941 8.74c.6-.384 1.286-.6 2.059-.6a3.843 3.843 0 0 1 3.858 3.858c0 .773-.216 1.46-.6 2.06Zm1.243 1.243a5.521 5.521 0 0 0 1.07-3.302A5.56 5.56 0 0 0 12 6.426a5.532 5.532 0 0 0-3.302 1.07l-.984-.984c1.373-.557 2.784-.859 4.286-.859 4.328 0 8.268 2.486 10.154 6.34-.94 1.972-2.442 3.556-4.242 4.67l-1.41-1.364Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineEyeOpen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineEyeOpen",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M24 12.173v-.433c0-.019 0-.03-.003-.039a.172.172 0 0 0-.04-.048v-.043C21.725 6.763 17.26 3.845 11.98 3.845S2.236 6.763.047 11.655v.043c0 .018 0 .028-.003.038a.172.172 0 0 1-.04.048v.518c0 .043 0 .043.043.087v.043C2.236 17.242 6.7 20.16 11.98 20.16s9.744-2.919 11.933-7.815v-.043c0-.043 0-.043.043-.086 0 0 0-.043.043-.043Zm-12.02 6.264c-4.463 0-8.24-2.405-10.214-6.437 1.973-4.037 5.75-6.437 10.215-6.437 4.464 0 8.242 2.4 10.214 6.437-1.973 4.037-5.75 6.437-10.214 6.437Zm0-12.02A5.572 5.572 0 0 0 6.399 12a5.572 5.572 0 0 0 5.583 5.582A5.572 5.572 0 0 0 17.563 12a5.572 5.572 0 0 0-5.582-5.582Zm0 9.447A3.85 3.85 0 0 1 8.118 12a3.85 3.85 0 0 1 3.864-3.864A3.85 3.85 0 0 1 15.845 12a3.85 3.85 0 0 1-3.864 3.864Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineFAQ = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineFAQ",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M.87 24a.855.855 0 0 1-.608-.26.834.834 0 0 1-.221-.83l1.833-6.678A11.455 11.455 0 0 1 .87 11.563C.87 5.192 6.062 0 12.434 0s11.564 5.192 11.564 11.563c0 6.372-5.192 11.564-11.564 11.564-1.617 0-3.186-.35-4.668-.96l-6.68 1.79C1.045 24 .958 24 .872 24ZM12.43 1.747c-5.413 0-9.817 4.409-9.817 9.816 0 1.483.307 2.88.96 4.19.086.172.086.392.042.608L2.09 21.909l5.493-1.487c.221-.044.437-.044.61.043 1.31.61 2.75.96 4.189.96 5.455-.044 9.86-4.448 9.86-9.86 0-5.413-4.405-9.818-9.813-9.818Zm-.567 13.482a.876.876 0 0 1-.873-.873 5.02 5.02 0 0 1 1.483-3.58l1.175-1.175c.437-.437.35-1.396 0-1.876s-.96-.787-1.526-.787h-.22c-.61 0-1.176.35-1.483.873-.259.437-.787.566-1.175.307-.437-.259-.567-.787-.308-1.175.61-1.09 1.79-1.747 3.009-1.747h.22c1.138 0 2.227.523 2.923 1.44.83 1.089.96 3.051-.13 4.145l-1.175 1.176c-.61.61-.96 1.44-.96 2.356-.087.523-.48.916-.96.916Zm.83 1.66a.873.873 0 1 1-1.746 0 .873.873 0 0 1 1.746 0Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineFamilyOnSamePlan = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineFamilyOnSamePlan",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M22 6.854c0-2.341-1.806-4.266-4.102-4.48A4.283 4.283 0 0 0 14.043 0H6.301C3.927 0 2 1.92 2 4.282v15.436C2 22.08 3.927 24 6.3 24h7.743c2.373 0 4.3-1.92 4.3-4.282v-8.45C20.426 10.868 22 9.042 22 6.854ZM6.3 1.716h7.743c.77 0 1.47.34 1.95.9a4.562 4.562 0 0 0-1.879 1.25c-.027 0-.049-.011-.077-.011H3.757A2.582 2.582 0 0 1 6.3 1.716Zm7.743 20.562H6.301a2.582 2.582 0 0 1-2.544-2.144h12.83a2.582 2.582 0 0 1-2.544 2.144ZM3.718 18.424V5.57h9.438a4.492 4.492 0 0 0-.192 1.283c0 2.188 1.575 4.014 3.662 4.414v7.15H3.718v.006Zm13.767-8.357a3.225 3.225 0 0 1-3.227-3.213 3.225 3.225 0 0 1 3.227-3.213 3.225 3.225 0 0 1 3.227 3.213 3.225 3.225 0 0 1-3.227 3.213Zm2.791-3.213a.64.64 0 0 1-.644.642H18.13v1.496a.64.64 0 0 1-.644.642.64.64 0 0 1-.645-.642V7.501h-1.503a.64.64 0 0 1-.644-.642.64.64 0 0 1 .644-.641h1.503V4.721a.64.64 0 0 1 .645-.641.64.64 0 0 1 .644.641v1.497h1.503a.636.636 0 0 1 .644.636Zm-7.88 7.14a3.21 3.21 0 0 0 .997-2.32 3.225 3.225 0 0 0-3.227-3.213 3.225 3.225 0 0 0-3.227 3.213c0 .915.391 1.743 1.008 2.325-1.404.559-2.302 1.666-2.302 3.026a.64.64 0 0 0 .645.642.64.64 0 0 0 .644-.642c0-1.239 1.355-2.144 3.227-2.144 1.9 0 3.227.883 3.227 2.144a.64.64 0 0 0 .644.642.64.64 0 0 0 .644-.642c.011-1.381-.864-2.478-2.28-3.032Zm-2.224-.39a1.937 1.937 0 0 1-1.939-1.93c0-1.064.87-1.93 1.939-1.93 1.068 0 1.938.866 1.938 1.93a1.94 1.94 0 0 1-1.938 1.93Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineFamily = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineFamily",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M12.826 9.769c.894-.66 2.288-1.04 3.836-1.04 2.48 0 4.418 1.045 4.929 2.66a.86.86 0 0 0 .817.603.88.88 0 0 0 .818-1.145c-.488-1.547-1.778-2.732-3.518-3.357a4.39 4.39 0 0 0 1.306-3.128c0-2.407-1.92-4.362-4.286-4.362-2.365 0-4.286 1.955-4.286 4.362a4.4 4.4 0 0 0 1.24 3.066c-.702.23-1.334.537-1.86.922a.878.878 0 0 0-.187 1.218.829.829 0 0 0 1.19.2Zm3.891-8.02c1.416 0 2.574 1.172 2.574 2.619 0 1.446-1.152 2.62-2.574 2.62-1.421 0-2.574-1.174-2.574-2.62 0-1.447 1.158-2.62 2.574-2.62Zm-4.94 10.907a.878.878 0 0 0-.186-1.217 6.427 6.427 0 0 0-1.734-.905 4.397 4.397 0 0 0 1.284-3.111c0-2.407-1.92-4.362-4.286-4.362-2.366 0-4.287 1.955-4.287 4.362 0 1.212.489 2.307 1.274 3.1C1.509 11.327 0 13.086 0 15.287v7.328c0 .48.384.871.856.871a.865.865 0 0 0 .856-.871v-7.328c0-2.028 2.152-3.502 5.11-3.502 1.504 0 2.837.38 3.76 1.061a.844.844 0 0 0 1.196-.19ZM6.856 4.803c1.416 0 2.574 1.173 2.574 2.62 0 1.446-1.153 2.62-2.574 2.62-1.416 0-2.574-1.174-2.574-2.62 0-1.447 1.158-2.62 2.574-2.62Zm8.15 12.003c0 .765-.264 1.475-.703 2.033 1.24.587 1.987 1.642 1.987 2.983v1.307c0 .48-.384.871-.856.871a.865.865 0 0 1-.856-.871v-1.307c0-1.285-1.488-1.743-2.766-1.743-1.296 0-2.81.453-2.81 1.743v1.307c0 .48-.385.871-.857.871a.865.865 0 0 1-.856-.871v-1.307c0-1.335.747-2.39 1.993-2.977a3.262 3.262 0 0 1-.708-2.039c0-1.804 1.443-3.273 3.216-3.273 1.772 0 3.216 1.47 3.216 3.273Zm-1.718-.005c0-.838-.67-1.525-1.498-1.525-.83 0-1.499.687-1.499 1.525 0 .837.67 1.524 1.499 1.524.823 0 1.498-.687 1.498-1.524Zm8.501.1a3.29 3.29 0 0 0 .72-2.06c0-1.805-1.444-3.274-3.217-3.274-1.773 0-3.216 1.47-3.216 3.273 0 .81.29 1.547.768 2.117a4.863 4.863 0 0 0-.39.226l-.021.014-.33.23a.88.88 0 0 0-.214 1.211.846.846 0 0 0 1.191.218l.308-.218a3.489 3.489 0 0 1 1.898-.53c1.685 0 3.003.86 3.003 1.965 0 .48.384.872.856.872s.856-.391.856-.872c.01-1.379-.862-2.535-2.212-3.172Zm-3.995-2.06c0-.844.675-1.526 1.498-1.526s1.498.687 1.498 1.525c0 .838-.67 1.525-1.498 1.525a1.51 1.51 0 0 1-1.498-1.525Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineFastForward = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineFastForward",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M12 24C5.386 24 0 18.62 0 12S5.386 0 12 0s12 5.386 12 12-5.386 12-12 12Zm0-22.283C6.33 1.717 1.717 6.329 1.717 12c0 5.67 4.612 10.283 10.283 10.283 5.67 0 10.283-4.612 10.283-10.283 0-5.67-4.612-10.283-10.283-10.283ZM7.037 18.176l5.566-5.573a.857.857 0 0 0 0-1.212L7.037 5.824a.857.857 0 0 0-1.213 1.213L10.788 12l-4.964 4.963a.857.857 0 0 0 0 1.212.855.855 0 0 0 1.212 0Zm7.283 0 5.572-5.573a.857.857 0 0 0 0-1.212L14.32 5.824a.857.857 0 0 0-1.212 1.213L18.07 12l-4.963 4.963a.857.857 0 0 0 1.212 1.212Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineFavourite = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineFavourite",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M12 24c-.24 0-.465-.1-.628-.273-1.755-1.884-4.684-5.034-7.086-8.338C1.409 11.425.01 8.256.01 5.7c0-1.72.58-3.188 1.678-4.228C2.68.522 4.037 0 5.498 0c2.494 0 4.273 1.002 6.497 3.75 1.055-1.32 1.932-2.182 2.786-2.748C15.82.312 16.904 0 18.295 0c1.472 0 2.852.518 3.897 1.453 1.175 1.054 1.793 2.521 1.793 4.247 0 2.647-1.514 5.97-4.626 10.155-.005.01-.014.019-.02.028l-3.149 3.893c-.005.01-.014.015-.02.024a143.297 143.297 0 0 1-3.547 3.922A.85.85 0 0 1 12 24ZM5.499 1.716c-1.88 0-3.778 1.232-3.778 3.984 0 2.148 1.328 5.073 3.955 8.683 2.071 2.852 4.579 5.619 6.324 7.498.815-.882 1.84-2.004 2.872-3.188l3.13-3.87c2.838-3.82 4.277-6.889 4.277-9.118 0-2.737-2.062-3.984-3.975-3.984-1.836 0-3.082.57-5.614 3.95a.863.863 0 0 1-.685.346.863.863 0 0 1-.686-.345C8.817 2.325 7.397 1.716 5.5 1.716Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineFemale = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineFemale",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "m18.974 17.364-2.158-8.545a4.387 4.387 0 0 0-2.019-2.83 3.404 3.404 0 0 0 1.17-2.561C15.967 1.536 14.414 0 12.501 0c-1.914 0-3.467 1.536-3.467 3.428 0 1.02.455 1.93 1.17 2.561a4.332 4.332 0 0 0-2.013 2.803l-2.169 8.566v.017a.42.42 0 0 0-.01.087.476.476 0 0 0-.012.088v.017c0 .022.006.038.006.06a.477.477 0 0 0 .033.17.379.379 0 0 0 .028.082c.01.028.022.05.038.077.011.022.023.05.04.071.016.022.032.044.05.066a.574.574 0 0 0 .055.066c.016.017.038.033.055.055.022.016.044.038.067.055.022.016.044.027.072.044.022.016.05.027.072.038l.089.033c.016.005.038.016.055.022h.017a.432.432 0 0 0 .083.01.563.563 0 0 0 .094.012H9.04V24h6.933v-5.572h1.952a.617.617 0 0 0 .1-.011.697.697 0 0 0 .327-.016.857.857 0 0 0 .622-1.037ZM12.5 1.717c.954 0 1.73.767 1.73 1.71 0 .944-.776 1.712-1.741 1.712-.954-.006-1.725-.773-1.725-1.711A1.732 1.732 0 0 1 12.5 1.717Zm1.73 14.994v5.572h-3.466v-5.572h-2.79l1.902-7.535c.272-1.262 1.326-2.107 2.618-2.107 1.293 0 2.347.845 2.624 2.134l1.897 7.503H14.23v.005Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineFiberQuality = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineFiberQuality",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "m21.912 19.572-2.57-4.345a9.131 9.131 0 0 0 2.161-5.928c0-5.137-4.26-9.299-9.53-9.299C6.706 0 2.44 4.157 2.44 9.299c0 2.236.789 4.29 2.139 5.895l-2.496 4.383a.632.632 0 0 0 .062.72c.17.205.448.288.71.216l3.778-1.107 1.151 4.112a.67.67 0 0 0 1.22.15l2.967-5.076 2.973 5.087c.119.2.34.316.573.316.028 0 .057 0 .09-.006a.651.651 0 0 0 .551-.47L17.31 19.4l3.835 1.107a.673.673 0 0 0 .709-.221c.17-.2.193-.487.057-.714Zm-13.27 2.081-.902-3.227a.662.662 0 0 0-.318-.398.696.696 0 0 0-.516-.056l-2.865.842 1.503-2.64a9.578 9.578 0 0 0 4.913 2.319l-1.815 3.16Zm3.33-19.92c-4.26 0-7.755 3.404-7.755 7.566s3.489 7.566 7.755 7.566c4.26 0 7.755-3.404 7.755-7.566 0-4.157-3.489-7.567-7.755-7.567Zm5.066 16.24a.681.681 0 0 0-.51.055.647.647 0 0 0-.318.398l-.919 3.277-1.94-3.194a9.594 9.594 0 0 0 5.026-2.319l1.549 2.618-2.888-.836ZM14.633 6.575V10.6c.857 0 1.549.675 1.554 1.51v1.728c0 .36-.295.647-.663.647a.653.653 0 0 1-.664-.647V12.11a.219.219 0 0 0-.221-.216H9.317a.219.219 0 0 0-.221.216v1.721c0 .36-.295.648-.664.648a.653.653 0 0 1-.664-.648v-1.727c0-.83.692-1.51 1.55-1.51v-.992a1.727 1.727 0 0 1-1.107-1.6c0-.951.794-1.726 1.77-1.726s1.77.775 1.77 1.727c0 .725-.46 1.345-1.106 1.6v.99h2.66V6.576a1.727 1.727 0 0 1-1.106-1.6c0-.952.794-1.727 1.77-1.727s1.77.775 1.77 1.727c0 .725-.46 1.345-1.106 1.6Zm-.221-1.6a.438.438 0 0 0-.443-.432.434.434 0 0 0-.442.432c0 .238.198.432.442.432a.438.438 0 0 0 .443-.432ZM9.975 7.572c.244 0 .443.194.443.432a.438.438 0 0 1-.443.431.438.438 0 0 1-.442-.431c0-.238.198-.432.442-.432Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineFiberNetwork = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineFiberNetwork",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M22.06 5.21a1.948 1.948 0 0 0-1.742 2.794l-5.738 5.798-1.665-1.683 8.32-8.409c.253.122.534.195.83.195A1.948 1.948 0 0 0 24 1.95 1.943 1.943 0 0 0 22.06.006a1.948 1.948 0 0 0-1.742 2.793l-8.315 8.404-1.665-1.683 5.743-5.804a1.9 1.9 0 0 0 .83.194 1.948 1.948 0 0 0 1.934-1.955A1.948 1.948 0 0 0 16.911 0a1.948 1.948 0 0 0-1.743 2.794L9.425 8.598 9.25 8.42a1.638 1.638 0 0 0-2.336 0L0 15.435 9.222 24l6.43-6.754c.643-.65.643-1.71 0-2.36l-.16-.162 5.744-5.804c.252.122.533.195.83.195A1.948 1.948 0 0 0 24 7.159c0-1.077-.874-1.95-1.94-1.95Zm0-3.905c.357 0 .643.295.643.65 0 .356-.286.65-.643.65a.65.65 0 0 1 0-1.3Zm-5.15 0c.358 0 .643.295.643.65 0 .356-.285.65-.643.65a.647.647 0 0 1-.643-.65c0-.355.286-.65.643-.65ZM9.145 21.573 2.479 15.38l5.605-5.688 6.304 6.377-5.243 5.504ZM22.06 7.815a.65.65 0 0 1 0-1.3.65.65 0 0 1 0 1.3Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineFile = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineFile",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M23.995 22.663H0V4c0-1.468 1.2-2.668 2.668-2.668H6.8c.71 0 1.378.269 1.867.801l2.088 2.093a.879.879 0 0 0 .623.268h9.954C22.8 4.494 24 5.694 24 7.163v15.5h-.005Zm-22.22-1.775H22.22V7.115a.889.889 0 0 0-.888-.888h-9.91c-.71 0-1.378-.269-1.867-.802L7.467 3.338a.878.878 0 0 0-.624-.269H2.668a.893.893 0 0 0-.892.888v16.93Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineFilter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineFilter",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M11.995 24c-1.444 0-2.625-1.195-2.625-2.669V16L1.605 1.309a.89.89 0 0 1 .022-.877.871.871 0 0 1 .75-.432h19.248c.308 0 .593.165.75.432a.904.904 0 0 1 .023.877L14.62 16v5.331c0 1.474-1.181 2.669-2.626 2.669ZM3.838 1.775l7.178 13.582c.067.13.106.273.106.421v5.56c0 .488.392.887.873.887a.882.882 0 0 0 .874-.888v-5.559c0-.148.033-.29.106-.421l7.178-13.582H3.837Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineFindAStore = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineFindAStore",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M23.99 3.356c0-.021-.006-.038-.006-.06a.904.904 0 0 0-.054-.208c0-.006-.005-.006-.005-.011a.73.73 0 0 0-.108-.176c-.006-.005-.011-.016-.016-.022L21.694.307A.834.834 0 0 0 21.047 0H4.212a.851.851 0 0 0-.647.307L1.458 2.88c-.006.006-.011.017-.016.022a.95.95 0 0 0-.108.176c0 .005-.006.005-.006.01a.843.843 0 0 0-.054.21c-.005.021-.005.038-.005.06 0 .027-.005.049-.005.076v4.711H3.79v3.756a4.51 4.51 0 0 0-1.681 3.527c0 1.009.334 1.936.889 2.687L.186 20.973a.65.65 0 0 0 0 .91.622.622 0 0 0 .447.187.62.62 0 0 0 .448-.187l2.71-2.759V24h18.102V8.144H24v-4.71c-.005-.028-.01-.05-.01-.078ZM4.604 1.716h16.054l.9 1.07H3.699l.906-1.07ZM8.21 22.284H5.473v-2.49a4.287 4.287 0 0 0 2.732-.208v2.698h.005Zm-1.687-3.641c-1.74 0-3.158-1.443-3.158-3.214 0-1.772 1.418-3.214 3.158-3.214 1.741 0 3.158 1.442 3.158 3.214 0 1.771-1.417 3.214-3.158 3.214Zm9.684 3.641H9.471v-3.51a4.526 4.526 0 0 0 1.471-3.345 4.535 4.535 0 0 0-1.47-3.346v-.724h6.736v10.925Zm4 0h-2.738V10.07H8.21v1.196a4.307 4.307 0 0 0-2.732-.208V8.133h14.734v14.15h-.006ZM2.944 6.428V4.069h19.368v2.359H2.945Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineFirewall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineFirewall",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M20.703 15.53h-.126v-5.177H10.29c-.044 0-.088 0-.214.044-.384.127-.642.778-.686.861.044-.386.044-.861.044-1.336 0-3.753-3.599-6.596-3.774-6.729a.843.843 0 0 0-.944-.088.92.92 0 0 0-.472.817s.088 1.507-.384 3.621c-.17.778-.812 1.595-1.497 2.418-1.114 1.507-2.442 3.19-2.36 5.608.127 4.013 3.303 5.432 3.43 5.476.34.127.685.044.943-.171a.866.866 0 0 0 .17-.95s-.516-1.208-.088-3.146c.088-.386.17-.734.302-1.038.044.171.088.342.126.52.17.777.516 1.29.812 1.766.214.342.428.645.516 1.037.17.69.044 1.64-.044 1.943-.044.26 0 .563.17.779.17.17.302.215.516.215H24v-6.47h-3.297Zm-1.416 0h-6.512c-.087-1.766-.598-3.063-1.113-3.88h7.63v3.88h-.005ZM6 12.816a.886.886 0 0 0-.642-.734h-.214a.888.888 0 0 0-.686.342c-.043.044-1.113 1.55-1.673 3.969a6.585 6.585 0 0 0-.214 1.722c-.428-.602-.812-1.468-.856-2.633-.087-1.81.988-3.147 2.014-4.444.773-.993 1.541-1.943 1.8-3.102.17-.778.3-1.507.383-2.114.856.993 1.8 2.456 1.8 4.052 0 1.981-.34 3.19-.34 3.19a.894.894 0 0 0 .213.861c.214.216.56.304.856.216.088-.045 1.032-.304 1.674-.95.087-.088.17-.215.257-.304.34.69.642 1.723.642 3.064 0 2.418-1.887 3.494-3.127 3.969 0-.43 0-.905-.126-1.38-.126-.646-.428-1.12-.73-1.551-.257-.43-.471-.779-.598-1.253A114.04 114.04 0 0 1 6 12.815Zm4.246 7.888c1.202-.817 2.228-2.07 2.442-3.88h2.743v3.88h-5.185Zm12.47 0H16.72v-3.88h6.002v3.88h-.006Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineFixInternetConnection = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineFixInternetConnection",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M6.905 13.828c3.806 0 6.905-3.103 6.905-6.914C13.81 3.103 10.71 0 6.905 0 3.099 0 0 3.103 0 6.914c0 3.811 3.099 6.914 6.905 6.914Zm.867-6.046h1.044c-.116 1.67-.558 2.949-1.044 3.662V7.782Zm0-1.73V2.388c.492.72.928 1.992 1.044 3.662H7.772Zm-1.729 0H5c.116-1.671.558-2.949 1.044-3.663v3.662Zm0 1.73v3.662C5.552 10.725 5.115 9.453 5 7.782h1.044Zm3.784 3.413c.387-.957.64-2.118.724-3.418h1.463a5.211 5.211 0 0 1-2.187 3.418Zm2.182-5.144h-1.464c-.077-1.3-.331-2.461-.723-3.418a5.197 5.197 0 0 1 2.187 3.418Zm-8.02-3.413c-.387.957-.642 2.119-.724 3.419H1.806a5.184 5.184 0 0 1 2.182-3.419ZM1.805 7.782H3.27c.077 1.3.332 2.462.724 3.419a5.197 5.197 0 0 1-2.188-3.419Zm21.87 1.339-.376-.885-2.64 2.644a.215.215 0 0 1-.299.005l-.63-.591a.226.226 0 0 1-.066-.155c0-.033.006-.1.06-.155l2.658-2.66-.884-.377a4.09 4.09 0 0 0-4.502.88 4.113 4.113 0 0 0-1.143 3.59l-4.425 4.43a4.1 4.1 0 0 0-3.585 1.145 4.1 4.1 0 0 0-.878 4.508l.375.885 2.64-2.644a.215.215 0 0 1 .299-.006l.63.592a.225.225 0 0 1 .066.155c0 .033-.006.1-.06.155l-2.658 2.66.884.377a4.096 4.096 0 0 0 4.502-.88 4.107 4.107 0 0 0 1.143-3.584l4.425-4.43a4.115 4.115 0 0 0 4.463-5.658Zm-1.796 3.59a2.8 2.8 0 0 1-2.706.724l-.365-.1-5.447 5.46.1.365a2.812 2.812 0 0 1-.724 2.71c-.552.554-1.298.858-2.044.825l1.15-1.15a1.51 1.51 0 0 0-.033-2.168l-.63-.593a1.499 1.499 0 0 0-2.105.028L7.943 19.94a2.806 2.806 0 0 1 3.53-2.771l.365.1 5.452-5.46-.1-.365a2.812 2.812 0 0 1 .724-2.71 2.755 2.755 0 0 1 2.044-.824l-1.15 1.15a1.51 1.51 0 0 0 .033 2.168l.63.592a1.504 1.504 0 0 0 2.105-.027l1.133-1.134a2.855 2.855 0 0 1-.829 2.052Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineFixedInternet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineFixedInternet",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M12 0 1 6.479V24h22V6.479L12 0Zm9.164 22.132H2.836V7.557L12 2.156l9.164 5.4v14.576ZM12 6.455c-3.79 0-6.876 3.15-6.876 7.018S8.21 20.491 12 20.491c2.857 0 5.31-1.784 6.342-4.317a7.11 7.11 0 0 0 .54-2.719c0-3.856-3.075-6.994-6.853-6.994h-.017c-.006 0-.006-.006-.012-.006Zm3.55 6.318c-.077-1.683-.423-3.15-.969-4.252a5.602 5.602 0 0 1 2.87 4.252h-1.902Zm-4.236 5.886c-.663-.689-1.303-2.264-1.42-4.48h1.42v4.48Zm-1.426-5.886c.111-2.24.757-3.833 1.42-4.527v4.527h-1.42Zm-.399-4.27c-.546 1.102-.898 2.58-.974 4.27H6.597a5.61 5.61 0 0 1 2.892-4.27Zm-.974 5.677c.076 1.67.434 3.131.974 4.227a5.609 5.609 0 0 1-2.886-4.227h1.912Zm4.171 4.533v-4.54h1.485c-.123 2.288-.798 3.887-1.485 4.54Zm0-5.94V8.192c.687.658 1.373 2.275 1.485 4.58h-1.485Zm1.89 5.628c.54-1.09.897-2.557.973-4.227h1.907a5.647 5.647 0 0 1-.375 1.449 5.595 5.595 0 0 1-2.505 2.778Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineFood = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineFood",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M12.617 1.284v6.429c0 1.415-1.107 2.562-2.469 2.573v12.858c0 .472-.37.856-.826.856-.456 0-.827-.384-.827-.856V10.286h-.01C7.118 10.286 6 9.134 6 7.713v-6.43c0-.471.37-.855.826-.855.456 0 .827.384.827.856v6.429c0 .472.37.856.826.856h.011V1.284c0-.472.37-.856.827-.856.455 0 .826.384.826.856v7.285c.45-.006.816-.39.816-.856v-6.43c0-.471.37-.855.826-.855.456 0 .832.384.832.856ZM18 .856v22.283c0 .471-.37.855-.826.855-.456 0-.827-.384-.827-.855V12.853h-1.653c-.456 0-.827-.384-.827-.856V3.43c0-1.894 1.484-3.43 3.313-3.43.45-.005.821.379.821.856Zm-1.658 1.086a1.73 1.73 0 0 0-.827 1.487v7.713h.827v-9.2Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineFootball = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineFootball",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M12 0C5.386 0 0 5.386 0 12s5.386 12 12 12 12-5.386 12-12S18.614 0 12 0Zm9.872 14.868-.67-1.491 1.076-1.108a10.38 10.38 0 0 1-.406 2.6Zm.307-4.338-1.93 1.991-2.715-.428-2.424-4.738 1.113-2.189 2.896-.576a10.281 10.281 0 0 1 3.06 5.94ZM4.75 19.283l.33-3.087 2.479-1.267 4.716 2.396.236 2.863-1.799 2.013a10.259 10.259 0 0 1-5.961-2.918Zm-2.456-3.888 1.502.73-.192 1.798a10.439 10.439 0 0 1-1.31-2.528Zm11.111 5.72 1.607.719c-.84.257-1.722.405-2.638.438l1.031-1.157Zm-.642-4.99-4.497-2.282.779-4.98 4.98-.795 2.292 4.486-3.554 3.57Zm2.699-13.81a10.05 10.05 0 0 1 2.369 1.217l-1.552.313-.817-1.53Zm-1.7-.445 1.382 2.578-1.18 2.325-5.254.845-1.875-1.87.373-2.836a10.243 10.243 0 0 1 4.798-1.19 9.761 9.761 0 0 1 1.755.148ZM5.786 3.812l-.214 1.65-1.82.4a10.6 10.6 0 0 1 2.034-2.05ZM2.814 7.393l3.153-.696 1.837 1.831-.822 5.254-2.463 1.262-2.643-1.284A10.304 10.304 0 0 1 1.722 12c-.005-1.656.39-3.22 1.092-4.607ZM16.662 21.16l-2.88-1.283-.224-2.726 3.778-3.79 2.638.417 1.25 2.77a10.367 10.367 0 0 1-4.562 4.612Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineFriendsCustomersPeople = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineFriendsCustomersPeople",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M7.59 9.874c.41.274.53.834.268 1.26a.878.878 0 0 1-1.23.28c-.523-.344-1.268-.531-2.099-.531-1.621 0-2.754.747-2.754 1.82v6.375a.9.9 0 0 1-.887.91.9.9 0 0 1-.888-.91v-6.381c0-1.341.762-2.444 1.991-3.074a3.467 3.467 0 0 1-.79-2.205C1.2 5.534 2.697 4 4.535 4s3.334 1.534 3.334 3.418A3.46 3.46 0 0 1 7.101 9.6c.17.087.336.175.49.274Zm-1.502-2.45c0-.875-.694-1.592-1.553-1.592-.86 0-1.553.717-1.553 1.592 0 .875.694 1.592 1.553 1.592.853 0 1.553-.717 1.553-1.592Zm9.246 1.633a3.44 3.44 0 0 1-.74 2.141c1.389.636 2.294 1.767 2.294 3.091v4.795a.9.9 0 0 1-.888.91.9.9 0 0 1-.888-.91V14.29c0-.986-1.422-1.815-3.112-1.815-1.69 0-3.112.829-3.112 1.815v4.794a.9.9 0 0 1-.888.91.9.9 0 0 1-.888-.91V14.29c0-1.325.91-2.456 2.293-3.092a3.46 3.46 0 0 1-.74-2.14c0-1.885 1.497-3.419 3.335-3.419 1.838 0 3.334 1.534 3.334 3.418ZM12 7.465c-.854 0-1.553.711-1.553 1.592 0 .881.694 1.598 1.553 1.593.854 0 1.553-.718 1.553-1.593S12.86 7.465 12 7.465Zm10.009 2.17c.495-.595.79-1.365.79-2.205 0-1.884-1.496-3.418-3.334-3.418s-3.334 1.534-3.334 3.418c0 .828.29 1.586.768 2.181-.17.082-.336.17-.49.275a.922.922 0 0 0-.267 1.26.872.872 0 0 0 1.23.274c.523-.345 1.268-.531 2.099-.531 1.622 0 2.754.752 2.754 1.82v6.381a.9.9 0 0 0 .887.91.9.9 0 0 0 .888-.91v-6.387c0-1.336-.762-2.438-1.991-3.068Zm-2.544-3.803c.86 0 1.553.717 1.553 1.592 0 .875-.7 1.592-1.553 1.592s-1.553-.717-1.553-1.592c0-.875.7-1.592 1.553-1.592Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineGift = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineGift",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M19.498 7.245h-.21a4.53 4.53 0 0 0 .89-2.719C20.179 1.988 18.184 0 15.635 0c-1.973 0-3.608 1.188-4.248 2.904-.6-.4-1.327-.638-2.112-.638-1.944 0-3.41 1.46-3.41 3.396 0 .58.134 1.119.372 1.583H4.502C3.1 7.245 2 8.439 2 9.963v13.133c0 .498.407.904.908.904h18.184c.5 0 .908-.406.908-.904V9.957c0-1.518-1.1-2.712-2.502-2.712Zm.68 2.712v1.356h-7.273V9.047h6.593c.5.006.68.55.68.91Zm-4.544-8.149c1.554 0 2.73 1.171 2.73 2.718 0 1.548-1.17 2.719-2.73 2.719h-2.73V4.526c0-1.547 1.176-2.718 2.73-2.718ZM7.679 5.657c0-.934.652-1.583 1.589-1.583.873 0 1.816.609 1.816 1.583v1.582H9.268c-.937.006-1.589-.65-1.589-1.582ZM4.496 9.053h6.593v2.266H3.816V9.963c0-.365.18-.91.68-.91Zm-.68 4.074h7.273v9.053H3.816v-9.053Zm9.089 9.059v-9.059h7.274v9.053h-7.274v.006Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineGreaterFlexibility = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineGreaterFlexibility",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M23.194 23.802a.808.808 0 0 1-.514-.172c-.043-.044-.514-.384-2.189-2.016-.172-.173-.383-.384-.6-.643-1.2 1.286-2.615 1.972-4.074 1.972-1.546 0-2.919-.73-4.119-1.973-1.2 1.244-2.577 1.973-3.906 1.973-1.632 0-3.135-.773-4.378-2.102a23.46 23.46 0 0 1-2.016 1.886c-.384.302-.902.26-1.2-.13-.302-.383-.259-.902.13-1.2.514-.426 1.286-1.074 2.06-1.929-1.2-1.886-1.93-4.463-1.93-7.252.043-3.177.945-6.868 3.388-6.868 2.405 0 3.346 3.69 3.389 6.868.043 2.961-1.243 5.452-2.66 7.339.946 1.032 2.06 1.675 3.265 1.675.988 0 1.972-.6 2.831-1.632C9.3 17.409 8.44 14.36 8.44 10.93v-.86c.044-2.318.346-9.872 3.389-9.872 3.043 0 3.345 7.554 3.389 9.872v.86c0 3.56-.99 6.566-2.405 8.668.86 1.032 1.93 1.632 3.005 1.632 1.113 0 2.188-.643 3.09-1.719-1.286-2.145-2.49-5.409-2.447-9.186 0-1.33.259-7.982 3.388-7.982 3.091 0 3.346 6.652 3.346 7.982v.6c0 3.134-.73 6.095-2.016 8.327-.087.13-.13.216-.216.346.259.345.47.6.686.816 1.589 1.545 2.016 1.843 2.016 1.886.384.302.427.816.173 1.2a.834.834 0 0 1-.643.302ZM3.837 7.066c-.73 0-1.632 2.188-1.675 5.15 0 2.232.513 4.248 1.372 5.836 1.114-1.588 2.016-3.561 1.973-5.836-.082-2.962-.94-5.15-1.67-5.15Zm7.981-5.15c-.556.086-1.631 3.048-1.675 8.154v.86c0 2.702.6 5.193 1.589 7.08 1.032-1.93 1.761-4.508 1.761-7.08v-.86c-.043-5.106-1.113-8.068-1.675-8.154Zm8.03 2.145c-.643 0-1.632 2.534-1.675 6.307-.043 3.005.816 5.664 1.805 7.555.945-1.843 1.545-4.334 1.545-6.998v-.557c-.09-3.777-1.075-6.307-1.675-6.307Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineGreen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineGreen",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M12.34.065a1.06 1.06 0 0 0-.729 0c-.259.13-6.906 3.302-6.906 11.495 0 6.777 4.631 9.051 6.436 9.652v1.929c0 .475.389.859.859.859.475 0 .86-.389.86-.86v-1.928a8.547 8.547 0 0 0 2.874-1.59c1.627-1.285 3.561-3.733 3.561-8.062C19.29 3.367 12.638.194 12.341.065Zm.514 19.303V6.843a.861.861 0 0 0-.859-.86c-.47 0-.859.39-.859.86V19.37c-1.675-.687-4.718-2.66-4.718-7.805.005-6.133 4.296-9.013 5.582-9.738 1.286.73 5.577 3.648 5.577 9.738-.005 5.145-3.048 7.118-4.723 7.805Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineGuarantee = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineGuarantee",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M22 7.496a4.909 4.909 0 0 0-4.156-4.864A4.238 4.238 0 0 0 13.917 0H6.254C3.906 0 2 1.92 2 4.282v15.436C2 22.08 3.906 24 6.254 24h7.658c2.347 0 4.254-1.92 4.254-4.282v-3.071l.67.675a.848.848 0 0 0 .925.186.855.855 0 0 0 .523-.79v-5.494A4.902 4.902 0 0 0 22 7.496ZM6.254 1.71h7.658a2.52 2.52 0 0 1 2.02 1.003 4.843 4.843 0 0 0-2.118 1.14H3.737C3.944 2.636 4.996 1.71 6.254 1.71Zm7.658 9.513v5.483c0 .346.207.658.523.79.316.131.686.06.926-.186l1.1-1.108v2.22H3.705V5.566h8.9a4.94 4.94 0 0 0-.387 1.93 4.901 4.901 0 0 0 1.694 3.73Zm.005 11.049H6.254c-1.264 0-2.31-.927-2.517-2.144h12.691a2.557 2.557 0 0 1-2.51 2.144Zm4.673-7.638-.882-.894a.847.847 0 0 0-1.204 0l-.887.894v-2.451a4.786 4.786 0 0 0 2.973 0v2.45Zm-1.486-3.926c-1.76 0-3.192-1.442-3.192-3.213 0-1.772 1.432-3.214 3.191-3.214 1.76 0 3.192 1.442 3.192 3.214 0 1.77-1.432 3.213-3.192 3.213Zm0-5.357a2.14 2.14 0 0 0-2.13 2.144c0 1.184.953 2.143 2.13 2.143a2.14 2.14 0 0 0 2.13-2.143 2.143 2.143 0 0 0-2.13-2.144Zm0 2.999a.854.854 0 0 1-.85-.855c0-.472.381-.856.85-.856.468 0 .85.384.85.856a.854.854 0 0 1-.85.855Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineGuru = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineGuru",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M16.239 14.777C18.492 13.36 20 10.857 20 8c0-4.41-3.59-8-8-8S4 3.59 4 8c0 2.856 1.508 5.36 3.761 6.777C3.181 16.017 0 19.237 0 23.112a.889.889 0 0 0 1.775 0C1.775 19.192 6.361 16 12 16c5.639 0 10.225 3.192 10.225 7.112a.889.889 0 0 0 1.775 0c0-3.874-3.18-7.095-7.761-8.335ZM12 1.775a6.228 6.228 0 0 1 5.616 3.556h-3.613c-.603 0-1.138.37-1.394.888h-1.212c-.256-.518-.791-.888-1.394-.888H6.39A6.213 6.213 0 0 1 12 1.775Zm2.003 4.888h2.447v1.11c0 .574-.313.887-.888.887h-1.115c-.28 0-.666 0-.666-.888v-.887c-.006-.103.114-.222.222-.222Zm-6.447 0h2.441c.103 0 .222.12.222.222v.887c0 .888-.387.888-.666.888h-1.11c-.574 0-.887-.319-.887-.888v-1.11ZM5.776 8c0-.46.05-.905.147-1.331h.296v1.11c0 1.308.916 2.224 2.225 2.224h1.11c1.251 0 2.002-.83 2.002-2.225v-.222h.888v.222c0 1.394.745 2.225 2.003 2.225h1.11c1.308 0 2.224-.916 2.224-2.225v-1.11h.296c.096.433.148.877.148 1.332A6.234 6.234 0 0 1 12 14.225 6.234 6.234 0 0 1 5.775 8Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineHDOption = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineHDOption",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M19.33 11.5c0-2.102-1.718-3.683-4-3.683h-2.667v7.366h2.668c2.28 0 3.999-1.581 3.999-3.683ZM14 9.115h1.33c1.549 0 2.67 1.005 2.67 2.385 0 1.381-1.121 2.385-2.668 2.385H14v-4.77Zm-8.892 5.419V8.466c0-.36.296-.649.666-.649.37 0 .665.289.665.65v2.384h3.556V8.466c0-.36.296-.649.665-.649.37 0 .666.289.666.65v6.067c0 .36-.296.649-.666.649a.655.655 0 0 1-.665-.65V12.15H6.439v2.385c0 .36-.295.649-.665.649a.655.655 0 0 1-.666-.65ZM0 5v13h24V5H0Zm22.22 11.264H1.774V6.736H22.22v9.528Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineHandsFree = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineHandsFree",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "m23.026 22.54-3.087-3.086c1.2-1.075 1.373-3 1.373-3.13v-5.226a2.58 2.58 0 0 0-2.573-2.573c-.389 0-.773.086-1.075.259-.427-.902-1.33-1.54-2.357-1.54-.389 0-.73.086-1.027.215-.389-.989-1.33-1.713-2.443-1.713-.303 0-.557.043-.816.13V2.572C11.02 1.157 9.864 0 8.405 0c-1.416 0-2.53 1.157-2.53 2.573v2.87L2.03 1.541a.832.832 0 0 0-1.2 0 .833.833 0 0 0 0 1.2l16.455 16.54v3.855c0 .475.389.86.859.86.475 0 .86-.39.86-.86v-2.227l2.826 2.827a.85.85 0 0 0 .6.26.85.85 0 0 0 .6-.26.823.823 0 0 0-.004-1.195ZM7.642 2.574c0-.475.388-.86.859-.86.475 0 .859.39.859.86v5.74c0 .476.389.86.86.86a.861.861 0 0 0 .858-.86c0-.47.39-.815.86-.815a.86.86 0 0 1 .859.859V9.86c0 .475.389.86.859.86.475 0 .86-.39.86-.86v-.086c0-.475.426-.773.858-.773.476 0 .86.389.86.86v1.286a.86.86 0 0 0 .859.859.862.862 0 0 0 .859-.86c0-.475.389-.859.86-.859.47 0 .858.39.858.86v5.102l-.013.076c-.062.35-.26 1.47-.889 1.94L7.642 7.157V2.573Zm-2.146 11.14v.428c0 3.216 3.73 6.6 3.773 6.638l.302.26v2.102c0 .47-.384.859-.859.859a.861.861 0 0 1-.86-.86v-1.329c-.983-.989-4.07-4.243-4.07-7.67v-.427c0-1.628 1.373-3 3-3 .47 0 .86.384.86.859v2.573c0 .47-.39.859-.86.859a.861.861 0 0 1-.859-.86v-1.372c-.254.254-.427.6-.427.94Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineHandsetInsurance = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineHandsetInsurance",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M22.138 3.857c-1.487 0-2.682-.91-2.864-1.053A4.315 4.315 0 0 0 15.227 0h-6.91C5.935 0 4 1.92 4 4.285v15.43C4 22.08 5.935 24 8.317 24h6.91c2.383 0 4.318-1.92 4.318-4.285v-6.272C21.303 12.67 23 11.062 23 9.004V3.857h-.862ZM8.318 1.712h6.91c1.022 0 1.901.598 2.321 1.454-.525.307-1.36.686-2.322.686H5.763a2.59 2.59 0 0 1 2.554-2.14Zm6.91 20.576h-6.91a2.59 2.59 0 0 1-2.555-2.145h12.013a2.58 2.58 0 0 1-2.549 2.145Zm-9.503-3.857V5.569h8.635V9c0 2.057 1.697 3.67 3.455 4.439v4.987H5.725v.006Zm15.55-9.432c0 1.404-1.492 2.496-2.592 2.94-1.1-.45-2.593-1.536-2.593-2.94V5.503c1.122-.175 2.04-.658 2.593-1.015.552.357 1.465.84 2.592 1.015V9Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineHeadphoneBluetooth = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineHeadphoneBluetooth",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M12 0a11.92 11.92 0 0 1 8.485 3.513 11.921 11.921 0 0 1 3.513 8.485v7.496c0 1.204-.423 2.327-1.186 3.157-.792.87-1.895 1.344-3.1 1.344h-2.14v-8.998h2.14c.96 0 1.848.302 2.572.859v-3.858c0-5.673-4.611-10.285-10.284-10.285-5.672 0-10.284 4.612-10.284 10.285v3.858a4.191 4.191 0 0 1 2.572-.859h2.14V24h-2.14a4.165 4.165 0 0 1-3.1-1.344C.425 21.826.002 20.703.002 19.5v-7.501a11.92 11.92 0 0 1 3.513-8.485A11.92 11.92 0 0 1 12 0ZM4.715 16.71h-.427c-1.493 0-2.572 1.176-2.572 2.788 0 1.613 1.084 2.784 2.572 2.784h.427V16.71Zm14.997 5.572h-.427V16.71h.427c1.488 0 2.572 1.171 2.572 2.784 0 1.612-1.08 2.788-2.572 2.788Zm-7.75-16.187c-1.795 0-3.033.854-3.033 4.113 0 3.258 1.238 4.107 3.033 4.107 1.794 0 3.033-.854 3.033-4.107 0-3.254-1.239-4.113-3.033-4.113Zm1.857 5.519-2.13 2.13v-2.807l-1.172 1.171-.422-.422 1.468-1.474L10.1 8.734l.422-.422 1.17 1.17v-2.81l2.132 2.13-1.406 1.407 1.4 1.406Zm-.845-.005-.681.681.005-1.363.676.682Zm1.905 2.14a.286.286 0 0 0-.1-.067.276.276 0 0 0-.125-.024.36.36 0 0 0-.125.024.37.37 0 0 0-.1.067.285.285 0 0 0-.068.101.276.276 0 0 0-.024.125c0 .043.01.086.024.125a.37.37 0 0 0 .067.1.286.286 0 0 0 .101.068.18.18 0 0 0 .024.01v.534h.2v-.4h.222l.356.4h.2l-.356-.415.067-.014a.452.452 0 0 0 .222-.1.225.225 0 0 0 .09-.186c0-.034-.015-.058-.032-.089a1.07 1.07 0 0 1-.013-.025.326.326 0 0 0-.045-.043.332.332 0 0 1-.044-.043c-.045-.028-.09-.057-.156-.057l-.032-.007a.659.659 0 0 0-.168-.021h-.137a.314.314 0 0 0-.048-.063Zm-.126.563v-.036a.367.367 0 0 0 .126-.076.286.286 0 0 0 .068-.1.326.326 0 0 0 .018-.188h.077c.244 0 .356.071.356.2 0 .057-.045.1-.09.143a.489.489 0 0 1-.266.057h-.289Zm.17-.328a.337.337 0 0 0-.008-.072h-.162v.337h.002a.236.236 0 0 0 .086-.063.296.296 0 0 0 .055-.079l.007-.012a.216.216 0 0 0 .02-.11Zm-.37-.172h.313a.3.3 0 0 0-.025-.03c-.017-.02-.04-.033-.062-.046a.601.601 0 0 1-.024-.016.344.344 0 0 0-.106-.019.258.258 0 0 0-.105.02.236.236 0 0 0-.087.062.335.335 0 0 0-.055.078l-.007.013a.378.378 0 0 0-.02.11c0 .039.005.077.02.11a.307.307 0 0 0 .062.092c.021.026.047.04.076.056l.01.006.01.003v-.44Zm-2.26-5.687.005 1.358.676-.677-.681-.681Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineHeadphones = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineHeadphones",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M12.005 0C5.388 0 0 5.386 0 12v7.497c0 2.567 1.844 4.497 4.285 4.497h2.146V15H4.285c-.982 0-1.865.318-2.573.856V12C1.712 6.33 6.326 1.717 12 1.717S22.288 6.329 22.288 12v3.856A4.184 4.184 0 0 0 19.715 15h-2.146v9h2.146C22.156 24 24 22.064 24 19.503V12c.01-6.614-5.377-12-11.995-12ZM4.291 16.711h.428v5.572H4.29c-1.493 0-2.574-1.173-2.574-2.786 0-1.612 1.081-2.786 2.574-2.786Zm15.43 5.572h-.429v-5.572h.428c1.493 0 2.574 1.174 2.574 2.786 0 1.613-1.081 2.786-2.574 2.786Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineHelp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineHelp",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M12 24C5.4 24 0 18.6 0 12S5.4 0 12 0s12 5.4 12 12-5.4 12-12 12Zm0-22.286C6.34 1.714 1.714 6.34 1.714 12c0 5.66 4.627 10.286 10.286 10.286 5.66 0 10.286-4.627 10.286-10.286C22.286 6.34 17.66 1.714 12 1.714Zm0 14.145a.861.861 0 0 1-.86-.859c0-1.416.558-2.74 1.542-3.773l1.243-1.243c.47-.47.384-1.54 0-2.06a2.17 2.17 0 0 0-1.714-.858H12c-.686 0-1.33.384-1.67.94-.26.428-.773.557-1.157.303-.427-.26-.557-.773-.303-1.157a3.62 3.62 0 0 1 3.13-1.8h.216c1.2 0 2.314.557 3.043 1.502.86 1.114.984 3.173-.13 4.33l-1.243 1.243c-.643.73-1.027 1.627-1.027 2.573 0 .47-.389.86-.859.86Zm.94 1.925a.94.94 0 1 1-1.88 0 .94.94 0 0 1 1.88 0Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineHockley = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineHockley",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M17.999 19.71h-4.285a2.144 2.144 0 1 0 0 4.29H18c1.18 0 2.145-.96 2.145-2.145A2.148 2.148 0 0 0 18 19.711Zm0 2.573h-4.285a.428.428 0 0 1 0-.856H18a.428.428 0 0 1 0 .856Zm4.284-11.996h-8.14c-.04 0-.078 0-.116.006l-.335-.598 4.202-7.564A.85.85 0 0 0 17.56.968a.85.85 0 0 0-1.163.335L12.705 7.95 8.459.436A.855.855 0 0 0 7.291.112a.855.855 0 0 0-.324 1.169l7.504 13.29c.445.768 1.344 1.284 2.244 1.284h5.573c.927 0 1.712-.785 1.712-1.712V12c0-.927-.79-1.712-1.717-1.712Zm0 3.856h-5.574c-.285 0-.62-.186-.751-.422l-.971-1.722h7.296v2.144Zm-10.714-2.457a.86.86 0 0 0-1.174.313l-.499.86H1.712A1.737 1.737 0 0 0 0 14.572v1.925c0 .927.784 1.712 1.712 1.712h5.573c.894 0 1.8-.516 2.244-1.284l2.358-4.07a.86.86 0 0 0-.318-1.168Zm-3.527 4.383c-.137.24-.472.427-.757.427H1.712v-1.93h7.197l-.867 1.503Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineHome = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineHome",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M23.731 12.043 11.991 0 .244 12.043c-.26.26-.303.6-.173.941.13.302.427.557.773.557h1.713V24H9.84v-7.714h4.286V24h7.282V13.498h1.714a.83.83 0 0 0 .772-.557.702.702 0 0 0-.163-.898Zm-7.886 10.239v-7.71H8.13v7.714H4.277V11.784H2.774l9.216-9.427 9.212 9.427h-1.503v10.498h-3.854Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineHomespot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineHomespot",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M8.708 13.497c-1.09 0-1.978-.866-1.978-1.93s.888-1.925 1.978-1.925c1.09 0 1.977.866 1.977 1.93s-.887 1.925-1.977 1.925Zm0-2.566a.65.65 0 0 0-.657.641c0 .351.297.642.657.642.36 0 .657-.29.657-.642a.65.65 0 0 0-.657-.641ZM17.927 9c0-3.307-2.758-6-6.146-6a.867.867 0 0 0-.877.856c0 .471.394.855.877.855 2.421 0 4.388 1.92 4.388 4.284 0 .471.393.855.876.855s.882-.378.882-.85ZM21 9c0-4.963-4.135-9-9.22-9a.867.867 0 0 0-.875.856c0 .471.393.855.876.855 4.112 0 7.46 3.269 7.46 7.284 0 .471.394.855.877.855S21 9.472 21 9Zm-6.584 15H3V9.428c0-1.415 1.18-2.572 2.635-2.572h6.146c1.45 0 2.635 1.151 2.635 2.572V24Zm-9.658-1.717h7.9V9.428a.867.867 0 0 0-.877-.856H5.635a.867.867 0 0 0-.877.856v12.855Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineHotline = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineHotline",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M6.808 24c-1.683 0-3.163-.537-4.29-1.653L.85 20.704a2.814 2.814 0 0 1-.847-1.839 2.446 2.446 0 0 1 .698-1.883L3.2 14.475c.99-.997 2.673-.948 3.746.109l1.743 1.719c1.045 1.03 3.405.17 5.605-2.042 1.161-1.166 1.97-2.409 2.283-3.498.182-.635.275-1.517-.302-2.086L14.53 6.958a2.828 2.828 0 0 1-.847-1.845 2.446 2.446 0 0 1 .699-1.883L16.88.723a2.483 2.483 0 0 1 1.887-.718 2.821 2.821 0 0 1 1.859.827l1.666 1.642c3.361 3.313 1.65 9.701-4.158 15.542C14.256 21.91 10.13 24 6.808 24Zm-1.854-8.54a.744.744 0 0 0-.539.213l-2.497 2.508a.754.754 0 0 0-.203.585c.016.263.137.52.34.723l1.667 1.642c2.64 2.6 8.059.827 13.18-4.319C22 11.688 23.712 6.29 21.072 3.69l-1.668-1.643a1.118 1.118 0 0 0-.731-.334.739.739 0 0 0-.583.209l-2.497 2.507a.754.754 0 0 0-.204.586c.017.262.138.52.341.722l1.744 1.72c.913.902 1.183 2.238.748 3.766-.396 1.385-1.331 2.846-2.712 4.237-2.998 3.01-6.227 3.837-8.036 2.058L5.73 15.8a1.12 1.12 0 0 0-.776-.34Zm6.645-3.055a.964.964 0 0 1-.22-.027l-3.064-.816a6.013 6.013 0 0 1-2.282.449c-3.328 0-6.03-2.693-6.03-6S2.7 0 6.028 0s6.029 2.693 6.029 6a5.87 5.87 0 0 1-.451 2.277l.82 3.05a.866.866 0 0 1-.22.826.842.842 0 0 1-.606.252ZM8.244 9.8a.94.94 0 0 1 .22.028l1.92.509-.512-1.91a.829.829 0 0 1 .055-.587A4.225 4.225 0 0 0 10.339 6c0-2.365-1.936-4.292-4.312-4.292-2.376 0-4.312 1.927-4.312 4.292 0 2.365 1.936 4.292 4.312 4.292.644 0 1.265-.137 1.848-.41a.862.862 0 0 1 .369-.083ZM6.01 3.208a.64.64 0 1 0 0 1.281.64.64 0 1 0 0-1.281Zm.643 4.922V5.989a.64.64 0 0 0-.643-.64.64.64 0 0 0-.644.64v2.14a.64.64 0 0 0 .644.641.64.64 0 0 0 .643-.64Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineHotspot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineHotspot",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M12.915 0h-7.66C2.907 0 1 1.92 1 4.285v15.43C1 22.08 2.907 24 5.255 24h7.66c2.349 0 4.256-1.92 4.256-4.285V4.29C17.176 1.926 15.264 0 12.916 0ZM2.7 18.436V5.575h12.77v12.861H2.7ZM5.255 1.717h7.66c1.265 0 2.31.928 2.518 2.146H2.738c.207-1.218 1.253-2.146 2.517-2.146Zm7.66 20.577h-7.66c-1.264 0-2.31-.928-2.517-2.146h12.695a2.559 2.559 0 0 1-2.518 2.146Zm8.865-4.67a.848.848 0 0 1-1.204.033.862.862 0 0 1-.033-1.213 6.353 6.353 0 0 0-.109-8.861.862.862 0 0 1 0-1.213.847.847 0 0 1 1.204 0 8.058 8.058 0 0 1 .142 11.254ZM19.79 15.6a.842.842 0 0 1-.626.28.858.858 0 0 1-.627-1.438 3.51 3.51 0 0 0-.103-4.845.862.862 0 0 1 0-1.213.847.847 0 0 1 1.204 0 5.223 5.223 0 0 1 .152 7.216Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineIdea = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineIdea",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M11.155 1.682V.84a.844.844 0 0 1 1.69 0v.84a.844.844 0 0 1-1.69 0Zm11 8.42h-.634a.844.844 0 0 0-.845.841c0 .464.38.841.845.841h.634a.844.844 0 0 0 .845-.84.844.844 0 0 0-.845-.842Zm-19.676 0h-.634a.844.844 0 0 0-.845.841c0 .464.38.841.845.841h.634a.844.844 0 0 0 .844-.84.844.844 0 0 0-.844-.842Zm1.906-4.506-.753-.432a.844.844 0 0 0-1.153.308.836.836 0 0 0 .308 1.148l.753.431a.856.856 0 0 0 .423.113c.292 0 .58-.15.73-.42a.842.842 0 0 0-.308-1.148Zm2.226-2.254a.844.844 0 0 0 1.154.308.837.837 0 0 0 .308-1.149l-.422-.727a.845.845 0 0 0-1.154-.308.837.837 0 0 0-.308 1.149l.422.727Zm9.608.335a.856.856 0 0 0 .423.113c.292 0 .58-.151.73-.42l.434-.75a.844.844 0 0 0-1.462-.841l-.434.75a.839.839 0 0 0 .31 1.148Zm5.308 1.795a.845.845 0 0 0-1.154-.308l-.753.432a.837.837 0 0 0-.308 1.148.844.844 0 0 0 1.153.307l.753-.431a.836.836 0 0 0 .309-1.148Zm-2.123 5.687a7.302 7.302 0 0 1-3.456 6.232 2.447 2.447 0 0 0-.27.21c.584.372.974 1.024.974 1.768 0 .475-.162.911-.433 1.262.265.35.433.787.433 1.261A2.112 2.112 0 0 1 14.535 24h-5.08a2.112 2.112 0 0 1-2.118-2.108c0-.474.162-.91.433-1.261a2.09 2.09 0 0 1-.433-1.262c0-.744.39-1.396.98-1.768a3.083 3.083 0 0 0-.27-.21 7.302 7.302 0 0 1-3.456-6.232c0-4.065 3.32-7.37 7.404-7.37 4.089 0 7.409 3.305 7.409 7.37Zm-4.441 10.739c0-.232-.19-.42-.423-.42H9.46a.422.422 0 0 0-.423.42c0 .231.19.42.423.42h5.08a.422.422 0 0 0 .423-.42Zm0-2.529c0-.232-.19-.42-.423-.42H9.46a.422.422 0 0 0-.423.42c0 .232.19.42.423.42h5.08a.422.422 0 0 0 .423-.42Zm2.75-8.21c0-3.137-2.56-5.687-5.713-5.687-3.152 0-5.714 2.55-5.714 5.687 0 1.968.991 3.752 2.654 4.803.005.006.92.566 1.235 1.305h3.645c.314-.739 1.23-1.3 1.235-1.305 1.668-1.056 2.659-2.84 2.659-4.803Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineInStore = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineInStore",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M23.99 3.115 21.43 0H3.764L1.211 3.115V8.14h2.532v8.139H1.632A.634.634 0 0 0 1 16.92c0 .356.28.641.632.641h11.173l-.815.834-.632.642a.65.65 0 0 0 0 .91.624.624 0 0 0 .448.187.62.62 0 0 0 .448-.187l.632-.642 2.344-2.38-2.344-2.38-.632-.642a.626.626 0 0 0-.896 0 .65.65 0 0 0 0 .91l.632.642.815.834H9.441v-4.925h6.75v10.925h-6.75v-2.786a.634.634 0 0 0-.632-.642.634.634 0 0 0-.632.642v2.786H5.434v-2.572a.85.85 0 0 0-.843-.856.85.85 0 0 0-.842.856V24h18.14V8.139H24V3.115h-.01ZM4.558 1.711h16.087l.875 1.07H3.68l.88-1.07Zm15.634 20.567h-2.744V10.064H8.172v6.214H5.428v-8.14h14.765v14.14ZM2.896 6.422V4.064h19.408v2.358H2.896Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineInformation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineInformation",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M0 12c0 6.6 5.4 12 12 12s12-5.4 12-12S18.6 0 12 0 0 5.4 0 12Zm1.714 0C1.714 6.34 6.34 1.714 12 1.714c5.66 0 10.286 4.627 10.286 10.286 0 5.66-4.627 10.286-10.286 10.286C6.34 22.286 1.714 17.66 1.714 12ZM12 18.427a.861.861 0 0 1-.86-.859v-8.14c0-.471.385-.86.86-.86.47 0 .86.384.86.86v8.14c0 .475-.39.86-.86.86Zm0-11.14a1.07 1.07 0 1 0 0-2.141 1.07 1.07 0 0 0 0 2.14Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineInsurance = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineInsurance",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M21.132 3.643c-4.363 0-7.835-2.787-8.453-3.32-.24-.202-.395-.318-.662-.323h-.023c-.267.005-.422.12-.662.324-.618.532-4.09 3.32-8.453 3.32H2v11.143c0 5.992 6.89 8.264 9.638 9.136a.89.89 0 0 0 .724 0C15.116 23.051 22 20.78 22 14.787V3.643h-.868Zm-10 18.217c-3.656-1.284-7.39-3.204-7.39-7.073V12h7.39v9.86Zm0-11.572h-7.39V5.361c3.2-.225 5.843-1.734 7.39-2.788v7.715Zm9.126 4.5c0 3.868-3.734 5.788-7.39 7.072V12h7.39v2.787Zm0-4.5h-7.39v-7.72c1.547 1.048 4.19 2.562 7.39 2.787v4.933Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineInternetOfThings = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineInternetOfThings",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M12 0C5.357 0 0 5.357 0 12s5.357 12 12 12 12-5.357 12-12S18.643 0 12 0ZM7.843 2.616c-.557.773-1.027 1.714-1.373 2.74-1.286 0-2.356 1.076-2.356 2.358 0 .94.556 1.756 1.372 2.14-.043.428-.086.86-.086 1.287H1.714c.302-3.811 2.74-7.027 6.13-8.525Zm-.345 5.098c0 .6-.476 1.075-1.076 1.075-.6 0-1.075-.475-1.075-1.075s.475-1.076 1.075-1.076 1.076.476 1.076 1.076Zm-5.741 5.145h3.6c.13 3.514 1.075 6.514 2.486 8.53-3.389-1.507-5.789-4.719-6.086-8.53Zm9.384 9.255c-2.141-.816-3.903-4.67-4.07-9.26h4.07v9.26Zm0-10.973H7.07c0-.427.043-.816.086-1.2a2.359 2.359 0 0 0 1.627-2.227A2.3 2.3 0 0 0 8.011 6c.73-2.102 1.843-3.643 3.13-4.114v9.255Zm11.14 0h-3.638c-.13-3.509-1.075-6.509-2.486-8.525 3.384 1.498 5.827 4.714 6.125 8.525ZM12.86 1.886c2.141.816 3.903 4.67 4.07 9.26h-4.07v-9.26Zm0 20.228v-9.255h4.07c-.172 4.584-1.929 8.439-4.07 9.255Zm3.298-.73c1.416-2.016 2.357-5.054 2.486-8.53h3.643c-.302 3.816-2.745 7.028-6.13 8.53Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineInternet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineInternet",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M12 0C5.375 0 0 5.375 0 12s5.37 12 12 12 12-5.375 12-12S18.625 0 12 0ZM7.826 2.605c-1.398 2.018-2.336 5.04-2.462 8.54H1.717c.312-3.823 2.758-7.043 6.11-8.54Zm-6.11 10.25h3.642c.126 3.494 1.064 6.516 2.463 8.54-3.346-1.497-5.792-4.717-6.104-8.54Zm9.428 9.258c-2.15-.822-3.883-4.656-4.069-9.257h4.07v9.257Zm0-10.969H7.075c.186-4.601 1.92-8.435 4.07-9.257v9.257Zm11.14 0h-3.642c-.127-3.493-1.064-6.515-2.463-8.539 3.346 1.497 5.792 4.717 6.104 8.54Zm-9.428-9.257c2.15.822 3.883 4.656 4.069 9.257h-4.07V1.887Zm0 20.226v-9.257h4.069c-.186 4.601-1.92 8.435-4.07 9.257Zm3.318-.718c1.398-2.018 2.336-5.04 2.462-8.54h3.642c-.307 3.823-2.753 7.043-6.104 8.54Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineKeepItSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineKeepItSimple",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M22.246 15.085a2.595 2.595 0 0 0-.906-.573 2.484 2.484 0 0 0-1.491-3.212 2.482 2.482 0 0 0-.585-2.644 2.62 2.62 0 0 0-.664-.469l2.453-2.402a2.48 2.48 0 0 0 0-3.56 2.586 2.586 0 0 0-1.817-.737c-.687 0-1.328.259-1.818.738L8.494 10.97 5.51 8.05a2.547 2.547 0 0 0-1.795-.728c-.68 0-1.316.26-1.795.728a2.45 2.45 0 0 0 0 3.515l2.172 2.127a5.802 5.802 0 0 1 1.615 2.914l.31 1.421a7.49 7.49 0 0 0 2.093 3.775c1.328 1.3 2.577 2.077 5.042 2.192.079.006.157.006.242.006 2.363 0 4.895-1.587 5.002-1.658l.079-.061c.203-.165.383-.325.546-.485l1.435-1.405 1.789-1.752A2.479 2.479 0 0 0 23 16.86c0-.666-.265-1.3-.754-1.774Zm-4.226-4.088-1.79 1.752a.843.843 0 0 1-1.142 0 .779.779 0 0 1-.236-.562c0-.209.085-.407.236-.562l1.79-1.752a.813.813 0 0 1 .574-.231.79.79 0 0 1 .568 1.355Zm-1.44 3.846 1.789-1.752a.818.818 0 0 1 .574-.231c.208 0 .416.077.574.23a.78.78 0 0 1 0 1.12l-1.795 1.751a.82.82 0 0 1-1.142 0 .78.78 0 0 1 0-1.118Zm-3.343 7.427c-1.924-.094-2.785-.617-3.882-1.692a5.802 5.802 0 0 1-1.615-2.914l-.31-1.422a7.49 7.49 0 0 0-2.093-3.774l-2.172-2.126a.754.754 0 0 1 0-1.08.815.815 0 0 1 1.103 0l4.226 4.137 10.173-9.95a.843.843 0 0 1 1.142 0 .788.788 0 0 1 0 1.124l-5.964 5.84s0 .006-.006.006a2.462 2.462 0 0 0-.748 1.774c0 .672.264 1.3.754 1.78.259.253.568.446.906.572a2.484 2.484 0 0 0 1.491 3.213 2.47 2.47 0 0 0 .585 2.644c.191.188.411.342.647.463a.88.88 0 0 0-.073.066c-.315.182-2.43 1.433-4.164 1.339Zm7.765-4.848-1.789 1.752a.843.843 0 0 1-1.142 0 .78.78 0 0 1 0-1.119l.894-.876.9-.881a.81.81 0 0 1 .57-.232.83.83 0 0 1 .573.232.779.779 0 0 1-.006 1.124ZM1.257 3.19a.849.849 0 0 1 0-1.218.893.893 0 0 1 1.244 0l3.078 3.014a.849.849 0 0 1 0 1.218.865.865 0 0 1-.619.253.865.865 0 0 1-.619-.253L1.257 3.19Zm8.35 3.014a.849.849 0 0 1 0-1.218l3.079-3.014a.893.893 0 0 1 1.243 0 .849.849 0 0 1 0 1.218l-3.078 3.014a.865.865 0 0 1-.619.253.912.912 0 0 1-.624-.253ZM6.71 5.163V.86A.87.87 0 0 1 7.588 0a.87.87 0 0 1 .878.86v4.303a.87.87 0 0 1-.878.859.87.87 0 0 1-.878-.86Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineKeyboard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineKeyboard",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M17.144 17H6.856a.639.639 0 0 1-.642-.642c0-.356.285-.641.642-.641h10.283a.64.64 0 0 1 .642.641.638.638 0 0 1-.637.642ZM5.572 8.647a.639.639 0 0 0-.641-.642H3.214a.639.639 0 0 0-.642.642c0 .357.285.642.642.642h1.711a.64.64 0 0 0 .647-.642Zm7.925 0a.639.639 0 0 0-.641-.642h-1.712a.639.639 0 0 0-.641.642c0 .357.285.642.641.642h1.712a.639.639 0 0 0 .641-.642Zm-3.96 0a.639.639 0 0 0-.641-.642H7.185a.639.639 0 0 0-.642.642c0 .357.285.642.642.642h1.71a.643.643 0 0 0 .642-.642Zm7.925 0a.639.639 0 0 0-.641-.642H15.11a.639.639 0 0 0-.642.642c0 .357.285.642.642.642h1.71a.639.639 0 0 0 .642-.642Zm3.966 0a.639.639 0 0 0-.642-.642h-1.711a.639.639 0 0 0-.642.642c0 .357.285.642.642.642h1.711a.643.643 0 0 0 .642-.642ZM5.572 11.22a.639.639 0 0 0-.641-.641H3.214a.639.639 0 0 0-.642.641c0 .357.285.642.642.642h1.711c.362 0 .647-.29.647-.642Zm7.925 0a.639.639 0 0 0-.641-.641h-1.712a.639.639 0 0 0-.641.641c0 .357.285.642.641.642h1.712c.356 0 .641-.29.641-.642Zm-3.96 0a.639.639 0 0 0-.641-.641H7.185a.639.639 0 0 0-.642.641c0 .357.285.642.642.642h1.71c.352 0 .642-.29.642-.642Zm7.925 0a.639.639 0 0 0-.641-.641H15.11a.639.639 0 0 0-.642.641c0 .357.285.642.642.642h1.71c.357 0 .642-.29.642-.642Zm3.966 0a.639.639 0 0 0-.642-.641h-1.711a.639.639 0 0 0-.642.641c0 .357.285.642.642.642h1.711c.351 0 .642-.29.642-.642ZM5.572 13.786a.639.639 0 0 0-.641-.642H3.214a.639.639 0 0 0-.642.642c0 .357.285.642.642.642h1.711a.637.637 0 0 0 .647-.642Zm7.925 0a.639.639 0 0 0-.641-.642h-1.712a.639.639 0 0 0-.641.642c0 .357.285.642.641.642h1.712a.636.636 0 0 0 .641-.642Zm-3.96 0a.639.639 0 0 0-.641-.642H7.185a.639.639 0 0 0-.642.642c0 .357.285.642.642.642h1.71a.639.639 0 0 0 .642-.642Zm7.925 0a.639.639 0 0 0-.641-.642H15.11a.639.639 0 0 0-.642.642c0 .357.285.642.642.642h1.71a.636.636 0 0 0 .642-.642Zm3.966 0a.639.639 0 0 0-.642-.642h-1.711a.639.639 0 0 0-.642.642c0 .357.285.642.642.642h1.711a.639.639 0 0 0 .642-.642ZM24 17.861V7.144C24 5.965 23.04 5 21.856 5H2.144C.965 5 0 5.96 0 7.144v10.712C0 19.035.96 20 2.144 20h19.712C23.035 20 24 19.04 24 17.861ZM21.856 6.717c.235 0 .427.192.427.427v10.712a.428.428 0 0 1-.427.427H2.144a.428.428 0 0 1-.427-.427V7.144c0-.235.192-.427.427-.427h19.712Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineLandline = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineLandline",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "m22.756 19.648-2.29-2.367a3.978 3.978 0 0 0-2.803-1.136c-1.06 0-2.053.402-2.808 1.142l-4.394 4.358a2.24 2.24 0 0 1-3.113 0 2.126 2.126 0 0 1-.011-3.034l.107-.105c.39-.055.79-.138 1.201-.254 2.172-.629 4.478-2.107 6.666-4.27 2.183-2.157 3.66-4.418 4.275-6.542.655-2.251.271-4.21-1.077-5.511L17.23.688c-.914-.883-2.346-.922-3.192-.083L12.12 2.502c-.846.839-.795 2.24.119 3.123L13.58 6.92c.598.58.265 2.146-1.523 3.917-1.799 1.776-3.406 2.124-3.998 1.544L6.716 11.08c-.913-.883-2.346-.922-3.192-.083l-1.917 1.897c-.423.42-.637.982-.604 1.59.034.573.288 1.114.717 1.533L3 17.258a4.641 4.641 0 0 0 2.33 1.204 3.802 3.802 0 0 0 .777 4.402A4 4 0 0 0 8.91 24c1.015 0 2.036-.38 2.809-1.136l4.393-4.358a2.21 2.21 0 0 1 1.557-.63c.586 0 1.139.227 1.54.613l2.272 2.35a.896.896 0 0 0 1.247.033.856.856 0 0 0 .028-1.224Zm-19.801-4.86a.612.612 0 0 1-.198-.409.334.334 0 0 1 .096-.275l1.918-1.898a.358.358 0 0 1 .26-.094c.146 0 .31.066.44.193l1.341 1.302c1.484 1.44 4.095.811 6.492-1.556 2.39-2.36 3-4.915 1.511-6.354L13.473 4.4c-.22-.21-.265-.524-.107-.684l1.917-1.898c.164-.16.48-.115.7.094l1.28 1.241c1.116 1.082.953 2.67.62 3.818-.524 1.82-1.89 3.878-3.83 5.798-1.956 1.93-4.054 3.293-5.915 3.828a6.565 6.565 0 0 1-1.044.215.797.797 0 0 0-.253.028c-.908.071-1.873-.094-2.612-.811l-1.274-1.241Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineLaptop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineLaptop",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M21.86 16.212s0-.044 0 0V6.527C21.86 5.137 20.704 4 19.289 4H4.718C3.302 4 2.145 5.137 2.145 6.527v9.685H0v.63A3.174 3.174 0 0 0 3.17 20h17.703C22.585 20 24 18.567 24 16.842v-.63h-2.14ZM3.863 6.527a.85.85 0 0 1 .856-.84h14.57a.85.85 0 0 1 .855.84v9.684H3.863V6.528Zm17.01 12.213H3.176c-.812 0-1.497-.55-1.755-1.261h21.213c-.302.711-.987 1.261-1.76 1.261Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineLegal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineLegal",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M13.716 8.847a5.138 5.138 0 0 0 5.14 5.058c2.826 0 5.1-2.361 5.144-5.144 0-.044 0-.26-.13-.428L19.585.617c-.13-.26-.303-.428-.73-.428H5.14c-.427 0-.6.173-.73.428L.13 8.333c-.13.173-.13.39-.13.428.043 2.788 2.313 5.14 5.14 5.14a5.138 5.138 0 0 0 5.14-5.059s0-.216-.13-.513L6.599 1.903h4.54v20.141H4.286a.861.861 0 0 0-.86.86c0 .474.39.858.86.858h15.428a.861.861 0 0 0 .86-.859.861.861 0 0 0-.86-.859h-6.857V1.903h4.54L13.84 8.329c-.124.302-.124.518-.124.518Zm-8.576 3.34c-1.589 0-2.956-1.113-3.302-2.572H8.48a3.483 3.483 0 0 1-3.34 2.572Zm2.836-4.285H2.318l2.827-5.14 2.831 5.14Zm10.884-5.14 2.827 5.14h-5.658l2.831-5.14Zm3.297 6.853c-.389 1.459-1.713 2.572-3.302 2.572-1.588 0-2.956-1.113-3.301-2.572h6.603Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineLidar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineLidar",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M17.575 0H6.425a.864.864 0 0 0-.856.87v16.99c0 .48.384.87.856.87h3.43v4.4c0 .48.384.87.856.87.471 0 .855-.39.855-.87v-4.4h.856v4.4c0 .48.385.87.856.87.472 0 .856-.39.856-.87v-4.4h3.43a.84.84 0 0 0 .598-.262.867.867 0 0 0 .258-.607V.875A.853.853 0 0 0 17.575 0Zm-.862 16.99H7.287V1.746h9.432v15.246h-.006ZM12 10.462c2.145 0 3.857-1.74 3.857-3.92 0-2.18-1.712-3.926-3.857-3.926-2.145 0-3.857 1.74-3.857 3.92 0 2.18 1.712 3.926 3.857 3.926Zm0-6.535c1.416 0 2.573 1.176 2.573 2.615 0 1.439-1.157 2.615-2.573 2.615S9.427 7.98 9.427 6.541 10.584 3.926 12 3.926Zm0 7.84c-1.202 0-2.145.959-2.145 2.18s.943 2.18 2.145 2.18 2.145-.959 2.145-2.18-.943-2.18-2.145-2.18Zm0 3.05a.864.864 0 0 1-.856-.87c0-.48.384-.87.856-.87s.856.39.856.87-.384.87-.856.87Zm0-6.535c.944 0 1.712-.787 1.712-1.74 0-.954-.774-1.74-1.712-1.74s-1.712.786-1.712 1.74c0 .953.768 1.74 1.712 1.74Zm0-2.18c.258 0 .428.172.428.434s-.17.435-.428.435-.428-.173-.428-.435.17-.435.428-.435ZM4.071 7.756c-.384-.307-.642-.742-.642-1.222s.214-.914.598-1.22c.302-.218.34-.609.17-.915-.213-.307-.598-.346-.9-.173-.73.569-1.157 1.394-1.157 2.308 0 .915.428 1.74 1.158 2.264a.66.66 0 0 0 .384.129.62.62 0 0 0 .516-.263c.214-.3.131-.736-.127-.908ZM1.284 6.535c0-.959.428-1.918 1.158-2.57a.637.637 0 0 0 .044-.915.613.613 0 0 0-.9-.044C.554 3.876 0 5.186 0 6.536c0 1.349.56 2.66 1.586 3.53a.55.55 0 0 0 .428.172c.17 0 .34-.09.472-.218.214-.262.214-.697-.044-.914a3.496 3.496 0 0 1-1.158-2.57Zm19.418-2.264c-.302-.217-.686-.128-.9.173-.213.301-.126.697.17.915.385.262.599.741.599 1.22 0 .48-.214.915-.598 1.222-.302.218-.34.608-.17.915.126.172.34.262.515.262a.702.702 0 0 0 .384-.129c.73-.568 1.158-1.394 1.158-2.308a2.77 2.77 0 0 0-1.158-2.27Zm1.712-1.26a.613.613 0 0 0-.9.045c-.214.262-.214.697.044.914a3.496 3.496 0 0 1 1.158 2.57c0 .96-.428 1.92-1.158 2.572a.637.637 0 0 0-.044.914.692.692 0 0 0 .472.217.55.55 0 0 0 .428-.172C23.402 9.156 24 7.89 24 6.54s-.554-2.66-1.586-3.53Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineLifts = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineLifts",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M18.175 10.467a.85.85 0 0 1 0-1.213l2.782-2.748 2.783 2.748a.85.85 0 0 1 0 1.213.859.859 0 0 1-.61.252.85.85 0 0 1-.612-.252L20.963 8.93l-1.555 1.536a.883.883 0 0 1-1.233 0Zm4.343 3.072-1.555 1.536-1.555-1.536a.876.876 0 0 0-1.228 0 .85.85 0 0 0 0 1.212l2.783 2.748 2.783-2.748a.85.85 0 0 0 0-1.212.876.876 0 0 0-1.228 0ZM16.62 2.573V24H1V2.573C1 1.157 2.166 0 3.605 0H14.02c1.433 0 2.6 1.157 2.6 2.573Zm-1.733 0a.862.862 0 0 0-.866-.856H3.605a.862.862 0 0 0-.866.856v19.715h12.153V2.573h-.006Zm-1.955 7.499v5.787h-1.3v4.712a.643.643 0 0 1-.65.642.643.643 0 0 1-.65-.642v-5.996h1.3v-4.498c0-.927-.794-1.711-1.733-1.711H7.727c-.94 0-1.733.784-1.733 1.711v4.498h1.3v6.002a.643.643 0 0 1-.65.642.643.643 0 0 1-.65-.642v-4.712h-1.3v-5.793c0-1.235.805-2.326 1.91-2.776a2.741 2.741 0 0 1-.61-1.723c0-1.536 1.266-2.786 2.821-2.786 1.556 0 2.822 1.25 2.822 2.786 0 .653-.228 1.251-.611 1.723 1.105.455 1.905 1.541 1.905 2.776ZM7.293 5.573c0 .823.678 1.498 1.511 1.498a1.51 1.51 0 0 0 1.522-1.498c0-.822-.683-1.497-1.516-1.497s-1.517.67-1.517 1.497Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineList = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineList",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M23.139 3.963H6.856A.851.851 0 0 1 6 3.118c0-.466.384-.845.856-.845h16.283a.85.85 0 0 1 .855.845.848.848 0 0 1-.855.845ZM24 12a.851.851 0 0 0-.856-.845H6.856A.851.851 0 0 0 6 12c0 .466.384.845.856.845h16.283c.477 0 .861-.38.861-.845Zm0 8.888a.851.851 0 0 0-.856-.845H6.856a.851.851 0 0 0-.856.845c0 .465.384.845.856.845h16.283c.477 0 .861-.38.861-.845ZM5.144 12c0-1.397-1.151-2.54-2.572-2.54C1.152 9.46 0 10.597 0 12s1.152 2.54 2.572 2.54c1.42 0 2.572-1.143 2.572-2.54Zm-1.71 0a.851.851 0 0 1-.856.845.851.851 0 0 1-.856-.845c0-.466.384-.845.856-.845.471 0 .855.38.855.845Zm1.71 8.46c0-1.398-1.151-2.54-2.572-2.54C1.152 17.92 0 19.057 0 20.46S1.152 23 2.572 23c1.42 0 2.572-1.137 2.572-2.54Zm-1.71 0a.851.851 0 0 1-.856.845.851.851 0 0 1-.856-.845c0-.466.384-.845.856-.845.471 0 .855.38.855.845Zm1.71-16.92C5.144 2.143 3.993 1 2.572 1 1.152 1 0 2.137 0 3.54s1.152 2.54 2.572 2.54c1.42 0 2.572-1.143 2.572-2.54Zm-1.71 0a.851.851 0 0 1-.856.845.851.851 0 0 1-.856-.845c0-.466.384-.845.856-.845.471 0 .855.374.855.845Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineLockOpen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineLockOpen",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M19.285 7.285v1.713a2.576 2.576 0 0 1 2.572 2.572v9.858A2.576 2.576 0 0 1 19.285 24H4.715a2.576 2.576 0 0 1-2.572-2.572V11.57a2.576 2.576 0 0 1 2.572-2.572V7.285C4.715 3.268 7.983 0 12 0s7.285 3.268 7.285 7.285ZM12 1.713a5.58 5.58 0 0 0-5.572 5.572v1.713h11.144V7.285A5.58 5.58 0 0 0 12 1.713Zm8.14 19.71c0 .47-.385.859-.86.859H4.715a.861.861 0 0 1-.859-.86V11.57c0-.47.384-.859.86-.859h14.569c.47 0 .859.384.859.86v9.852h-.005Zm-9.426-3.355 4.967-4.962a.857.857 0 0 1 1.21 1.214l-6.177 6.177-2.75-2.75a.857.857 0 1 1 1.214-1.214l1.536 1.535Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineLockClosed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineLockClosed",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M19.285 8.998V7.285C19.285 3.268 16.017 0 12 0S4.715 3.268 4.715 7.285v1.713a2.576 2.576 0 0 0-2.572 2.572v9.858A2.576 2.576 0 0 0 4.715 24h14.57a2.576 2.576 0 0 0 2.572-2.572V11.57a2.576 2.576 0 0 0-2.572-2.572ZM6.428 7.285A5.58 5.58 0 0 1 12 1.713a5.58 5.58 0 0 1 5.572 5.572v1.713H6.428V7.285ZM19.28 22.282a.861.861 0 0 0 .86-.86h.004V11.57a.861.861 0 0 0-.859-.859H4.715a.861.861 0 0 0-.859.86v9.852c0 .475.389.859.86.859H19.28Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineLockOpen2 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineLockOpen2",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M19.283 9.471V7.283A7.28 7.28 0 0 0 12 0a7.27 7.27 0 0 0-6.684 4.371c-.173.427 0 .94.427 1.113.427.173.94 0 1.113-.427.94-2.015 2.913-3.34 5.14-3.34a5.56 5.56 0 0 1 5.57 5.571v2.14H5.139A2.578 2.578 0 0 0 2.567 12v9.428A2.578 2.578 0 0 0 5.139 24h13.713a2.578 2.578 0 0 0 2.571-2.572V12c0-1.286-.94-2.313-2.14-2.529Zm.427 11.952a.861.861 0 0 1-.858.86H5.139a.861.861 0 0 1-.86-.86V12c0-.475.39-.859.86-.859h13.713a.86.86 0 0 1 .858.859v9.423Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineLogin = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineLogin",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M15.79 0H8.21C5.887 0 4 1.92 4 4.285v15.43C4 22.08 5.887 24 8.21 24h7.58c2.323 0 4.21-1.92 4.21-4.285V4.29C20 1.926 18.113 0 15.79 0ZM5.682 18.436V5.575h12.636v12.861H5.682ZM8.21 1.717h7.58c1.25 0 2.286.928 2.49 2.146H5.72c.205-1.218 1.24-2.146 2.49-2.146Zm7.58 20.577H8.21c-1.25 0-2.285-.928-2.49-2.146h12.56c-.204 1.218-1.24 2.146-2.49 2.146ZM14.183 12.18c.599-.587.976-1.41.976-2.32 0-1.773-1.418-3.216-3.159-3.216-1.741 0-3.159 1.443-3.159 3.215 0 .91.377 1.734.976 2.321-1.38.554-2.243 1.652-2.243 3.04v1.284c0 .357.28.642.63.642a.634.634 0 0 0 .632-.642V15.22c0-1.262 1.299-2.146 3.159-2.146 1.86 0 3.159.884 3.159 2.146v1.284a.634.634 0 1 0 1.267 0V15.22c0-1.388-.858-2.486-2.238-3.04Zm-4.08-2.32c0-1.065.851-1.932 1.897-1.932s1.898.867 1.898 1.931c0 1.065-.852 1.931-1.898 1.931-1.046 0-1.898-.866-1.898-1.93Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineLostFound = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineLostFound",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M18.106 0c-3.252 0-5.895 2.669-5.895 5.952 0 3.284 2.643 5.952 5.895 5.952 3.251 0 5.894-2.668 5.894-5.952C24 2.669 21.352 0 18.106 0Zm0 10.584c-2.526 0-4.582-2.076-4.582-4.626 0-2.55 2.056-4.627 4.582-4.627 2.525 0 4.581 2.077 4.581 4.627s-2.056 4.626-4.581 4.626Zm.514-1.766a.654.654 0 1 1-1.308 0 .654.654 0 1 1 1.308 0Zm.882-5.303c.425.558.492 1.551-.083 2.132l-.48.486a1.08 1.08 0 0 0-.32.772.654.654 0 1 1-1.307 0c0-.643.252-1.252.704-1.709l.48-.485c.057-.057.046-.3-.027-.395a.526.526 0 0 0-.408-.203h-.09a.429.429 0 0 0-.368.214.653.653 0 0 1-.894.243.666.666 0 0 1-.24-.903 1.728 1.728 0 0 1 1.503-.874h.089c.559 0 1.1.27 1.441.722Zm-2.938 11.25a.617.617 0 0 0-.034-.147c-.006-.017-.017-.04-.022-.057a.346.346 0 0 0-.04-.079.56.56 0 0 0-.066-.107c-.006-.005-.012-.017-.017-.022a.685.685 0 0 0-.168-.17L2.345 3.645l-.688-1.388a.87.87 0 0 0-1.173-.395.886.886 0 0 0-.391 1.185L.78 4.44.763 21.975c0 .084.017.158.034.237.006.01.006.022.011.033.011.04.023.074.04.108.01.028.027.056.044.084l.028.045a.916.916 0 0 0 .29.277.853.853 0 0 0 .43.118.87.87 0 0 0 .76-.445 6.98 6.98 0 0 1 2.95-2.81 6.817 6.817 0 0 1 2.576-.71l1.324 2.685a.442.442 0 0 1-.195.592.436.436 0 0 1-.587-.198l-.196-.394a.868.868 0 0 0-1.173-.395.885.885 0 0 0-.39 1.184l.195.395A2.18 2.18 0 0 0 8.859 24c.324 0 .66-.073.972-.231 1.079-.542 1.514-1.868.978-2.957l-1.324-2.708a6.91 6.91 0 0 1 6.107-2.336.871.871 0 0 0 .972-1.004Zm-5.744.112a8.594 8.594 0 0 0-2.799 2.229 8.528 8.528 0 0 0-3.447.92 8.825 8.825 0 0 0-2.056 1.438l.017-13.478L13.2 14.082a8.899 8.899 0 0 0-2.38.795Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineMale = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineMale",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M18 9.21c0-1.656-1.02-3.077-2.478-3.713.45-.576.72-1.29.72-2.068 0-1.893-1.576-3.429-3.52-3.429-1.943 0-3.52 1.536-3.52 3.429 0 .718.231 1.387.62 1.942C8.182 5.919 7 7.433 7 9.216v7.927h1.757v6.001a.87.87 0 0 0 .879.856.869.869 0 0 0 .879-.856v-7.718H8.757V9.21c0-1.279 1.11-2.36 2.422-2.36h2.642c1.312 0 2.422 1.081 2.422 2.36v6.215h-1.758v7.713a.87.87 0 0 0 .88.855.869.869 0 0 0 .878-.855v-5.996H18V9.21Zm-5.283-7.498c.969 0 1.757.768 1.757 1.711 0 .944-.788 1.712-1.768 1.712-.97-.006-1.752-.774-1.752-1.712.005-.943.794-1.711 1.763-1.711Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineManagedLan = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineManagedLan",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M24 18.22c0-1.2-1.019-2.224-2.213-2.224-.883 0-1.636.58-1.993 1.331h-5.31c-.22-.489-.577-.887-1.104-1.109v-3.777h7.518a.886.886 0 0 0 .883-.888V.887A.886.886 0 0 0 20.898 0H4.102a.886.886 0 0 0-.883.887v10.666c0 .49.396.888.883.888h7.518v3.777c-.487.222-.838.62-1.064 1.11h-5.35c-.351-.803-1.104-1.332-1.993-1.332C2.02 15.996 1 17.02 1 18.22c0 .888.577 1.644 1.325 2.003v2.89c0 .489.396.887.883.887a.886.886 0 0 0 .883-.887v-2.89c.487-.222.883-.62 1.104-1.11h5.31c.22.49.662.888 1.103 1.11v2.89c0 .489.397.887.883.887a.886.886 0 0 0 .884-.887v-2.89c.486-.222.883-.62 1.104-1.11h5.31c.22.49.662.888 1.103 1.11v2.89c0 .489.396.887.883.887a.886.886 0 0 0 .883-.887v-2.89c.816-.359 1.342-1.07 1.342-2.003ZM4.985 1.775H20.02v8.885H4.985V1.775Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineManagedWirelessLan = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineManagedWirelessLan",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M20.951 16.283c-.845 0-1.566.56-1.907 1.284h-5.12c-.212-.472-.553-.9-1.057-1.114v-1.886h4.232c2.796 0 5.082-2.315 5.082-5.183 0-2.786-2.373-5.145-5.164-5.183C16.551 1.804 14.433 0 11.978 0 9.48 0 7.405 1.799 6.938 4.201c-2.795.044-5.082 2.358-5.082 5.183 0 2.824 2.287 5.183 5.12 5.183h4.19v1.93a2.148 2.148 0 0 0-1.057 1.07H5.026c-.336-.774-1.057-1.284-1.907-1.284-1.144 0-2.119.988-2.119 2.145 0 .855.553 1.585 1.268 1.93v2.786c0 .472.38.856.845.856a.852.852 0 0 0 .846-.856v-2.786a2.147 2.147 0 0 0 1.056-1.07h5.12c.212.473.591.856 1.02 1.07v2.786c0 .472.379.856.845.856a.852.852 0 0 0 .845-.856v-2.786a2.147 2.147 0 0 0 1.057-1.07h5.12c.212.473.59.856 1.019 1.07v2.786c0 .472.38.856.845.856a.852.852 0 0 0 .846-.856v-2.786c.764-.34 1.267-1.03 1.267-1.93.027-1.157-.904-2.145-2.048-2.145ZM6.94 12.856a3.454 3.454 0 0 1-3.387-3.472c0-1.93 1.523-3.472 3.43-3.472.168 0 .336 0 .51.044.509.088.975.258 1.397.516.38.257.932.17 1.187-.258.255-.384.168-.943-.255-1.201-.379-.258-.764-.428-1.186-.598.298-1.541 1.69-2.698 3.343-2.698 1.907 0 3.43 1.54 3.43 3.471 0 .34-.043.642-.125.988-.124.471.125.943.591 1.069.087.044.168.044.255.044.379 0 .72-.258.802-.598.086-.258.124-.472.168-.73 1.864.088 3.43 1.63 3.43 3.472a3.397 3.397 0 0 1-3.43 3.428H6.939v-.005Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineMap = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineMap",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M21.123 4.528C20.609 1.948 18.369 0 15.693 0c-2.677 0-4.916 1.948-5.43 4.528H0V24h24V4.528h-2.877Zm-5.43-2.72c2.038 0 3.693 1.728 3.693 3.85 0 1.432-2.027 5.043-3.693 7.623C14.027 10.707 12 7.09 12 5.658c0-2.122 1.654-3.85 3.693-3.85ZM1.843 9.897c.544.255.922.794.922 1.426v1.356c0 .047.006.093.012.14.307 1.947 2.103 2.469 3.55 2.886 1.738.505 2.441.823 2.441 1.96V19.2c0 .04 0 .081.006.128a4.692 4.692 0 0 0 1.164 2.863H1.843V9.896ZM22.157 22.19H14.31c-1.778 0-3.693-.991-3.693-3.17v-1.357c0-2.603-2.174-3.235-3.763-3.693-1.436-.417-2.098-.678-2.24-1.368v-1.281c0-1.64-1.193-3.015-2.77-3.328V6.342h8.383c.556 2.997 4.249 8.452 4.704 9.113.17.25.46.4.768.4.307 0 .596-.15.768-.4.449-.66 4.148-6.116 4.703-9.113h.992v15.85h-.005ZM18.12 5.206c0-1.316-1.093-2.383-2.428-2.383-1.341 0-2.429 1.073-2.429 2.383s1.088 2.382 2.429 2.382c1.341 0 2.428-1.066 2.428-2.382Zm-2.428 1.026c-.58 0-1.046-.458-1.046-1.026 0-.568.467-1.026 1.046-1.026s1.046.458 1.046 1.026c0 .568-.467 1.026-1.046 1.026Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineMask = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineMask",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M24 12c0-1.867-1.334-3.374-3.11-3.734v-.27c0-1.242-.98-2.222-2.223-2.222H5.333c-1.243 0-2.223.98-2.223 2.223v.269A3.779 3.779 0 0 0 0 12c0 1.867 1.334 3.374 3.11 3.734v.27c0 1.242.98 2.222 2.223 2.222h13.334c1.243 0 2.223-.98 2.223-2.223v-.269C22.666 15.374 24 13.862 24 12ZM1.78 12c0-.888.582-1.598 1.335-1.867v3.734A1.98 1.98 0 0 1 1.781 12Zm16.882 4.445c.226 0 .447-.226.447-.447V8.002c0-.226-.226-.447-.447-.447H5.328c-.226 0-.446.226-.446.447v7.996a.48.48 0 0 0 .446.447h13.334Zm2.228-2.583v-3.734c.753.269 1.334 1.022 1.334 1.867a2.026 2.026 0 0 1-1.334 1.867Zm-3.557-4.305H6.667a.685.685 0 0 0-.667.667c0 .355.312.667.667.667h10.666a.685.685 0 0 0 .667-.667.682.682 0 0 0-.667-.667Zm0 3.552H6.667a.685.685 0 0 0-.667.667c0 .355.312.667.667.667h10.666a.685.685 0 0 0 .667-.667.685.685 0 0 0-.667-.667Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineMast = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineMast",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M21.01 8.369a6.36 6.36 0 0 1-2.272 4.864.866.866 0 0 1-1.207-.098.843.843 0 0 1 .099-1.199 4.666 4.666 0 0 0 1.668-3.567 4.63 4.63 0 0 0-1.91-3.753.847.847 0 0 1-.175-1.192.862.862 0 0 1 1.201-.175c1.646 1.22 2.595 3.088 2.595 5.12Zm.252-6.481a.867.867 0 0 0-1.213-.006.852.852 0 0 0-.005 1.204 7.562 7.562 0 0 1 2.244 5.386 7.636 7.636 0 0 1-1.871 5.006.848.848 0 0 0 .647 1.405.841.841 0 0 0 .648-.294A9.33 9.33 0 0 0 24 8.472c.01-2.478-.966-4.82-2.738-6.584ZM1.717 8.472a7.57 7.57 0 0 1 2.245-5.386.842.842 0 0 0-.006-1.204.857.857 0 0 0-1.213.006A9.237 9.237 0 0 0 0 8.472a9.33 9.33 0 0 0 2.288 6.117.857.857 0 0 0 1.207.087.843.843 0 0 0 .088-1.198 7.67 7.67 0 0 1-1.866-5.006ZM5.602 3.25c-1.651 1.22-2.6 3.083-2.6 5.12a6.36 6.36 0 0 0 2.271 4.864.866.866 0 0 0 1.207-.098.843.843 0 0 0-.099-1.199A4.657 4.657 0 0 1 4.713 8.37c0-1.492.697-2.86 1.91-3.753a.848.848 0 0 0 .175-1.192.86.86 0 0 0-1.196-.175ZM12.005 1l3.43.85v14.068H12.86v7.232c0 .469-.384.85-.856.85a.854.854 0 0 1-.856-.85v-7.232H8.576V1.85l3.43-.85Zm-1.712 13.218h1.07V2.912l-1.07.267v11.04Zm3.424-11.04-1.07-.266v11.3h1.07V3.18Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineMenu = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineMenu",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M23 19H1a1 1 0 1 0 0 2h22a1 1 0 1 0 0-2Zm0-8H1a1 1 0 1 0 0 2h22a1 1 0 1 0 0-2Zm0-8H1a1 1 0 0 0 0 2h22a1 1 0 1 0 0-2Z"
        }
    ]
};

const O2LineMicrophone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineMicrophone",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M18.145 23.112c0 .49-.388.888-.866.888H7.737a.878.878 0 0 1-.866-.888c0-.489.389-.887.866-.887h3.903v-.956C8.465 20.83 6 18.043 6 14.669c0-.49.389-.888.866-.888s.866.398.866.888c0 2.697 2.142 4.887 4.768 4.887s4.768-2.196 4.768-4.887c0-.49.389-.888.866-.888s.866.398.866.888c0 3.374-2.459 6.162-5.64 6.6v.956h3.903a.88.88 0 0 1 .882.887Zm-9.758-8.665V4.222C8.387 1.855 10.197 0 12.506 0c2.309 0 4.118 1.855 4.118 4.222v10.225c0 2.367-1.81 4.222-4.118 4.222-2.31 0-4.12-1.855-4.12-4.222Zm1.732 0c0 1.394 1.027 2.446 2.387 2.446s2.386-1.052 2.386-2.446V4.222c0-1.394-1.026-2.447-2.386-2.447s-2.387 1.053-2.387 2.447v10.225Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineMinus",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M23 11H1a1 1 0 1 0 0 2h22a1 1 0 1 0 0-2Z"
        }
    ]
};

const O2LineMobileCoverage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineMobileCoverage",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M15.79 0H8.21C5.887 0 4 1.92 4 4.285v15.43C4 22.08 5.887 24 8.21 24h7.58c2.323 0 4.21-1.92 4.21-4.285V4.29C20 1.926 18.113 0 15.79 0ZM5.682 18.65V5.36h12.636v13.29H5.682ZM8.21 1.717h7.58c1.32 0 2.41 1.037 2.517 2.36H5.693c.108-1.323 1.196-2.36 2.517-2.36Zm7.58 20.577H8.21c-1.32 0-2.41-1.038-2.517-2.36h12.614c-.107 1.322-1.197 2.36-2.517 2.36Zm-4.701-9.405v3.38c0 .357-.28.642-.63.642a.634.634 0 0 1-.632-.642v-3.38c0-.357.28-.642.631-.642.35 0 .63.285.63.642Zm3.089-2.557v5.964c0 .357-.28.642-.63.642a.634.634 0 0 1-.632-.642v-5.964c0-.357.28-.642.631-.642.35 0 .63.285.63.642Zm3.089-2.579v8.543c0 .357-.28.642-.63.642a.634.634 0 0 1-.632-.642V7.753c0-.357.28-.642.631-.642.35 0 .63.285.63.642ZM8 15.03v1.262c0 .357-.28.642-.63.642a.634.634 0 0 1-.631-.642V15.03c0-.357.28-.642.63-.642s.631.29.631.642Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineMultiSim = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineMultiSim",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M21.168 6.077 15.792.687A2.371 2.371 0 0 0 14.132 0h-6.64a2.348 2.348 0 0 0-2.346 2.347V3h-.653a2.348 2.348 0 0 0-2.347 2.347V24h16.713V9.446c0-.614-.25-1.219-.682-1.656l-4.094-4.104A2.363 2.363 0 0 0 12.423 3h-5.57v-.653c0-.35.284-.633.634-.633h6.638a.62.62 0 0 1 .447.187l5.38 5.385a.64.64 0 0 1 .188.447v13.262a.858.858 0 1 0 1.718 0V7.738c0-.62-.254-1.224-.691-1.661ZM12.874 4.9l4.084 4.094a.66.66 0 0 1 .188.451v12.84H3.858V5.347c0-.35.283-.633.634-.633h7.934c.163 0 .327.067.447.187Zm2.985 7.416c0-.883-.72-1.603-1.603-1.603H6.744c-.883 0-1.603.72-1.603 1.603V21h10.713v-8.683h.005Zm-1.718 6.97H6.859v-6.86h7.287v6.86h-.005Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineMultiSave = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineMultiSave",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M4.296 4.452c0-.361.293-.65.659-.65h3.082c.366 0 .659.289.659.65 0 .361-.293.65-.66.65h-3.08a.652.652 0 0 1-.66-.65Zm5.34-.928a2.034 2.034 0 0 1-.613-1.456c0-.55.22-1.073.614-1.462A2.09 2.09 0 0 1 11.113 0c.557 0 1.087.217 1.481.606a2.034 2.034 0 0 1 0 2.912 2.09 2.09 0 0 1-1.476.606 2.098 2.098 0 0 1-1.481-.6Zm.71-1.462c0 .2.08.395.226.54a.79.79 0 0 0 1.087 0 .747.747 0 0 0 .225-.54.768.768 0 0 0-.772-.761c-.208 0-.4.077-.546.222a.775.775 0 0 0-.22.54Zm7.313 3.535a2.034 2.034 0 0 1 0 2.912c-.405.4-.94.6-1.476.6-.535 0-1.07-.2-1.476-.6a2.044 2.044 0 0 1 0-2.918 2.09 2.09 0 0 1 1.476-.605 2.165 2.165 0 0 1 1.476.611Zm-.71 1.462a.767.767 0 0 0-.772-.761c-.202 0-.4.077-.546.222a.754.754 0 0 0 0 1.072.78.78 0 0 0 1.087 0 .718.718 0 0 0 .231-.533ZM9.772 8.387a.66.66 0 0 0 .467.19.66.66 0 0 0 .468-.19l7.037-6.947a.645.645 0 0 0 0-.923.666.666 0 0 0-.936 0L9.766 7.465a.65.65 0 0 0 .006.922Zm1.217 10.416a.891.891 0 0 1-1.212.29c-.81-.49-1.769-.74-2.839-.74-2.079 0-4.18.806-4.18 2.607v2.173a.874.874 0 0 1-.88.867.874.874 0 0 1-.878-.867V20.96c0-1.745 1.138-3.13 2.969-3.83a4.07 4.07 0 0 1-1.211-2.896c0-2.273 1.876-4.124 4.18-4.124s4.18 1.851 4.18 4.124a4.073 4.073 0 0 1-1.267 2.952c.293.122.574.267.845.433a.846.846 0 0 1 .293 1.184Zm-4.051-2.195c1.335 0 2.423-1.073 2.423-2.39 0-1.318-1.088-2.39-2.423-2.39s-2.423 1.072-2.423 2.39c0 1.317 1.088 2.39 2.423 2.39ZM23 22.905a.874.874 0 0 1-.879.867.874.874 0 0 1-.879-.867c0-1.678-1.876-3.04-4.18-3.04s-4.18 1.362-4.18 3.04a.874.874 0 0 1-.88.867.874.874 0 0 1-.878-.867c0-1.829 1.217-3.385 3.053-4.19a4.081 4.081 0 0 1-1.29-2.974c0-2.274 1.876-4.124 4.18-4.124 2.305 0 4.18 1.85 4.18 4.124a4.081 4.081 0 0 1-1.29 2.973C21.784 19.52 23 21.076 23 22.905Zm-5.944-4.774c1.335 0 2.423-1.073 2.423-2.39 0-1.318-1.087-2.39-2.423-2.39-1.335 0-2.422 1.072-2.422 2.39 0 1.317 1.093 2.39 2.422 2.39Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineMusic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineMusic",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M23.935.863a.901.901 0 0 0-.345-.69.837.837 0 0 0-.777-.13L7.68 4.368a.832.832 0 0 0-.647.82v11.025a4.18 4.18 0 0 0-2.594-.864 4.333 4.333 0 0 0-4.32 4.32C.117 22.045 2.054 24 4.432 24a4.334 4.334 0 0 0 4.32-4.32V5.84L22.16 1.99v10.334a4.18 4.18 0 0 0-2.594-.864 4.334 4.334 0 0 0-4.32 4.321 4.337 4.337 0 0 0 4.32 4.32 4.337 4.337 0 0 0 4.32-4.32c.048-.043.048-14.918.048-14.918ZM4.476 22.27a2.602 2.602 0 0 1-2.594-2.594 2.605 2.605 0 0 1 2.594-2.595 2.605 2.605 0 0 1 2.594 2.595 2.602 2.602 0 0 1-2.594 2.594Zm15.134-3.894a2.602 2.602 0 0 1-2.594-2.594 2.605 2.605 0 0 1 2.594-2.594 2.605 2.605 0 0 1 2.594 2.594 2.602 2.602 0 0 1-2.594 2.594Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineMute = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineMute",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "m23.744 22.514-6.947-6.948V1.31A.875.875 0 0 0 15.48.557L6.84 5.612 1.49.256A.873.873 0 0 0 .256 1.49l14.8 14.802v5.317L4.807 15.61a.87.87 0 0 0-.441-.117H2.182V8.947h2.184a.872.872 0 0 0 0-1.743H1.31a.872.872 0 0 0-.871.871v8.29c0 .48.39.87.871.87h2.82l11.36 6.648a.885.885 0 0 0 .876 0 .875.875 0 0 0 .441-.76V18.03l5.708 5.709c.173.173.39.256.614.256a.85.85 0 0 0 .614-.256.86.86 0 0 0 0-1.224ZM8.124 6.891l6.93-4.055v10.987l-6.93-6.932Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineMyO2 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineMyO2",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M6.216 24h11.549a6.218 6.218 0 0 0 6.216-6.22V6.23A6.223 6.223 0 0 0 17.765.014H6.216A6.224 6.224 0 0 0 0 6.235v11.549A6.223 6.223 0 0 0 6.216 24ZM1.776 6.23a4.445 4.445 0 0 1 4.44-4.44v.005h11.549a4.445 4.445 0 0 1 4.44 4.44V17.78a4.445 4.445 0 0 1-4.44 4.44H6.216a4.445 4.445 0 0 1-4.44-4.44V6.23Zm5.338 4.959c0 2.712 1.972 4.968 4.838 4.968 2.846 0 4.82-2.251 4.82-4.968 0-2.885-1.935-4.968-4.82-4.968-2.9.005-4.838 2.088-4.838 4.968Zm1.862 0c0-1.805 1.1-3.552 2.976-3.552 1.862 0 2.957 1.752 2.957 3.552 0 1.694-.912 3.552-2.957 3.552-2.064.005-2.976-1.853-2.976-3.552Zm10.397 6.437v.662h-2.794v-.7a9.75 9.75 0 0 1 .214-.201c.541-.5 1.6-1.48 1.6-2.142 0-.384-.345-.567-.686-.567-.355 0-.696.154-.97.336l-.067-.696a2.777 2.777 0 0 1 1.248-.302c.802 0 1.32.398 1.32 1.224 0 .837-.785 1.607-1.449 2.258l-.13.128h1.714Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineNetworkStatus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineNetworkStatus",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M19.498 20.314c.172.13.384.216.6.216a.834.834 0 0 0 .6-.26C22.843 18 24 15.086 24 12c0-6.6-5.4-12-12-12S0 5.4 0 12c0 3.086 1.157 6 3.298 8.227a.828.828 0 0 0 1.2.043.828.828 0 0 0 .043-1.2A10.151 10.151 0 0 1 1.714 12c0-5.66 4.622-10.286 10.281-10.286 5.66 0 10.287 4.632 10.287 10.286 0 2.66-.984 5.14-2.828 7.114a.873.873 0 0 0 .044 1.2ZM6.34 18.082a.932.932 0 0 1-.643-.26A8.553 8.553 0 0 1 3.422 12C3.427 7.282 7.282 3.427 12 3.427S20.573 7.282 20.573 12a8.574 8.574 0 0 1-2.27 5.827c-.341.341-.86.389-1.2.043-.341-.34-.39-.859-.044-1.2A6.761 6.761 0 0 0 18.902 12c0-3.768-3.086-6.854-6.854-6.854-3.768 0-6.86 3.086-6.86 6.854 0 1.757.644 3.389 1.844 4.67a.829.829 0 0 1-.043 1.2.978.978 0 0 1-.648.212Zm8.313-2.612c.168.13.341.216.557.216.26 0 .475-.086.639-.302.81-.946 1.286-2.146 1.286-3.389 0-2.827-2.309-5.14-5.136-5.14s-5.14 2.313-5.14 5.14c0 1.248.47 2.448 1.286 3.389a.864.864 0 0 0 1.2.086.866.866 0 0 0 .086-1.2 3.484 3.484 0 0 1-.86-2.27A3.435 3.435 0 0 1 12 8.573 3.435 3.435 0 0 1 15.427 12a3.41 3.41 0 0 1-.859 2.27c-.302.341-.254.898.086 1.2Zm-3.513 7.67c0 .471.384.86.859.86.47 0 .86-.389.86-.86V12c0-.47-.39-.86-.86-.86s-.86.385-.86.86v11.14Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineNetworking = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineNetworking",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M18.437 12.854c-.235 0-.456.02-.682.048L15.85 9.6a5.547 5.547 0 0 0 1.728-4.022A5.572 5.572 0 0 0 12.01.01a5.556 5.556 0 0 0-5.578 5.553c0 1.584.672 3.015 1.728 4.023l-1.906 3.302a5.298 5.298 0 0 0-.681-.048A5.597 5.597 0 0 0 0 18.432 5.566 5.566 0 0 0 5.568 24c2.78 0 5.083-2.05 5.5-4.714h1.858C13.344 21.95 15.648 24 18.427 24a5.572 5.572 0 0 0 5.568-5.568c0-3.072-2.486-5.578-5.558-5.578ZM10.06 8.9v-.144c0-.73.816-1.253 1.944-1.253 1.128 0 1.973.533 1.973 1.253v.125a3.768 3.768 0 0 1-1.973.542A3.91 3.91 0 0 1 10.06 8.9Zm.873-3.763c0-.595.476-1.07 1.07-1.07.596 0 1.071.475 1.071 1.07 0 .595-.475 1.07-1.07 1.07a1.06 1.06 0 0 1-1.07-1.07Zm1.07-3.432a3.863 3.863 0 0 1 3.86 3.86c0 .863-.293 1.67-.778 2.313-.225-.533-.662-.97-1.243-1.263.331-.408.523-.912.523-1.478 0-1.3-1.06-2.362-2.361-2.362a2.366 2.366 0 0 0-2.362 2.362c0 .562.192 1.08.523 1.478-.58.303-1.012.74-1.233 1.282a3.857 3.857 0 0 1-.797-2.333c.01-2.117 1.738-3.859 3.869-3.859ZM9.57 10.58a5.51 5.51 0 0 0 2.429.562c.874 0 1.69-.207 2.429-.562l1.622 2.818a5.588 5.588 0 0 0-3.13 4.18h-1.857a5.588 5.588 0 0 0-3.13-4.18L9.57 10.58ZM3.624 21.754v-.144c0-.73.816-1.253 1.944-1.253 1.128 0 1.973.533 1.973 1.253v.124a3.768 3.768 0 0 1-1.973.543c-.71.014-1.368-.192-1.944-.523Zm.874-3.75c0-.594.475-1.07 1.07-1.07.595 0 1.07.476 1.07 1.07 0 .596-.475 1.071-1.07 1.071-.595 0-1.07-.49-1.07-1.07Zm4.152 2.742c-.226-.533-.663-.97-1.244-1.263a2.31 2.31 0 0 0 .524-1.478 2.366 2.366 0 0 0-2.362-2.362 2.367 2.367 0 0 0-2.362 2.362 2.3 2.3 0 0 0 .524 1.478c-.581.303-1.013.74-1.234 1.282a3.857 3.857 0 0 1-.797-2.333 3.863 3.863 0 0 1 3.86-3.86 3.868 3.868 0 0 1 3.868 3.86c0 .864-.293 1.66-.777 2.314Zm7.833 1.008v-.144c0-.73.816-1.253 1.944-1.253 1.128 0 1.973.533 1.973 1.253v.124a3.768 3.768 0 0 1-1.973.543 3.745 3.745 0 0 1-1.944-.523Zm.874-3.75c0-.594.475-1.07 1.07-1.07.595 0 1.07.476 1.07 1.07 0 .596-.475 1.071-1.07 1.071a1.084 1.084 0 0 1-1.07-1.07Zm4.161 2.742c-.225-.533-.662-.97-1.243-1.263.331-.408.523-.912.523-1.478a2.366 2.366 0 0 0-2.361-2.362 2.366 2.366 0 0 0-2.362 2.362c0 .561.192 1.08.523 1.478-.58.303-1.012.74-1.233 1.282a3.857 3.857 0 0 1-.797-2.333 3.86 3.86 0 0 1 7.718 0c.01.864-.283 1.66-.768 2.314Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineNew = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineNew",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M23.751.25a.852.852 0 0 0-1.205 0L21.09 1.704H10.223a2.54 2.54 0 0 0-1.804.747L.747 10.124A2.528 2.528 0 0 0 0 11.928c0 .682.267 1.325.747 1.805l9.52 9.52c.496.496 1.15.747 1.805.747.654 0 1.309-.25 1.805-.747l7.666-7.666a2.528 2.528 0 0 0 .747-1.805V2.91l1.456-1.456A.847.847 0 0 0 23.75.25ZM20.59 13.776a.845.845 0 0 1-.251.605l-7.666 7.666a.852.852 0 0 1-1.205 0l-9.515-9.52a.855.855 0 0 1-.25-.6c0-.223.086-.441.25-.605l7.666-7.666a.855.855 0 0 1 .6-.25h9.166l-1.096 1.106a.852.852 0 0 0 .6 1.456.829.829 0 0 0 .6-.25l1.1-1.102v9.16Zm-2.765-2.274c-2.868 0-5.114-2.339-5.114-5.327a.635.635 0 0 0-.638-.638.635.635 0 0 0-.638.638c0 2.988-2.246 5.327-5.115 5.327a.635.635 0 0 0-.637.638c0 .354.283.638.637.638 3.01 0 5.115 2.012 5.115 4.896 0 .355.284.638.638.638a.635.635 0 0 0 .638-.638c0-2.884 2.104-4.896 5.114-4.896a.639.639 0 0 0 0-1.276Zm-5.752 3.348a5.858 5.858 0 0 0-2.874-2.754 6.38 6.38 0 0 0 2.874-2.993 6.38 6.38 0 0 0 2.873 2.994 5.858 5.858 0 0 0-2.873 2.753Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineNewsletter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineNewsletter",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M6.18 15.556h5.37V10.67H6.18v4.887ZM7.525 12h2.686v2.225H7.525V12Zm10.066.888c0 .37-.297.665-.67.665h-3.578a.665.665 0 1 1 0-1.331h3.578c.367 0 .67.302.67.666ZM6.18 21.338h5.37v-4.889H6.18v4.888Zm1.345-3.557h2.686v2.225H7.525V17.78Zm10.066 1.331c0 .37-.297.666-.67.666h-3.578a.665.665 0 1 1 0-1.331h3.578c.367 0 .67.296.67.665ZM3.5 0v24h17V0h-17Zm15.208 8.444H5.286V4.222h13.422v4.222Zm0-6.669v1.11H5.286v-1.11h13.422Zm0 17.337v3.113H5.286V9.775h13.422v9.338Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineNext = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineNext",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M6.475 24a.842.842 0 0 1-.6-.26.832.832 0 0 1 0-1.2L16.421 12 5.875 1.46a.832.832 0 0 1 0-1.2.83.83 0 0 1 1.2 0L18.216 11.4c.34.34.34.86 0 1.2L7.076 23.74a.834.834 0 0 1-.6.26Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineNotification = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineNotification",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M22.973 18.773a12.126 12.126 0 0 1-2.4-7.2v-3C20.573 3.859 16.713 0 12 0 7.286 0 3.427 3.86 3.427 8.573v3c0 2.573-.86 5.14-2.4 7.2-.216.259-.216.6-.086.902.13.303.427.47.773.47h6.902c0 .13-.043.303-.043.428A3.435 3.435 0 0 0 12 24a3.435 3.435 0 0 0 3.427-3.427c0-.13 0-.303-.043-.427h6.898c.34 0 .643-.173.772-.47.13-.298.13-.649-.081-.903Zm-9.26 1.8A1.72 1.72 0 0 1 12 22.286a1.72 1.72 0 0 1-1.714-1.713c0-.13 0-.303.043-.427h3.298c.086.124.086.297.086.427Zm-10.41-2.146a13.713 13.713 0 0 0 1.843-6.859v-3c0-3.773 3.086-6.86 6.859-6.86 3.772 0 6.854 3.092 6.854 6.865v3c0 2.4.643 4.8 1.843 6.859h-17.4v-.005Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineO2Angels = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineO2Angels",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M12 4.005c.98 0 5.874-.097 5.874-2.003C17.874.097 12.98 0 12 0c-.98 0-5.874.097-5.874 2.002 0 1.906 4.894 2.003 5.874 2.003Zm0-2.668c2.31 0 3.825.38 4.387.665-.562.285-2.077.666-4.387.666-2.31 0-3.825-.381-4.387-.666.562-.284 2.077-.665 4.387-.665Zm3.641 14.75a6.266 6.266 0 0 0 2.45-4.977c0-3.43-2.734-6.224-6.091-6.224S5.91 7.68 5.91 11.11a6.25 6.25 0 0 0 2.449 4.977C4.729 17.18 2.14 19.86 2 23.073a.882.882 0 0 0 .83.927h.038a.882.882 0 0 0 .869-.848c.14-3.208 3.841-5.813 8.262-5.813 4.415 0 8.123 2.61 8.262 5.813a.878.878 0 0 0 .869.848h.038a.882.882 0 0 0 .83-.927c-.14-3.214-2.728-5.894-6.358-6.986Zm-7.99-4.972c0-2.451 1.95-4.442 4.349-4.442 2.4 0 4.348 1.99 4.348 4.442S14.4 15.558 12 15.558s-4.348-1.996-4.348-4.443Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineOffers = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineOffers",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M23.751.25a.852.852 0 0 0-1.205 0L21.09 1.704H10.223a2.54 2.54 0 0 0-1.804.747L.747 10.124A2.528 2.528 0 0 0 0 11.928c0 .682.267 1.325.747 1.805l9.52 9.52c.496.496 1.15.747 1.805.747.654 0 1.309-.25 1.805-.747l7.666-7.666a2.528 2.528 0 0 0 .747-1.805V2.91l1.456-1.456A.847.847 0 0 0 23.75.25ZM20.59 13.776a.845.845 0 0 1-.251.605l-7.666 7.666a.852.852 0 0 1-1.205 0l-9.515-9.52a.855.855 0 0 1-.25-.6c0-.223.086-.441.25-.605l7.666-7.666a.855.855 0 0 1 .6-.25h9.166l-1.096 1.106a.852.852 0 0 0 .6 1.456.829.829 0 0 0 .6-.25l1.1-1.102v9.16Zm-9.095.709h3.239a.85.85 0 1 1 .006 1.7H9.41a.852.852 0 0 1 0-1.7.42.42 0 0 0 .425-.426v-1.7a.852.852 0 0 1 0-1.702V9.17a2.774 2.774 0 0 1 2.77-2.77c.633 0 1.249.218 1.74.616.365.3.42.834.125 1.2a.856.856 0 0 1-1.2.125 1.068 1.068 0 0 0-1.733.829v1.488h1.7a.852.852 0 0 1 0 1.701h-1.7v1.701c0 .147-.017.29-.044.426Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineOfficeSmall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineOfficeSmall",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M20.118 4H3.877A.883.883 0 0 0 3 4.887v19.107h4.389v-6.66h2.636V24H21V4.887A.888.888 0 0 0 20.118 4Zm-8.34 18.22v-6.667H5.63v6.667h-.877V5.775h14.488V22.22h-7.463Zm.877-2.668h5.71v-4h-5.71v4Zm1.315-2.662h3.074v1.33H13.97v-1.33Zm-2.63-5.558H5.63V7.333h5.71v4Zm-1.321-2.668H6.945v1.331h3.074v-1.33Zm2.636 2.668h5.71V7.333h-5.71v4Zm1.315-2.668h3.074v1.331H13.97v-1.33Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineOfficeLarge = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineOfficeLarge",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M20.118 0H3.877A.875.875 0 0 0 3 .871v23.123h4.389v-6.538h2.197V24H21V.877A.881.881 0 0 0 20.118 0Zm-.877 22.252H11.34v-6.544H5.63v6.544h-.877V1.748h14.488v20.504ZM5.63 13.307h5.71V9.38H5.63v3.926Zm1.315-2.614h3.074V12H6.945v-1.307Zm5.71 2.614h5.71V9.38h-5.71v3.926Zm1.315-2.614h3.074V12H13.97v-1.307Zm-1.315 8.94h5.71v-3.925h-5.71v3.925Zm1.315-2.619h3.074v1.307H13.97v-1.307Zm-8.34-9.81h5.71V3.271H5.63v3.931Zm1.315-2.62h3.074v1.307H6.945V4.584Zm5.71 2.62h5.71V3.271h-5.71v3.931Zm1.315-2.62h3.074v1.307H13.97V4.584Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LinePackage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LinePackage",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M12.5 0 2 6.116v11.763L12.5 24 23 17.884V6.116L12.5 0Zm0 11.012L9.174 9.157 17.07 4.67l3.332 1.937-7.902 4.405Zm2.84-7.352L7.403 8.17 4.598 6.606 12.5 2.004l2.84 1.656ZM3.752 8.114l7.873 4.388v8.981l-7.873-4.587V8.114Zm9.62 13.369v-8.98l7.874-4.389v8.782l-7.873 4.587Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineParking = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineParking",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M8.447 20a.889.889 0 0 1-.887-.887V4.005h5.336a4.893 4.893 0 0 1 4.886 4.886 4.897 4.897 0 0 1-4.886 4.887H9.34v5.335a.897.897 0 0 1-.893.888Zm.888-7.997h3.555a3.112 3.112 0 0 0 0-6.223H9.335v6.223ZM21.338 24H2.668A2.672 2.672 0 0 1 0 21.332V2.668A2.672 2.672 0 0 1 2.668 0h18.664A2.672 2.672 0 0 1 24 2.668v18.664A2.667 2.667 0 0 1 21.338 24ZM2.668 1.78a.889.889 0 0 0-.887.888v18.664c0 .49.398.887.887.887h18.664c.49 0 .887-.398.887-.887V2.668a.889.889 0 0 0-.887-.887H2.668Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LinePause = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LinePause",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M12 24C5.386 24 0 18.62 0 12S5.386 0 12 0s12 5.386 12 12-5.386 12-12 12Zm0-22.283C6.33 1.717 1.717 6.329 1.717 12c0 5.67 4.612 10.283 10.283 10.283 5.67 0 10.283-4.612 10.283-10.283 0-5.67-4.612-10.283-10.283-10.283ZM9.856 17.144V6.856a.857.857 0 0 0-1.712 0v10.283a.857.857 0 0 0 1.712.005Zm6 0V6.856a.857.857 0 0 0-1.712 0v10.283a.857.857 0 0 0 1.712.005Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LinePenTest = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LinePenTest",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "m14.833 7.621-4.542 4.463-1.547-1.515a.845.845 0 0 0-1.201 0 .81.81 0 0 0 0 1.18l2.743 2.695 5.743-5.642a.81.81 0 0 0 0-1.18.834.834 0 0 0-1.196 0Zm7.028 8.59s0-.043 0 0V6.528C21.86 5.137 20.703 4 19.288 4H4.718C3.302 4 2.145 5.137 2.145 6.527v9.685H0v.63C0 18.61 1.328 20 3 20h17.873C22.585 20 24 18.567 24 16.842v-.63h-2.14Zm-18-9.684a.85.85 0 0 1 .857-.84h14.57a.85.85 0 0 1 .855.84v9.685H3.863V6.527ZM20.874 18.74H3.001c-.774 0-1.416-.507-1.63-1.261h21.22c-.259.711-.944 1.261-1.718 1.261Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LinePerson = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LinePerson",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M16.194 14.585a7.954 7.954 0 0 0 3.584-6.66C19.778 3.554 16.29 0 12 0 7.71 0 4.222 3.554 4.222 7.925a7.953 7.953 0 0 0 3.585 6.66C3.203 15.843 0 19.136 0 23.096c0 .5.398.905.888.905a.897.897 0 0 0 .887-.904c0-3.995 4.586-7.247 10.225-7.247 5.639 0 10.225 3.252 10.225 7.247 0 .498.398.904.887.904.49 0 .888-.406.888-.904 0-3.96-3.203-7.252-7.806-8.51ZM5.997 7.925c0-3.374 2.691-6.116 6.003-6.116 3.312 0 6.003 2.742 6.003 6.116 0 3.374-2.691 6.11-6.003 6.11-3.312 0-6.003-2.742-6.003-6.11Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LinePlanReportChart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LinePlanReportChart",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M18.908 1.29h-2.16V0H7.252v1.284h-2.16C3.666 1.284 2.5 2.44 2.5 3.856V24h19V3.862c0-1.415-1.166-2.573-2.592-2.573Zm-10.406 0h6.952v2.144H8.502V1.29ZM19.77 22.287H4.23V12.43h.862c.215 0 .475-.126.564-.34l1.553-2.87 2.934 5.014a.628.628 0 0 0 .564.302.739.739 0 0 0 .563-.302l2.2-3.768.95 1.629c.172.214.387.34.603.34h1.724a.664.664 0 0 0 .647-.642.664.664 0 0 0-.647-.642H15.41l-1.338-2.276a.747.747 0 0 0-.563-.302.74.74 0 0 0-.564.302l-2.2 3.774-2.978-5.058a.628.628 0 0 0-.564-.301c-.221 0-.431.126-.564.34l-1.934 3.516H4.23V3.862a.86.86 0 0 1 .862-.856h2.16v1.712h9.5V3h2.156a.86.86 0 0 1 .862.855V22.29Zm-2.807-4.712H7.037a.664.664 0 0 0-.646.642c0 .34.304.642.646.642h9.931a.664.664 0 0 0 .647-.642.665.665 0 0 0-.652-.642Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LinePlanReport = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LinePlanReport",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M16.963 14.148H7.037a.664.664 0 0 0-.646.642c0 .34.304.641.646.641h9.931a.664.664 0 0 0 .647-.641.665.665 0 0 0-.652-.642Zm0-3.429H7.037a.664.664 0 0 0-.646.642c0 .34.304.642.646.642h9.931a.664.664 0 0 0 .647-.642.665.665 0 0 0-.652-.642Zm0-3.428H7.037a.664.664 0 0 0-.646.641c0 .34.304.642.646.642h9.931a.664.664 0 0 0 .647-.642.665.665 0 0 0-.652-.641Zm0 10.285H7.037a.664.664 0 0 0-.646.642c0 .34.304.642.646.642h9.931a.664.664 0 0 0 .647-.642.665.665 0 0 0-.652-.642ZM18.908 1.29h-2.16V0H7.252v1.284h-2.16C3.666 1.284 2.5 2.44 2.5 3.856V24h19V3.862c0-1.415-1.166-2.573-2.592-2.573Zm-10.406 0h6.952v2.145H8.502V1.29Zm11.268 21H4.23V3.861a.86.86 0 0 1 .862-.856h2.16v1.712h9.5V3h2.156a.86.86 0 0 1 .862.855V22.29Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LinePlasticSim = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LinePlasticSim",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M21.427 24H2.573V2.573A2.578 2.578 0 0 1 5.14 0h9.13a2.4 2.4 0 0 1 1.8.773l4.583 4.584c.47.47.773 1.113.773 1.8V24Zm-17.14-1.714h15.427V7.156a.842.842 0 0 0-.26-.6l-4.54-4.583a.868.868 0 0 0-.644-.26H5.14a.861.861 0 0 0-.858.86v19.713h.004ZM18 20.573H6V10.286c0-.94.773-1.713 1.714-1.713h8.572c.941 0 1.714.773 1.714 1.713v10.287ZM7.714 18.859h8.572v-8.573H7.714v8.573Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LinePlay2 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LinePlay2",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M3.763 24c-.47 0-.945-.13-1.373-.384-.772-.427-1.2-1.2-1.2-2.06V2.477c0-.858.47-1.67 1.287-2.102.854-.47 1.843-.513 2.659-.038L21.552 9.85a2.441 2.441 0 0 1 1.243 1.886 2.453 2.453 0 0 1-.816 2.102c-.043.044-.086.087-.13.087L5.094 23.659a2.84 2.84 0 0 1-1.33.341ZM3.85 1.704c-.173 0-.341.043-.514.13-.13.086-.427.302-.427.643v19.08c0 .302.216.47.34.557.26.13.644.216.985.043l16.675-9.648c.13-.173.216-.384.216-.6a.758.758 0 0 0-.384-.6L4.234 1.79a1.263 1.263 0 0 0-.384-.086Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LinePlay = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LinePlay",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M12 24C5.386 24 0 18.62 0 12S5.386 0 12 0s12 5.386 12 12-5.386 12-12 12Zm0-22.283C6.33 1.717 1.717 6.329 1.717 12c0 5.67 4.612 10.283 10.283 10.283 5.67 0 10.283-4.612 10.283-10.283 0-5.67-4.612-10.283-10.283-10.283ZM8.358 18.856A.852.852 0 0 1 7.502 18V6a.85.85 0 0 1 .429-.74.85.85 0 0 1 .86.005l10.284 5.995a.857.857 0 0 1 0 1.48l-10.283 6a.884.884 0 0 1-.434.116Zm.856-11.364v9.01L16.942 12 9.214 7.492Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LinePortal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LinePortal",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M21.86 16.147V6.117c0-1.44-1.151-2.617-2.572-2.617H4.718c-1.416 0-2.573 1.172-2.573 2.618v4.14H.647a.645.645 0 0 0-.642.654c0 .362.286.653.642.653h1.498v4.576H0v.87C0 18.938 1.536 20.5 3.429 20.5H20.57c1.893 0 3.429-1.563 3.429-3.488v-.87h-2.14v.005ZM3.863 11.57h7.663l-1.69 1.72a.662.662 0 0 0 0 .926.639.639 0 0 0 .911 0l3.243-3.299-3.25-3.297a.635.635 0 0 0-.91 0 .662.662 0 0 0 0 .926l1.689 1.72H3.862V6.122c0-.48.384-.87.856-.87h14.57c.471 0 .855.39.855.87v10.03H3.863V11.57Zm16.71 7.194H3.433c-.63 0-1.185-.351-1.487-.87h20.111c-.296.519-.85.87-1.487.87Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LinePosition = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LinePosition",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M12 24a.802.802 0 0 1-.667-.312c-.312-.355-7.56-8.4-7.56-14.846C3.778 3.864 7.378 0 12 0s8.223 3.864 8.223 8.842c0 6.441-7.244 14.534-7.556 14.846A.808.808 0 0 1 12 24Zm0-22.22c-3.686 0-6.441 3.025-6.441 7.066 0 4.71 4.665 10.8 6.441 12.888 1.78-2.13 6.442-8.179 6.442-12.888 0-4.046-2.755-7.065-6.442-7.065Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LinePower = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LinePower",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M11.016 12.825c0 .5.437.913.97.913.532 0 .97-.413.97-.912V.964c0-.5-.438-.912-.97-.912-.533 0-.97.413-.97.912v11.86Zm-10.92 0C.096 18.985 5.438 24 11.986 24c6.552 0 11.89-5.02 11.894-11.175 0-4.833-3.302-9.124-8.203-10.627-.485-.139-1.07.135-1.215.59-.144.457.144 1.009.63 1.143 4.08 1.277 6.844 4.834 6.844 8.895 0 5.155-4.464 9.35-9.95 9.35-5.487 0-9.95-4.195-9.95-9.35 0-4.061 2.769-7.623 6.849-8.895a.9.9 0 0 0 .629-1.142c-.144-.5-.73-.725-1.215-.59C3.394 3.7.096 7.986.096 12.825Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LinePreOrder = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LinePreOrder",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M10.79 4.128a.664.664 0 0 0-.648-.648h-.648a4.69 4.69 0 0 1 2.727-1.992c2.553-.691 5.15.82 5.846 3.38a4.563 4.563 0 0 1-.475 3.594c-.648 1.085-1.646 1.906-2.9 2.208-2.553.691-5.15-.82-5.846-3.379a8.013 8.013 0 0 1-.172-1.085.664.664 0 0 0-.648-.648.664.664 0 0 0-.648.648c0 .476.086.95.216 1.388.734 2.683 3.163 4.502 5.846 4.502.518 0 1.037-.087 1.56-.216a6.183 6.183 0 0 0 3.681-2.813 5.86 5.86 0 0 0 .605-4.589C18.451 1.268 15.12-.638 11.913.23a5.993 5.993 0 0 0-3.201 2.122V2.05a.664.664 0 0 0-.648-.648.664.664 0 0 0-.648.648v2.726h2.726a.664.664 0 0 0 .648-.648Zm13.032-.22c.13-.476-.172-.951-.604-1.038-.476-.13-.95.173-1.037.605l-2.64 9.96H6.979L4.032 1.785C3.902.923 2.86.226 1.738.226H.917a.867.867 0 0 0-.864.865c0 .475.389.864.864.864h.82c.26 0 .519.13.605.216l4.076 16.07a2.994 2.994 0 0 0-1.82 2.77c0 .82.303 1.56.908 2.121a3.02 3.02 0 0 0 2.121.864 3.01 3.01 0 0 0 3.029-3.029c0-.475-.087-.907-.303-1.3h6.236c-.173.388-.303.82-.303 1.3a3.01 3.01 0 0 0 3.03 3.03c.82 0 1.56-.303 2.164-.908a3.02 3.02 0 0 0 .864-2.122 3.01 3.01 0 0 0-3.029-3.029H8.102v-.13l-.69-2.682h13.42l2.99-11.218ZM7.627 22.31c-.345 0-.691-.13-.907-.388-.26-.216-.389-.562-.389-.908 0-.734.562-1.3 1.3-1.3.347 0 .692.13.908.388.26.26.389.562.389.907 0 .74-.566 1.301-1.3 1.301Zm12.6-.388c.26-.26.389-.562.389-.908 0-.739-.562-1.3-1.3-1.3-.346 0-.649.13-.908.388-.26.26-.389.562-.389.907 0 .74.567 1.301 1.3 1.301.347 0 .649-.13.908-.388ZM12.825 2.784c0-.346.303-.648.649-.648.345 0 .647.302.647.648v3.034l1.43 1.516a.668.668 0 0 1-.042.908.555.555 0 0 1-.432.172.694.694 0 0 1-.476-.216l-1.776-1.862V2.784Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LinePrevious = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LinePrevious",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M17.616 24a.842.842 0 0 0 .6-.26.833.833 0 0 0 0-1.2L7.67 12 18.216 1.46a.833.833 0 0 0 0-1.2.832.832 0 0 0-1.2 0L5.876 11.4a.83.83 0 0 0 0 1.2l11.14 11.14a.83.83 0 0 0 .6.26Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LinePricingCreditBalance = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LinePricingCreditBalance",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M22.899 16.75a2.117 2.117 0 0 0-2.018-1.455c-.378 0-.75.1-1.066.285l-2.773 1.606a2.198 2.198 0 0 0-2.07-1.454H8.609l-.902-.538a2.612 2.612 0 0 0-1.319-.335H.88a.877.877 0 0 0-.879.873c0 .48.395.872.88.872h2.643v4.37a.877.877 0 0 1-.88.872H.88a.877.877 0 0 0-.88.874c0 .481.395.873.88.873h1.758c.778 0 1.483-.342 1.962-.873h2.78l4.853 1.197a2.634 2.634 0 0 0 1.979-.268l7.69-4.403c.884-.51 1.307-1.556.997-2.495Zm-1.883.984-7.684 4.403a.903.903 0 0 1-.67.09l-5.069-1.248h-2.31v-4.37H6.38c.175 0 .322.034.429.096l1.308.778h6.85c.242 0 .439.195.439.436 0 .24-.197.436-.44.436h-4.842a.877.877 0 0 0-.88.873c0 .481.395.873.88.873h4.842c.524 0 .998-.19 1.376-.493l4.357-2.523a.361.361 0 0 1 .519.213c.056.15-.04.341-.203.436Zm-9.127-3.748c3.89 0 7.047-3.133 7.047-6.993 0-3.86-3.157-6.993-7.047-6.993C8 0 4.842 3.133 4.842 6.993c0 3.86 3.157 6.993 7.047 6.993Zm0-12.24c2.915 0 5.288 2.355 5.288 5.247s-2.373 5.248-5.288 5.248c-2.914 0-5.288-2.356-5.288-5.248 0-2.892 2.374-5.248 5.288-5.248ZM9.465 9.61c0-.363.293-.654.66-.654.124 0 .22-.095.22-.219v-1.09a.654.654 0 1 1 0-1.31v-1.09c0-1.086.89-1.97 1.984-1.97.547 0 1.071.224 1.443.621a.657.657 0 0 1-.028.929.67.67 0 0 1-.936-.028.658.658 0 0 0-1.139.448v1.09h1.1a.654.654 0 1 1 0 1.31h-1.1v1.09c0 .073-.005.146-.017.219h2.216a.654.654 0 1 1 0 1.309h-3.743a.654.654 0 0 1-.66-.655Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LinePrinter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LinePrinter",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M24 7.286a2.58 2.58 0 0 0-2.573-2.572h-3V.427H5.573v4.287h-3A2.58 2.58 0 0 0 0 7.286v11.141h5.573v5.141h12.859v-5.14H24V7.285ZM7.286 2.141h9.428v2.573H7.286V2.14Zm9.428 19.718H7.286v-8.573h9.428v8.573Zm5.572-5.145h-3.859v-5.141H5.573v5.14h-3.86V7.287c0-.47.385-.859.86-.859h18.859c.47 0 .86.384.86.86v9.427h-.006Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LinePriorityTickets = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LinePriorityTickets",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M8.837 24a.838.838 0 0 1-.603-.252l-2.89-2.89a.86.86 0 0 1-.253-.604c0-.225.088-.444.252-.603a.692.692 0 0 0 .203-.494.695.695 0 0 0-1.19-.494.858.858 0 0 1-1.213 0l-2.89-2.89A.86.86 0 0 1 0 15.17c0-.225.088-.444.252-.603L14.56.252A.86.86 0 0 1 15.163 0a.84.84 0 0 1 .603.252l2.89 2.89a.857.857 0 0 1 0 1.213.695.695 0 0 0 0 .987.716.716 0 0 0 .988 0 .878.878 0 0 1 1.213 0l2.89 2.89a.86.86 0 0 1 .253.603.838.838 0 0 1-.252.604L9.446 23.748a.873.873 0 0 1-.609.252ZM7.05 20.144l1.788 1.788L21.932 8.835l-1.788-1.787a2.422 2.422 0 0 1-.993.208 2.4 2.4 0 0 1-1.706-.708 2.406 2.406 0 0 1-.494-2.692l-1.783-1.783L2.074 15.165l1.788 1.788a2.423 2.423 0 0 1 2.693.493 2.4 2.4 0 0 1 .708 1.706c0 .345-.071.685-.214.992Zm3.182-3.444a.641.641 0 0 1-.636-.576l-.236-2.468-2.156-.981a.653.653 0 0 1-.379-.593.64.64 0 0 1 .395-.581l2.255-.949.28-2.391a.642.642 0 0 1 1.125-.34l1.563 1.82 2.402-.46a.64.64 0 0 1 .653.269.63.63 0 0 1 .017.702l-1.251 2.013 1.174 2.182c.12.22.099.494-.055.691a.647.647 0 0 1-.653.236l-2.359-.526-1.673 1.75a.631.631 0 0 1-.466.202Zm-1.169-4.59 1.163.526a.642.642 0 0 1 .373.521l.137 1.437.95-.998a.633.633 0 0 1 .603-.181l1.344.302-.68-1.273a.639.639 0 0 1 .022-.641l.669-1.086-1.333.257a.637.637 0 0 1-.609-.213l-.85-.999-.154 1.3a.637.637 0 0 1-.39.516l-1.245.532Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LinePriority = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LinePriority",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "m6.192 11.18 2.3 2.079-.63 3.22c-.048.247.048.5.245.647a.623.623 0 0 0 .677.038l2.721-1.58 2.715 1.58c.214.127.475.11.673-.038a.654.654 0 0 0 .245-.647l-.63-3.225 2.3-2.08a.658.658 0 0 0 .181-.68.632.632 0 0 0-.528-.444l-3.142-.34-1.243-2.93a.623.623 0 0 0-.57-.384.626.626 0 0 0-.571.384L9.692 9.71l-3.142.34a.632.632 0 0 0-.528.444.63.63 0 0 0 .17.686Zm3.985-.225a.621.621 0 0 0 .507-.384l.816-1.926.816 1.926a.63.63 0 0 0 .507.384l2.086.225-1.5 1.355a.652.652 0 0 0-.202.609l.432 2.21-1.835-1.07a.623.623 0 0 0-.619 0l-1.835 1.07.432-2.21a.662.662 0 0 0-.197-.61l-1.499-1.349 2.091-.23ZM15.667 0H7.333C5.494 0 4 1.536 4 3.429V20.57C4 22.464 5.494 24 7.334 24h8.332C17.506 24 19 22.464 19 20.571V3.434C19 1.541 17.506 0 15.666 0ZM7.333 1.717h8.332c.918 0 1.664.768 1.664 1.712v.427H5.664V3.43c0-.944.747-1.712 1.67-1.712Zm10.002 3.856v12.859H5.664V5.573h11.672Zm-1.67 16.715H7.334c-.918 0-1.664-.768-1.664-1.711v-.428h11.67v.428c-.005.943-.752 1.711-1.675 1.711Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineRadiusServer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineRadiusServer",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M16.285 3H5.57v18h12.856V5.189C18.431 3.987 17.487 3 16.285 3ZM7.287 9.858h9.432v3.856H7.287V9.858Zm8.998-5.14c.258 0 .428.213.428.471v3.385H7.287V4.717h8.998Zm-8.998 14.57v-4.284h9.432v4.284H7.287ZM9.213 7.29h2.573c.34 0 .642-.302.642-.642a.661.661 0 0 0-.642-.642H9.213a.661.661 0 0 0-.642.642c0 .34.301.642.642.642Zm2.573 3.857H9.213a.661.661 0 0 0-.642.642c0 .34.301.642.642.642h2.573c.34 0 .642-.302.642-.642a.632.632 0 0 0-.642-.642Zm0 5.14H9.213a.661.661 0 0 0-.642.642c0 .34.301.642.642.642h2.573c.34 0 .642-.302.642-.642a.632.632 0 0 0-.642-.642Zm-7.715-6.77c.302-.213.34-.597.17-.9-.214-.3-.598-.34-.9-.17-.773.56-1.201 1.372-1.201 2.272a2.7 2.7 0 0 0 1.158 2.227.668.668 0 0 0 .384.127.622.622 0 0 0 .516-.258c.214-.302.126-.686-.17-.9-.34-.302-.599-.73-.599-1.201 0-.472.253-.895.642-1.196ZM1.284 10.72c0-.944.428-1.887 1.158-2.53a.62.62 0 0 0 .044-.899.62.62 0 0 0-.9-.044C.554 8.102 0 9.391 0 10.72c0 1.328.56 2.617 1.586 3.473.126.126.258.17.428.17a.71.71 0 0 0 .472-.214c.214-.258.214-.686-.044-.9a3.425 3.425 0 0 1-1.158-2.529Zm19.418-2.233c-.302-.214-.686-.126-.9.17-.213.302-.126.686.17.9.385.258.599.73.599 1.201 0 .472-.214.9-.598 1.202-.302.214-.34.598-.17.9.126.17.34.257.515.257a.71.71 0 0 0 .384-.126c.73-.56 1.158-1.371 1.158-2.271 0-.9-.428-1.717-1.158-2.233Zm1.712-1.24c-.258-.214-.686-.214-.9.044-.214.258-.214.686.044.9a3.416 3.416 0 0 1 1.158 2.529c0 .944-.428 1.887-1.158 2.53a.62.62 0 0 0-.044.899.697.697 0 0 0 .472.214c.17 0 .302-.044.428-.17.988-.9 1.586-2.145 1.586-3.473 0-1.328-.554-2.617-1.586-3.473Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineRecording = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineRecording",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M12 24C5.386 24 0 18.62 0 12S5.386 0 12 0s12 5.386 12 12-5.386 12-12 12Zm0-22.283C6.33 1.717 1.717 6.329 1.717 12c0 5.67 4.612 10.283 10.283 10.283 5.67 0 10.283-4.612 10.283-10.283 0-5.67-4.612-10.283-10.283-10.283Zm0 16.71A6.437 6.437 0 0 1 5.572 12 6.437 6.437 0 0 1 12 5.572 6.437 6.437 0 0 1 18.428 12 6.437 6.437 0 0 1 12 18.428ZM12 7.29A4.718 4.718 0 0 0 7.289 12 4.721 4.721 0 0 0 12 16.711 4.721 4.721 0 0 0 16.711 12 4.718 4.718 0 0 0 12 7.289Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineRecycle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineRecycle",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M10.003 19.882h-4.81a3.274 3.274 0 0 1-2.87-1.652 3.196 3.196 0 0 1 .01-3.24l1.795-3.086.365 1.363a.844.844 0 0 0 1.027.595.84.84 0 0 0 .595-1.032L5.011 8.688.87 9.797a.84.84 0 0 0-.596 1.032.84.84 0 0 0 1.032.595l1.359-.365-1.79 3.077a4.903 4.903 0 0 0-.01 4.934c.897 1.565 2.515 2.496 4.33 2.496h4.81a.84.84 0 0 0 .84-.84.845.845 0 0 0-.84-.844Zm4.858-16.565.84 1.445-1.35-.36a.84.84 0 0 0-1.031.595.84.84 0 0 0 .595 1.032l3.288.883c.024.005.043.014.067.02l.788.21L19.162 3a.844.844 0 0 0-.596-1.032.844.844 0 0 0-1.032.595l-.364 1.373-.855-1.469A4.943 4.943 0 0 0 12 0c-1.8 0-3.413.922-4.315 2.472L5.933 5.51a.846.846 0 0 0 .307 1.152.846.846 0 0 0 1.152-.307l1.747-3.038A3.283 3.283 0 0 1 12 1.68c1.196 0 2.262.614 2.862 1.637Zm8.256 10.829L20.4 9.49a.84.84 0 0 0-1.152-.303.84.84 0 0 0-.303 1.152l2.722 4.651a3.187 3.187 0 0 1 .01 3.236 3.265 3.265 0 0 1-2.87 1.65h-2.338l.998-.998a.837.837 0 0 0 0-1.19.837.837 0 0 0-1.19 0l-2.434 2.434-.595.595.595.595 2.434 2.434a.84.84 0 0 0 .595.244.84.84 0 0 0 .595-1.435l-.998-.998h2.337a4.94 4.94 0 0 0 4.33-2.496 4.845 4.845 0 0 0-.02-4.915Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineRefresh = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineRefresh",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M16.248 20.851a9.67 9.67 0 0 1-4.248.96c-5.414 0-9.816-4.401-9.816-9.816a9.76 9.76 0 0 1 1.738-5.558l.254 1.776c.058.417.418.72.826.72.038 0 .077 0 .115-.01a.833.833 0 0 0 .71-.94l-.643-4.47-4.464.644a.838.838 0 0 0-.71.945.833.833 0 0 0 .94.71l1.508-.215A11.487 11.487 0 0 0 .504 12c0 6.336 5.15 11.486 11.487 11.486 1.737 0 3.412-.379 4.963-1.128.418-.206.59-.7.389-1.118-.183-.408-.687-.58-1.095-.389Zm7.743-1.963a.845.845 0 0 0-.941-.71l-1.507.216A11.401 11.401 0 0 0 23.487 12C23.487 5.664 18.337.514 12 .514c-1.718 0-3.37.37-4.915 1.099-.418.192-.59.7-.398 1.118.192.418.7.59 1.118.399a9.716 9.716 0 0 1 4.2-.941c5.414 0 9.816 4.401 9.816 9.816a9.771 9.771 0 0 1-1.728 5.549l-.254-1.776a.845.845 0 0 0-.941-.71.833.833 0 0 0-.71.94l.643 4.469 4.459-.643a.846.846 0 0 0 .7-.946Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineRefurb = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineRefurb",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M17.357 21.751a.84.84 0 0 1-.39 1.12A11.37 11.37 0 0 1 11.996 24C5.657 24 .506 18.839.506 12.5c0-2.307.685-4.53 1.952-6.414l-1.503.22a.834.834 0 0 1-.947-.707.838.838 0 0 1 .706-.948l4.467-.642.642 4.47a.838.838 0 0 1-.706.948c-.043.005-.08.01-.118.01a.834.834 0 0 1-.823-.717l-.268-1.793a9.788 9.788 0 0 0-1.738 5.568c0 5.418 4.408 9.83 9.821 9.83a9.768 9.768 0 0 0 4.248-.964.84.84 0 0 1 1.118.39Zm6.633-2.36a.834.834 0 0 0-.946-.707l-1.504.22a11.437 11.437 0 0 0 1.942-6.404c0-6.344-5.157-11.5-11.49-11.5-1.718 0-3.37.37-4.917 1.103a.835.835 0 0 0 .717 1.51 9.691 9.691 0 0 1 4.2-.943c5.413 0 9.821 4.412 9.821 9.83a9.76 9.76 0 0 1-1.728 5.557l-.257-1.783a.835.835 0 1 0-1.653.241l.642 4.47 4.467-.642a.842.842 0 0 0 .706-.953ZM7.182 17.168V7.82a2.601 2.601 0 0 1 2.595-2.596H14.2a2.601 2.601 0 0 1 2.594 2.597v9.353A2.601 2.601 0 0 1 14.2 19.77H9.777a2.606 2.606 0 0 1-2.595-2.601ZM8.44 8.934v7.116h7.104V8.934H8.44Zm7.088 8.374H8.45a1.34 1.34 0 0 0 1.327 1.204H14.2c.695 0 1.257-.53 1.326-1.204ZM8.45 7.682h7.077a1.34 1.34 0 0 0-1.326-1.205H9.777c-.69 0-1.258.53-1.327 1.205Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineRewind = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineRewind",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M12 24C5.386 24 0 18.62 0 12S5.386 0 12 0s12 5.386 12 12-5.386 12-12 12Zm0-22.283C6.33 1.717 1.717 6.329 1.717 12c0 5.67 4.612 10.283 10.283 10.283 5.67 0 10.283-4.612 10.283-10.283 0-5.67-4.612-10.283-10.283-10.283Zm6.175 16.459a.857.857 0 0 0 0-1.213L13.212 12l4.963-4.963a.857.857 0 0 0-1.212-1.213l-5.566 5.573a.857.857 0 0 0 0 1.212l5.572 5.572a.843.843 0 0 0 1.206-.006Zm-7.283 0a.857.857 0 0 0 0-1.213L5.93 12l4.963-4.963A.857.857 0 0 0 9.68 5.824l-5.572 5.573a.857.857 0 0 0 0 1.212L9.68 18.18c.165.17.384.252.603.252.22 0 .44-.087.61-.258Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineRoaming = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineRoaming",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M22 6.857c0-2.6-1.978-4.734-4.47-4.91C16.885.784 15.666 0 14.276 0H6.758C4.684 0 3 1.728 3 3.856v16.287C3 22.272 4.684 24 6.758 24h7.517c2.074 0 3.758-1.728 3.758-3.857v-8.437C20.283 11.302 22 9.287 22 6.857Zm-1.31-.642h-1.422c-.048-.927-.192-1.848-.449-2.594a3.652 3.652 0 0 1 1.871 2.594Zm-4.309 1.29h1.636c-.096 1.815-.583 2.825-.818 2.99-.235-.165-.722-1.175-.818-2.99Zm0-1.29c.096-1.815.583-2.825.818-2.99.235.16.722 1.175.818 2.99h-1.636ZM4.668 3.862c0-1.18.936-2.145 2.09-2.145h7.517c.508 0 .967.192 1.326.5a4.84 4.84 0 0 0-2.363 1.853h-8.57v-.208ZM15.13 6.215h-1.422a3.64 3.64 0 0 1 1.871-2.594c-.256.751-.406 1.667-.449 2.594Zm.45 3.884a3.64 3.64 0 0 1-1.872-2.595h1.422c.043.928.193 1.844.45 2.595Zm.785 10.044c0 1.18-.935 2.145-2.09 2.145H6.758c-1.15 0-2.09-.96-2.09-2.145v-.213h11.697v.213ZM4.668 18.646V5.36h7.955a4.95 4.95 0 0 0-.23 1.497c0 2.425 1.716 4.444 3.967 4.85v6.939H4.668Zm14.151-8.547c.257-.746.401-1.662.45-2.595h1.421a3.652 3.652 0 0 1-1.87 2.595Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineRobotics = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineRobotics",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "m23.76 8.524-1.802-1.906h-1.971a2.12 2.12 0 0 0-.337-.455L16.223 2.63A2.974 2.974 0 0 0 13.279 0a2.852 2.852 0 0 0-2.533 1.488l-5.809 10.07a3.563 3.563 0 0 0-1.882 3.129v4.792C1.878 19.669 1 20.675 1 21.928V24h11.086v-2.07c0-1.25-.873-2.256-2.055-2.451v-4.68l4.573-8.043 2.25 2.266c.047.047.105.106.168.153v2.822l1.971 1.488a.843.843 0 0 0 1.151-.164.827.827 0 0 0-.163-1.16l-1.314-.995V9.594A1.997 1.997 0 0 0 20.14 8.27h1.11l1.36 1.408c.3.302.857.302 1.157 0a.822.822 0 0 0-.005-1.154ZM3.466 21.1h6.161c.468 0 .82.354.82.826v.412h-7.8v-.412c0-.472.351-.826.82-.826Zm4.93-6.412v4.754H4.702v-4.754c0-1.011.846-1.864 1.85-1.864s1.845.853 1.845 1.864ZM7.072 11.21l5.125-8.932a1.29 1.29 0 0 1 1.083-.62c.715 0 1.314.604 1.314 1.324 0 .217-.063.423-.194.625l-5.025 9.032a3.488 3.488 0 0 0-2.303-1.43Zm8.763-6.635 2.66 2.754c.084.084.126.18.126.285 0 .175-.174.371-.41.371a.39.39 0 0 1-.284-.127L15.398 5.31l.436-.736Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineRouter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineRouter",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M16.6 3.643c1.727 0 3.4.741 4.6 2.03a.857.857 0 0 1-.627 1.444.845.845 0 0 1-.622-.275c-.888-.954-2.076-1.481-3.351-1.481s-2.464.527-3.352 1.481a.853.853 0 0 1-1.204.044A.868.868 0 0 1 12 5.674a6.298 6.298 0 0 1 4.6-2.03Zm-6.54.884a.852.852 0 0 0 .616-.264 8.122 8.122 0 0 1 5.93-2.551 8.12 8.12 0 0 1 5.928 2.551.853.853 0 0 0 1.205.028.867.867 0 0 0 .027-1.213A9.802 9.802 0 0 0 16.611 0a9.802 9.802 0 0 0-7.156 3.078.862.862 0 0 0 .022 1.213c.158.159.37.236.583.236ZM4.044 18.43c-.823 0-1.488.67-1.488 1.498s.665 1.498 1.488 1.498 1.487-.67 1.487-1.498a1.49 1.49 0 0 0-1.487-1.498Zm19.798 1.498c0 2.244-1.814 4.071-4.043 4.071H4.044C1.814 24 0 22.173 0 19.929s1.815-4.072 4.044-4.072H15.75v-6.43c0-.472.381-.856.85-.856.468 0 .85.384.85.856v6.43h2.343c2.235 0 4.05 1.828 4.05 4.072Zm-1.705 0c0-1.3-1.052-2.36-2.344-2.36H4.043A2.355 2.355 0 0 0 1.7 19.93c0 1.3 1.052 2.36 2.344 2.36h15.755c1.286 0 2.338-1.06 2.338-2.36Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineSMS = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineSMS",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M19.71 2H4.284C1.92 2 0 3.907 0 6.255v7.66c0 2.201 1.695 4.02 3.856 4.233v3.002a.85.85 0 0 0 .856.85.863.863 0 0 0 .61-.25l3.603-3.575h10.79C22.08 18.175 24 16.27 24 13.92V6.256C24 3.912 22.075 2 19.71 2Zm2.573 11.92a2.568 2.568 0 0 1-2.573 2.556H8.57a.84.84 0 0 0-.604.25l-2.397 2.376v-1.776a.854.854 0 0 0-.856-.85h-.428a2.567 2.567 0 0 1-2.572-2.555V6.255A2.568 2.568 0 0 1 4.284 3.7H19.71c1.415 0 2.573 1.144 2.573 2.555v7.666Zm-7.499-5.96v4.255a.637.637 0 0 1-.642.638.637.637 0 0 1-.642-.638v-1.553l-.927 1.836a.64.64 0 0 1-.576.355.64.64 0 0 1-.576-.354l-.927-1.837v1.553a.637.637 0 0 1-.642.638.637.637 0 0 1-.641-.638V7.96c0-.294.202-.555.493-.62a.65.65 0 0 1 .724.337l1.57 3.116 1.568-3.116a.642.642 0 0 1 1.218.283Zm-6.303 3.171c0 1.013-.768 1.722-1.865 1.722a2.68 2.68 0 0 1-1.086-.207.637.637 0 0 1-.34-.84.644.644 0 0 1 .844-.337c.165.07.351.103.582.103.576 0 .576-.337.576-.446 0-.158-.039-.273-.768-.594-.362-.158-1.322-.578-1.322-1.635 0-.931.773-1.585 1.887-1.585.131 0 .477.01.84.109a.64.64 0 0 1 .449.784.646.646 0 0 1-.79.447 2.177 2.177 0 0 0-.5-.065c-.06 0-.597.01-.597.305 0 .087 0 .223.554.463.614.283 1.536.686 1.536 1.776Zm10.395 0c0 1.013-.768 1.722-1.865 1.722a2.68 2.68 0 0 1-1.086-.207.637.637 0 0 1-.34-.84.644.644 0 0 1 .845-.337c.164.07.35.103.581.103.576 0 .576-.337.576-.446 0-.158-.038-.273-.768-.594-.362-.158-1.322-.578-1.322-1.635 0-.931.774-1.585 1.887-1.585.132 0 .477.01.84.109a.64.64 0 0 1 .45.784.646.646 0 0 1-.79.447 2.177 2.177 0 0 0-.5-.065c-.06 0-.598.01-.598.305 0 .087 0 .223.554.463.615.283 1.536.686 1.536 1.776Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineSearch = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineSearch",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "m23.75 22.536-7.08-7.075a9.392 9.392 0 0 0 2.184-6.029C18.86 4.229 14.626 0 9.427 0 4.23 0 0 4.229 0 9.427c0 5.199 4.229 9.427 9.427 9.427 2.29 0 4.392-.82 6.029-2.184l7.08 7.08a.854.854 0 0 0 1.21 0 .862.862 0 0 0 .004-1.214ZM1.714 9.427c0-4.253 3.46-7.713 7.713-7.713s7.714 3.46 7.714 7.713-3.461 7.714-7.714 7.714-7.713-3.461-7.713-7.714Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineSend = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineSend",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M23.994.997C24 .952 24 .907 24 .867V.838a.84.84 0 0 0-.028-.165V.662a.08.08 0 0 1-.012-.034.613.613 0 0 0-.04-.108c-.011-.017-.017-.04-.028-.057L23.84.378a.875.875 0 0 0-.108-.125c-.017-.012-.029-.029-.046-.04a.91.91 0 0 0-.376-.188c-.01-.006-.028-.006-.04-.011a.737.737 0 0 0-.25-.006c-.017 0-.034.006-.05.006-.03.005-.058.005-.086.011L.657 6.035a.894.894 0 0 0-.654.786.892.892 0 0 0 .512.881l9.95 4.578-.876.876a.889.889 0 1 0 1.257 1.256l.877-.876 4.58 9.947c.147.318.46.517.807.517.023 0 .052 0 .074-.006a.88.88 0 0 0 .785-.654l6.003-22.212c.005-.023.005-.045.01-.068a.2.2 0 0 0 .012-.063Zm-3.863 1.621-8.323 8.32L3.49 7.11l16.641-4.493Zm-3.237 17.89-3.829-8.313 8.324-8.32-4.495 16.633Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineServer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineServer",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M19.39 0H2v24h20V2.573C22 1.157 20.826 0 19.39 0ZM3.742 8.574h16.522v5.53H3.742v-5.53ZM19.39 1.717c.479 0 .868.384.868.856v4.712H3.742V1.717H19.39ZM3.742 22.288v-6.9h16.522v6.9H3.742ZM5.695 4.29h3.478a.666.666 0 0 0 .651-.642.666.666 0 0 0-.65-.642h-3.48a.666.666 0 0 0-.651.642c0 .34.306.642.651.642Zm3.478 5.568H5.695a.666.666 0 0 0-.651.642c0 .34.306.642.651.642h3.478a.666.666 0 0 0 .651-.642c0-.34-.3-.642-.65-.642Zm0 6.857H5.695a.666.666 0 0 0-.651.642c0 .34.306.642.651.642h3.478a.666.666 0 0 0 .651-.642c0-.34-.3-.642-.65-.642Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineService = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineService",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M5.573 23.995a.856.856 0 0 1-.61-1.46l6.706-6.748.523.207a7.401 7.401 0 0 0 7.93-1.656 7.402 7.402 0 0 0 2.035-6.61l-4.152 4.152c-.97.98-2.563.98-3.547 0L12.12 9.543a2.518 2.518 0 0 1 0-3.548l4.152-4.147a7.39 7.39 0 0 0-6.61 2.035 7.4 7.4 0 0 0-1.656 7.93l.207.523-6.749 6.7a.856.856 0 0 1-1.205-1.213l5.967-5.919a9.121 9.121 0 0 1 2.232-9.23 9.116 9.116 0 0 1 9.768-2.04l1.224.475-6.116 6.1a.8.8 0 0 0 0 1.124l2.338 2.338a.795.795 0 0 0 1.123 0l6.101-6.11.475 1.218a9.118 9.118 0 0 1-2.04 9.768 9.134 9.134 0 0 1-9.23 2.232l-5.919 5.967a.857.857 0 0 1-.61.25Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineSettings = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineSettings",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M13.714 24h-3.432a.85.85 0 0 1-.855-.854V21.96a10.203 10.203 0 0 1-2.654-1.1l-.835.836a.866.866 0 0 1-1.215 0l-2.429-2.42a.854.854 0 0 1-.254-.604c0-.226.086-.446.254-.605l.836-.835a10.135 10.135 0 0 1-1.1-2.654H.86a.873.873 0 0 1-.855-.874v-3.432c0-.466.38-.854.854-.854h1.186c.245-.932.605-1.83 1.1-2.655l-.84-.825a.854.854 0 0 1-.255-.605c0-.226.086-.447.254-.605l2.429-2.424a.854.854 0 0 1 .605-.254c.225 0 .446.086.604.254l.836.835A10.619 10.619 0 0 1 9.432 2.04V.854c0-.475.389-.854.864-.854h3.432a.85.85 0 0 1 .854.854V2.04c.932.245 1.83.605 2.655 1.1l.83-.836a.854.854 0 0 1 .605-.254c.226 0 .447.086.605.254l2.42 2.429a.866.866 0 0 1 0 1.214l-.836.835c.494.826.854 1.719 1.1 2.655h1.175a.85.85 0 0 1 .855.854v3.432a.85.85 0 0 1-.855.855H21.96a10.203 10.203 0 0 1-1.1 2.654l.836.835a.866.866 0 0 1 0 1.215l-2.414 2.414a.866.866 0 0 1-1.215 0l-.835-.835c-.825.494-1.718.854-2.654 1.099v1.186a.858.858 0 0 1-.864.854Zm-2.564-1.709h1.704v-1.013c0-.417.293-.768.701-.844a8.491 8.491 0 0 0 3.293-1.368.858.858 0 0 1 1.09.096l.72.72 1.214-1.215-.72-.72a.852.852 0 0 1-.096-1.09 8.497 8.497 0 0 0 1.368-3.292.855.855 0 0 1 .845-.701h1.013v-1.709h-1.013a.855.855 0 0 1-.845-.7 8.491 8.491 0 0 0-1.368-3.293.858.858 0 0 1 .096-1.09l.72-.72-1.214-1.214-.72.72a.852.852 0 0 1-1.09.096 8.497 8.497 0 0 0-3.293-1.368.855.855 0 0 1-.7-.845V1.709h-1.71V2.73a.855.855 0 0 1-.7.845 8.491 8.491 0 0 0-3.293 1.368.858.858 0 0 1-1.09-.096l-.72-.72-1.224 1.205.72.72a.852.852 0 0 1 .096 1.09 8.319 8.319 0 0 0-1.358 3.302.855.855 0 0 1-.845.7H1.714v1.71h1.022c.418 0 .768.292.845.7a8.491 8.491 0 0 0 1.368 3.293.858.858 0 0 1-.096 1.09l-.72.72 1.214 1.214.72-.72a.852.852 0 0 1 1.09-.096 8.497 8.497 0 0 0 3.293 1.368c.408.077.7.427.7.845v1.022Zm.855-3.432c-3.778 0-6.86-3.081-6.86-6.859s3.082-6.86 6.86-6.86c3.777 0 6.86 3.082 6.86 6.86 0 3.778-3.082 6.86-6.86 6.86Zm0-12A5.144 5.144 0 0 0 6.865 12a5.144 5.144 0 0 0 5.14 5.14 5.144 5.144 0 0 0 5.14-5.14 5.144 5.144 0 0 0-5.14-5.14Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineShareData = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineShareData",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M19.285 15.424a4.291 4.291 0 0 0-3.36 1.627l-7.073-3.93c.096-.36.149-.735.149-1.128a4.25 4.25 0 0 0-.264-1.483l7.179-3.59a4.28 4.28 0 0 0 3.369 1.641 4.293 4.293 0 0 0 4.285-4.285 4.285 4.285 0 1 0-8.422 1.118L7.825 9.056a4.275 4.275 0 0 0-3.11-1.344 4.293 4.293 0 0 0-4.286 4.286 4.293 4.293 0 0 0 4.286 4.285 4.29 4.29 0 0 0 3.36-1.627l7.073 3.93A4.293 4.293 0 0 0 19.285 24a4.293 4.293 0 0 0 4.285-4.285 4.297 4.297 0 0 0-4.285-4.29Zm0-13.71a2.572 2.572 0 1 1 0 5.144 2.572 2.572 0 0 1 0-5.145ZM4.715 14.57a2.576 2.576 0 0 1-2.572-2.572 2.572 2.572 0 1 1 2.572 2.572Zm14.57 7.712a2.572 2.572 0 1 1 0-5.144 2.572 2.572 0 0 1 0 5.144Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineSignOut = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineSignOut",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M18.642 0h-7.717a4.3 4.3 0 0 0-4.286 4.286v6.857H4.197L5.31 10.03a.832.832 0 0 0 0-1.2.832.832 0 0 0-1.2 0L.852 12.002 4.11 15.17a.85.85 0 0 0 .6.259.85.85 0 0 0 .6-.26.832.832 0 0 0 0-1.199l-1.113-1.113h11.23a.861.861 0 0 0 .858-.86.864.864 0 0 0-.858-.858h-7.07V5.572h12.857v12.856H8.358v-3.642a.861.861 0 0 0-.86-.86.864.864 0 0 0-.859.86v4.929A4.3 4.3 0 0 0 10.925 24h7.717a4.3 4.3 0 0 0 4.285-4.285V4.285A4.3 4.3 0 0 0 18.642 0Zm-7.717 1.713h7.717c1.286 0 2.313.94 2.529 2.14H8.396c.216-1.194 1.248-2.14 2.529-2.14Zm7.717 20.574h-7.717c-1.286 0-2.313-.94-2.53-2.14h12.776c-.211 1.194-1.243 2.14-2.53 2.14Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineSpeed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineSpeed",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "m21.542 7.623 1.492-2.528a.82.82 0 0 0-.137-1.007.871.871 0 0 0-1.031-.134l-2.595 1.451A12.125 12.125 0 0 0 12.003 3C5.387 3 0 8.255 0 14.721c0 1.993.587 3.858 1.838 5.877a.868.868 0 0 0 1.18.279.825.825 0 0 0 .284-1.152c-1.086-1.741-1.59-3.332-1.59-5.009 0-5.54 4.613-10.045 10.285-10.045 2.08 0 4.01.611 5.634 1.65l-1.536.863a8.472 8.472 0 0 0-4.092-1.05c-4.729 0-8.569 3.846-8.569 8.582 0 2.298.987 4.393 2.847 6.059.165.145.373.22.582.22a.86.86 0 0 0 .63-.274.825.825 0 0 0-.054-1.183c-1.52-1.361-2.293-2.984-2.293-4.822 0-3.809 3.077-6.905 6.857-6.905.79 0 1.558.139 2.282.39l-5.025 2.83a.912.912 0 0 0-.077.048c-.165.117-.33.257-.488.407a4.496 4.496 0 0 0 0 6.455 4.717 4.717 0 0 0 3.308 1.334 4.717 4.717 0 0 0 3.308-1.334c.153-.15.29-.31.416-.477l.05-.075 4.822-8.175a9.82 9.82 0 0 1 1.69 5.502c0 1.671-.505 3.263-1.591 5.009a.83.83 0 0 0 .285 1.152.87.87 0 0 0 1.18-.279C23.418 18.584 24 16.714 24 14.721c.005-2.667-.916-5.126-2.458-7.098Zm-7.224 8.893a2.356 2.356 0 0 1-.225.247c-1.158 1.124-3.034 1.124-4.186 0a2.85 2.85 0 0 1 .258-4.308l9.792-5.501-5.64 9.562Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineSport = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineSport",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M21.428 1.284h-1.07V.856A.857.857 0 0 0 19.503 0h-15a.857.857 0 0 0-.856.856v.428H2.572C1.18 1.284 0 2.464 0 3.857v3.216c0 2.48 1.629 4.307 3.921 4.483.867 3.325 3.724 5.854 7.218 6.21v.665H9.428a.86.86 0 0 0-.768.472L6.735 22.76A.856.856 0 0 0 7.503 24h8.994c.296 0 .57-.154.73-.406a.868.868 0 0 0 .038-.834l-1.93-3.857a.855.855 0 0 0-.768-.472h-1.711v-.664a8.381 8.381 0 0 0 7.107-5.789C22.261 11.753 24 9.866 24 7.501V3.643c0-1.322-1.13-2.359-2.572-2.359ZM15.11 22.288H8.885l1.07-2.145h4.08l1.075 2.145ZM1.717 7.073V3.857c0-.439.416-.856.855-.856h1.07v6.453c0 .11.01.22.016.335-1.168-.28-1.941-1.317-1.941-2.716ZM12 16.099a6.649 6.649 0 0 1-6.642-6.645V1.712h13.284v7.742c0 3.66-2.978 6.645-6.642 6.645ZM22.283 7.5c0 1.3-.8 2.337-1.963 2.672a7.76 7.76 0 0 0 .038-.719V2.996h1.07c.345 0 .855.17.855.642V7.5Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineStar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineStar",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M11.997 24a.86.86 0 0 1-.751-.44l-1.917-3.39-3.546 1.623a.851.851 0 0 1-.867-.088.847.847 0 0 1-.348-.792l.453-3.862-3.828-.764a.867.867 0 0 1-.651-.578.85.85 0 0 1 .187-.847l2.646-2.86L.73 9.143a.866.866 0 0 1-.187-.848.85.85 0 0 1 .651-.577l3.828-.765-.453-3.862a.866.866 0 0 1 .348-.792.877.877 0 0 1 .867-.088L9.33 3.83 11.246.44a.86.86 0 0 1 1.502 0l1.917 3.389 3.546-1.618a.864.864 0 0 1 .867.088.842.842 0 0 1 .348.792l-.447 3.862 3.828.765c.303.06.552.28.651.577a.85.85 0 0 1-.187.847l-2.646 2.86 2.646 2.861c.21.231.281.55.187.847a.85.85 0 0 1-.651.578l-3.828.764.447 3.862c.039.308-.1.61-.348.792a.877.877 0 0 1-.867.088l-3.546-1.617-1.917 3.388a.866.866 0 0 1-.75.435Zm-2.303-5.792c.304 0 .596.16.751.44l1.552 2.745 1.552-2.745a.86.86 0 0 1 1.11-.358l2.878 1.315-.364-3.13a.861.861 0 0 1 .685-.94l3.104-.622-2.143-2.322a.86.86 0 0 1 0-1.166l2.143-2.321-3.104-.622a.852.852 0 0 1-.685-.94l.364-3.13-2.877 1.314a.866.866 0 0 1-1.11-.357l-1.553-2.75-1.552 2.744a.86.86 0 0 1-1.11.358L6.457 4.406l.365 3.13a.861.861 0 0 1-.685.94l-3.104.622 2.143 2.322a.86.86 0 0 1 0 1.166l-2.143 2.321 3.104.622c.442.088.74.495.685.94l-.365 3.13 2.878-1.314a.828.828 0 0 1 .359-.077Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineStreaming = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineStreaming",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "m8.18 9.13-2.224 5.78c0 .005-.006.005-.006.011a.522.522 0 0 1-.114.182.731.731 0 0 1-.136.12.572.572 0 0 1-.13.068.05.05 0 0 0-.024.005.691.691 0 0 1-.216.04.691.691 0 0 1-.216-.04c-.006 0-.011 0-.023-.005a.572.572 0 0 1-.13-.068.543.543 0 0 1-.16-.148.684.684 0 0 1-.09-.154c0-.006-.007-.006-.007-.011L2.492 9.13a.664.664 0 1 1 1.24-.478l1.598 4.159 1.6-4.159a.662.662 0 0 1 .859-.38c.352.13.523.517.392.858Zm6.713 2.651c0 2.02-1.497 3.67-3.334 3.67s-3.333-1.645-3.333-3.67 1.496-3.67 3.333-3.67c1.838 0 3.334 1.65 3.334 3.67Zm-1.337 0c0-1.286-.899-2.332-2.003-2.332-1.103 0-2.002 1.046-2.002 2.332 0 1.286.899 2.332 2.002 2.332 1.104 0 2.003-1.046 2.003-2.332Zm8.004 0c0 1.962-1.496 3.555-3.334 3.555H15.78v-7.11h2.446c1.838 0 3.334 1.592 3.334 3.555Zm-1.337 0c0-1.223-.899-2.224-2.003-2.224h-1.109v4.442h1.11c1.109.006 2.002-.995 2.002-2.218ZM24 2.668v18.664A2.672 2.672 0 0 1 21.332 24H2.668A2.672 2.672 0 0 1 0 21.332V2.668A2.672 2.672 0 0 1 2.668 0h18.664A2.675 2.675 0 0 1 24 2.668Zm-1.775 0a.889.889 0 0 0-.887-.887H2.668a.889.889 0 0 0-.887.887v18.664c0 .49.398.887.887.887h18.664c.49 0 .887-.398.887-.887V2.668h.006Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineSubscription = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineSubscription",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M5.008 13.086H13.9a.88.88 0 0 1 .888.872.88.88 0 0 1-.888.871H5.008a.881.881 0 0 1-.888-.871c0-.48.392-.872.888-.872Zm8.892 3.932H5.008a.881.881 0 0 0-.888.872c0 .48.398.871.888.871H13.9a.88.88 0 0 0 .888-.871.881.881 0 0 0-.888-.872Zm8.904-11.092-1.731 1.698-1.73-1.698a.645.645 0 0 1 0-.927.667.667 0 0 1 .7-.145 3.051 3.051 0 0 0-.387-.47c-1.298-1.273-3.416-1.273-4.72 0a3.24 3.24 0 0 0 0 4.63c1.298 1.274 3.416 1.274 4.72 0a.676.676 0 0 1 .945 0 .645.645 0 0 1 0 .928 4.666 4.666 0 0 1-2.699 1.296V24H1V0h16.902v2.162A4.65 4.65 0 0 1 20.6 3.457c.49.48.86 1.062 1.093 1.704l.166-.162a.676.676 0 0 1 .945 0 .645.645 0 0 1 0 .927Zm-6.678-3.658v-.525H2.782v20.509h13.344V11.126a4.627 4.627 0 0 1-2.124-1.19 4.523 4.523 0 0 1 0-6.479 4.649 4.649 0 0 1 2.124-1.19Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineSubtitles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineSubtitles",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M20.138 11.578H4.284a.637.637 0 1 1 0-1.275h15.86a.637.637 0 1 1-.006 1.275Zm.647 2.342a.637.637 0 0 0-.642-.637H4.284a.637.637 0 1 0 0 1.275h15.86a.644.644 0 0 0 .641-.638Zm-15.47 7.835 3.61-3.58h10.79c2.365 0 4.285-1.907 4.285-4.255V6.255C24 3.907 22.08 2 19.716 2H4.284C1.92 2 0 3.907 0 6.255v7.66c0 2.2 1.695 4.02 3.856 4.233v3.002a.85.85 0 0 0 .856.85.823.823 0 0 0 .604-.245ZM19.71 3.705c1.415 0 2.573 1.144 2.573 2.555v7.66a2.568 2.568 0 0 1-2.573 2.555H8.57a.84.84 0 0 0-.604.251l-2.397 2.375v-1.776a.854.854 0 0 0-.856-.85h-.428a2.567 2.567 0 0 1-2.572-2.555V6.255A2.568 2.568 0 0 1 4.284 3.7H19.71v.005Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineSuccess = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineSuccess",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M23.09 12.657c.296.414.471.921.471 1.472a2.56 2.56 0 0 1-1.897 2.464c.115.294.186.61.186.943A2.56 2.56 0 0 1 19.952 20c.116.294.187.61.187.943a2.568 2.568 0 0 1-2.572 2.557h-7.284c-1.025 0-2.056-.414-2.747-1.101-.373-.37-.96-.6-1.536-.6H.856A.854.854 0 0 1 0 20.95c0-.47.384-.85.856-.85H6c1.026 0 2.057.414 2.748 1.1.373.371.96.6 1.535.6h7.284a.854.854 0 0 0 .855-.85.854.854 0 0 0-.855-.85.854.854 0 0 1-.856-.851c0-.469.384-.85.856-.85h1.71a.854.854 0 0 0 .857-.851.854.854 0 0 0-.856-.85h-.428a.854.854 0 0 1-.856-.85c0-.47.384-.851.856-.851h2.144a.854.854 0 0 0 .856-.85.854.854 0 0 0-.856-.851h-1.71a.854.854 0 0 1-.856-.85c0-.47.384-.851.855-.851h2.145a.854.854 0 0 0 .855-.85.854.854 0 0 0-.855-.851H12.85a.854.854 0 0 1-.855-.85c0-.47.383-.85.855-.85h.521l1.19-3.752V3.264c0-.589-.438-1.063-.976-1.063-.4 0-.861.202-.982.649l-.636 2.54a.85.85 0 0 1-.225.398L7.102 10.4a2.55 2.55 0 0 1-1.815.747H.856a.854.854 0 0 1-.856-.85c0-.47.384-.851.856-.851h4.431c.23 0 .444-.087.609-.25l4.47-4.444.587-2.328C11.264 1.27 12.323.5 13.596.5c1.48 0 2.687 1.243 2.687 2.77v1.275a.807.807 0 0 1-.038.256l-1.07 3.364h6.253A2.568 2.568 0 0 1 24 10.722a2.552 2.552 0 0 1-.91 1.935Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineSwitch = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineSwitch",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M21.529 15.3a.893.893 0 0 0-1.214-.087.866.866 0 0 0-.089 1.201l.649.73h-8.872c-2.86 0-5.198-2.271-5.198-5.102 0-.9.216-1.755.693-2.528.216-.428.088-.944-.344-1.158-.432-.214-.953-.088-1.17.34-.603.944-.908 2.145-.908 3.303 0 3.773 3.114 6.856 6.927 6.856h8.877l-.648.73c-.305.34-.305.9.088 1.201.172.126.388.214.566.214a.84.84 0 0 0 .648-.302L24 18l-2.471-2.7ZM3.125 6.86h8.878c2.86 0 5.198 2.27 5.198 5.101 0 .9-.216 1.755-.693 2.529-.216.428-.089.943.305 1.157a.817.817 0 0 0 .432.126c.305 0 .604-.17.737-.427a6.642 6.642 0 0 0 .909-3.385c0-3.768-3.076-6.813-6.883-6.813H3.125l.604-.73c.305-.34.305-.899-.088-1.2-.344-.302-.91-.302-1.214.087L0 6.003l2.466 2.699c.172.17.388.301.648.301a.852.852 0 0 0 .566-.213.871.871 0 0 0 .088-1.202l-.643-.73Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineTV = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineTV",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M24 18.375V3H0v15.37h9.559v1.315h-2.89a.659.659 0 0 0-.666.657c0 .366.296.658.666.658h10.668c.37 0 .666-.292.666-.658a.659.659 0 0 0-.666-.657h-2.89v-1.316H24v.006Zm-22.225-1.76V4.76h20.45v11.855H1.775ZM13.11 19.69h-2.225v-1.315h2.225v1.315Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineTablet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineTablet",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M19.284 0H4.712A2.578 2.578 0 0 0 2.14 2.572v18.856A2.578 2.578 0 0 0 4.712 24h14.572a2.578 2.578 0 0 0 2.571-2.572V2.572A2.578 2.578 0 0 0 19.283 0ZM4.712 1.713h14.572a.86.86 0 0 1 .858.859v.427H3.858v-.427a.86.86 0 0 1 .854-.86Zm15.426 2.999v14.572H3.858V4.712h16.28Zm-.855 17.57H4.713a.861.861 0 0 1-.86-.859v-.427h16.286v.427a.857.857 0 0 1-.855.86Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineTalkToPerson = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineTalkToPerson",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M16.769 11.57h1.305A2.576 2.576 0 0 0 20.647 9v-.245a8.83 8.83 0 0 0-2.38-6.042c-1.55-1.665-3.638-2.625-5.88-2.707a8.5 8.5 0 0 0-6.262 2.4 8.502 8.502 0 0 0-2.62 6.166.858.858 0 1 0 1.718 0 6.81 6.81 0 0 1 2.092-4.933 6.812 6.812 0 0 1 5.015-1.92c3.642.13 6.603 3.288 6.603 7.036V9c0 .47-.384.859-.859.859h-.58A5.579 5.579 0 0 0 12.07 3a5.579 5.579 0 0 0-5.571 5.57c0 1.757.82 3.33 2.097 4.353-.969.298-1.847.72-2.586 1.257-1.617 1.186-2.51 2.856-2.51 4.703v4.257a.858.858 0 1 0 1.718 0v-4.257c0-1.305.624-2.457 1.81-3.32 1.257-.917 3.047-1.426 5.048-1.426 3.973 0 6.857 1.997 6.857 4.742v4.256a.858.858 0 1 0 1.718 0V18.88c0-2.793-2.01-5.015-5.096-5.96a5.73 5.73 0 0 0 1.214-1.35ZM8.217 8.572a3.859 3.859 0 1 1 7.496 1.286h-2.778a.858.858 0 1 0 0 1.719h1.564a3.821 3.821 0 0 1-2.418.859c-2.131-.01-3.864-1.738-3.864-3.864Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineTarget = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineTarget",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M23.95 3.487a.656.656 0 0 0-.608-.405h-2.424V.659a.665.665 0 0 0-.406-.61.67.67 0 0 0-.722.142l-3.083 3.082a.66.66 0 0 0-.192.468v2.806L15.303 7.76a9.176 9.176 0 0 0-3.365-1.86 9.191 9.191 0 0 0-7.046.693A9.164 9.164 0 0 0 .4 12.06c-1.482 4.88 1.285 10.053 6.161 11.535a9.192 9.192 0 0 0 7.046-.688 9.164 9.164 0 0 0 4.492-5.465 9.227 9.227 0 0 0-.479-6.616.881.881 0 0 0-1.595.75 7.48 7.48 0 0 1-3.247 9.782 7.448 7.448 0 0 1-5.704.558C3.123 20.71.884 16.523 2.08 12.573a7.457 7.457 0 0 1 3.635-4.43 7.448 7.448 0 0 1 8.326.874l-1.562 1.56a5.243 5.243 0 0 0-3.235-1.115 5.294 5.294 0 0 0-5.287 5.286 5.294 5.294 0 0 0 5.287 5.286 5.294 5.294 0 0 0 5.287-5.286 5.24 5.24 0 0 0-1.116-3.235l4.03-4.03h2.808a.661.661 0 0 0 .468-.19l3.083-3.083a.661.661 0 0 0 .146-.722Zm-11.183 11.26a3.524 3.524 0 0 1-7.046 0 3.524 3.524 0 0 1 5.502-2.914L8.776 14.28a.66.66 0 0 0 .468 1.127c.17 0 .338-.062.468-.192l2.446-2.445c.383.563.609 1.245.609 1.978Zm7.215-8.588h-2.148V4.012l1.76-1.759v1.488c0 .366.292.66.659.66h1.488l-1.759 1.758Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineTeamwork = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineTeamwork",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M23.139 9.427h-1.185a10.4 10.4 0 0 0-1.097-2.656l.839-.84a.858.858 0 0 0 0-1.212l-2.425-2.425a.86.86 0 0 0-.603-.253.838.838 0 0 0-.604.253l-.839.84a9.87 9.87 0 0 0-2.655-1.098V.856A.857.857 0 0 0 13.714 0h-3.428a.857.857 0 0 0-.856.856v1.185c-.933.242-1.821.61-2.655 1.098l-.84-.84a.864.864 0 0 0-.608-.252.838.838 0 0 0-.604.252L2.3 4.724a.86.86 0 0 0-.253.604.86.86 0 0 0 .253.609l.839.84A9.874 9.874 0 0 0 2.04 9.431H.856a.857.857 0 0 0-.856.856v3.43c0 .471.384.855.856.855H2.04a10.4 10.4 0 0 0 1.097 2.656l-.84.84a.86.86 0 0 0-.252.603c0 .225.088.445.253.604L4.723 21.7a.857.857 0 0 0 1.213 0l.839-.84a10.05 10.05 0 0 0 2.655 1.1v1.185c0 .472.384.856.856.856h3.428a.857.857 0 0 0 .856-.856V21.96a10.397 10.397 0 0 0 2.655-1.098l.84.84a.857.857 0 0 0 1.212 0l2.424-2.425a.858.858 0 0 0 0-1.213l-.839-.84c.488-.828.861-1.717 1.097-2.655h1.185a.857.857 0 0 0 .856-.856v-3.43a.858.858 0 0 0-.861-.855Zm-1.87 3.429a.863.863 0 0 0-.846.702 8.516 8.516 0 0 1-1.366 3.298.857.857 0 0 0 .1 1.092l.718.719-1.213 1.212-.718-.719a.856.856 0 0 0-1.092-.098 8.512 8.512 0 0 1-3.297 1.366h-.005l-.03.008a.62.62 0 0 1-.073.02.423.423 0 0 0-.05.016l-.031.014a.593.593 0 0 0-.112.058l-.028.018a.705.705 0 0 0-.099.08c-.016.016-.033.033-.044.05a.35.35 0 0 0-.054.07.312.312 0 0 1-.014.019.593.593 0 0 0-.069.12l-.008.015c-.008.015-.015.028-.02.044a.663.663 0 0 0-.027.099.679.679 0 0 0-.033.22v1.015h-1.711v-1.021a.835.835 0 0 0-.017-.165.171.171 0 0 1-.01-.049 1.563 1.563 0 0 1-.008-.03.358.358 0 0 0-.025-.074.255.255 0 0 0-.028-.055.438.438 0 0 1-.022-.044l-.022-.044-.033-.05a.38.38 0 0 0-.06-.07l-.044-.044a.705.705 0 0 0-.096-.08.598.598 0 0 0-.107-.063l-.016-.009a.186.186 0 0 0-.044-.019l-.02-.006a.443.443 0 0 0-.073-.021.692.692 0 0 1-.03-.008l-.03-.009h-.006a8.512 8.512 0 0 1-3.297-1.366.856.856 0 0 0-1.092.099l-.718.719-1.213-1.213.719-.719a.857.857 0 0 0 .099-1.091 8.517 8.517 0 0 1-1.366-3.298.89.89 0 0 0-.862-.708H1.712v-1.712h1.014a.863.863 0 0 0 .845-.702c.22-1.191.68-2.3 1.366-3.298a.857.857 0 0 0-.099-1.092l-.718-.719 1.212-1.212.719.719c.29.29.751.334 1.091.098a8.512 8.512 0 0 1 3.297-1.366.859.859 0 0 0 .703-.845V1.712h1.711v1.015c0 .412.296.768.702.845 1.19.22 2.299.68 3.297 1.366a.858.858 0 0 0 1.092-.098l.718-.72 1.213 1.213-.719.72a.857.857 0 0 0-.099 1.091 8.516 8.516 0 0 1 1.366 3.298.859.859 0 0 0 .845.702h1.015v1.712h-1.015Zm-9.584-1.53c.29.202.362.603.159.893a.654.654 0 0 1-.9.165l-.269-.187c-.411-.252-.998-.394-1.662-.394-1.377 0-2.375.674-2.375 1.607v1.169a.64.64 0 0 1-.642.642.64.64 0 0 1-.642-.642V13.41c0-1.086.647-1.975 1.679-2.469a2.774 2.774 0 0 1-.78-1.926A2.791 2.791 0 0 1 9.04 6.228a2.791 2.791 0 0 1 2.787 2.787c0 .746-.302 1.432-.784 1.931.029.014.058.028.087.04v.001c.087.04.175.08.253.13l.302.208ZM10.538 9.01A1.5 1.5 0 0 0 9.04 7.512 1.5 1.5 0 0 0 7.543 9.01c0 .823.675 1.498 1.497 1.498.823 0 1.498-.675 1.498-1.498ZM17 11.808c.318.148.604.335.85.554.16.132.79.724.785 1.789a.64.64 0 0 1-.642.642.64.64 0 0 1-.642-.642c0-.495-.292-.762-.326-.793l-.003-.003c-.466-.433-1.19-.664-2.008-.664-1.377 0-2.375.675-2.375 1.608v2.848a.64.64 0 0 1-.642.642.64.64 0 0 1-.642-.642v-2.848c0-1.07.626-1.948 1.63-2.447a2.774 2.774 0 0 1-.796-1.948 2.791 2.791 0 0 1 2.787-2.787 2.791 2.791 0 0 1 2.787 2.787c0 .735-.291 1.405-.763 1.904Zm-.526-1.91a1.5 1.5 0 0 0-1.498-1.497 1.5 1.5 0 0 0-1.498 1.497c0 .824.675 1.498 1.498 1.498s1.498-.675 1.498-1.498Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineTelephoneIP = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineTelephoneIP",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M21.433 2.144H9.858V0H3v2.144H0v19.712h3V24h6.858v-2.144h11.57A2.58 2.58 0 0 0 24 19.283V4.717a2.572 2.572 0 0 0-2.567-2.573ZM1.717 20.14V3.86h1.284v16.283H1.717v-.005Zm6.857 2.572H4.29V1.29h4.284v21.42Zm13.714-3.428a.857.857 0 0 1-.855.856H9.858V3.86h11.57c.47 0 .855.384.855.856v14.566h.005Zm-1.93-13.71h-8.57a.661.661 0 0 0-.641.64v3.856c0 .34.302.642.642.642h8.569a.66.66 0 0 0 .641-.642V6.214a.653.653 0 0 0-.641-.642Zm-.642 3.855H12.43V6.856h7.285v2.572Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineTelephonePot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineTelephonePot",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M11.144 17.678a1.497 1.497 0 1 1-2.994 0 1.497 1.497 0 1 1 2.994 0Zm-1.502-5.8c-.828 0-1.498.671-1.498 1.502a1.497 1.497 0 1 0 2.995 0c0-.83-.67-1.501-1.497-1.501Zm4.716 0c-.828 0-1.497.671-1.497 1.502a1.497 1.497 0 1 0 2.995 0c0-.83-.67-1.501-1.498-1.501ZM24 9.087v.775c0 .687-.258 1.33-.73 1.76a2.175 2.175 0 0 1-1.54.643h-.302v8.158A2.582 2.582 0 0 1 18.856 23H5.144a2.582 2.582 0 0 1-2.572-2.578v-8.158h-.301c-.56 0-1.114-.215-1.542-.644C.258 11.192 0 10.548 0 9.861v-.775C.044 4.963 5.144 2 12 2s11.956 2.963 12 7.086Zm-4.289 3.222h-.987c-1.245 0-2.27-1.072-2.27-2.403v-.857c0-1.116-1.843-2.32-4.46-2.32-2.616 0-4.458 1.204-4.458 2.32v.857c0 1.33-1.026 2.403-2.27 2.403h-.988v8.158c0 .473.384.857.855.857h13.712a.858.858 0 0 0 .855-.857v-8.158h.011Zm2.572-3.178C22.24 6.04 17.786 3.72 12 3.72S1.76 6.036 1.717 9.13v1.462h4.07V8.916C5.83 6.684 8.571 5.007 12 5.007s6.17 1.677 6.214 3.909v1.676h4.07V9.13Zm-7.925 7.042c-.828 0-1.497.67-1.497 1.501a1.497 1.497 0 1 0 2.995.006c0-.83-.67-1.507-1.498-1.507Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineThermometer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineThermometer",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M15.556 15.78V3.555A3.57 3.57 0 0 0 12 0a3.57 3.57 0 0 0-3.556 3.556V15.78a4.856 4.856 0 0 0-1.334 3.33A4.877 4.877 0 0 0 12 24a4.877 4.877 0 0 0 4.89-4.89 4.878 4.878 0 0 0-1.334-3.33ZM12 22.223a3.096 3.096 0 0 1-3.115-3.114A3.2 3.2 0 0 1 9.908 16.8c.177-.177.312-.403.312-.667V3.556a1.78 1.78 0 1 1 3.56 0v12.578c0 .27.092.49.312.667a3.188 3.188 0 0 1 1.023 2.309A3.099 3.099 0 0 1 12 22.224Zm.667-5.202V3.556A.685.685 0 0 0 12 2.89a.685.685 0 0 0-.667.667v13.471a2.2 2.2 0 0 0-1.555 2.088c0 1.243.98 2.222 2.222 2.222a2.206 2.206 0 0 0 .667-4.314ZM12 20.002a.892.892 0 0 1-.888-.887c0-.485.403-.888.888-.888s.888.403.888.888a.89.89 0 0 1-.888.887Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineTipsAndTricks = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineTipsAndTricks",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M12.456.038C6.1.038.912 5.222.912 11.582c0 1.613.346 3.178.96 4.661L.086 22.91a.84.84 0 0 0 .216.83c.178.178.394.26.61.26.086 0 .178 0 .216-.043l6.667-1.83c1.483.654 3.048.96 4.66.96C18.816 23.132 24 17.943 24 11.583 24 5.222 18.82.038 12.456.038Zm0 21.35c-1.483 0-2.875-.307-4.18-.96-.178-.086-.394-.086-.61-.043L2.13 21.913l1.483-5.491c.044-.216.044-.437-.043-.61-.61-1.306-.96-2.745-.96-4.18.043-5.453 4.45-9.85 9.85-9.85 5.4 0 9.801 4.401 9.801 9.801s-4.401 9.807-9.806 9.807ZM12.24 3.745a5.447 5.447 0 0 0-5.448 5.448c0 1.613.744 3.178 2.002 4.18.566.48.912.96.96 1.484-.346.216-.567.61-.567 1.09 0 .345.13.652.346.873a1.22 1.22 0 0 0-.346.874 1.28 1.28 0 0 0 1.306 1.305h3.484a1.28 1.28 0 0 0 1.306-1.305c0-.346-.13-.653-.345-.874a1.22 1.22 0 0 0 .345-.873c0-.437-.216-.83-.566-1.047.086-.523.393-1.003.96-1.483a5.387 5.387 0 0 0 1.958-4.18 5.376 5.376 0 0 0-5.395-5.492Zm1.742 11.76c.26 0 .437.178.437.437s-.178.437-.437.437h-3.484a.416.416 0 0 1-.437-.437c0-.26.177-.437.437-.437h3.484Zm-3.921 2.18c0 .258.177.436.437.436h3.484c.264 0 .437-.178.437-.437a.416.416 0 0 0-.437-.437h-3.484a.416.416 0 0 0-.437.437Zm4.795-5.32c-.83.697-1.306 1.436-1.435 2.266h-2.439c-.13-.83-.61-1.57-1.435-2.265a4.126 4.126 0 0 1-1.526-3.178c0-2.265 1.872-4.137 4.137-4.137 2.266 0 4.138 1.872 4.138 4.137.082 1.22-.48 2.395-1.44 3.178Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineTopUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineTopUp",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M15.858 0H8.146a4.3 4.3 0 0 0-4.285 4.286v15.428A4.3 4.3 0 0 0 8.146 24h7.717a4.3 4.3 0 0 0 4.286-4.285V4.285C20.144 1.93 18.215 0 15.859 0ZM8.146 1.713h7.717c1.286 0 2.313.94 2.53 2.14H5.612c.215-1.194 1.242-2.14 2.533-2.14ZM5.612 20.142h3.389a.861.861 0 0 0 .859-.86.861.861 0 0 0-.86-.858H5.575V5.572h12.857v12.856H12.86V9.776l1.972 1.972a.85.85 0 0 0 .6.26.85.85 0 0 0 .6-.26.833.833 0 0 0 0-1.2L12 6.431l-4.026 4.112a.832.832 0 0 0 0 1.2.832.832 0 0 0 1.2 0l1.972-1.972v12.516h-3c-1.29 0-2.318-.946-2.534-2.145Zm10.246 2.145H12.86v-2.14h5.528c-.215 1.194-1.242 2.14-2.529 2.14Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineTrackMyOrder = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineTrackMyOrder",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "m14.7.097 8.655 4.762c.345.172.436.565.393.738v9.997c0 .307-.173.566-.432.739l-8.664 5.198c-.168.13-.518.172-.82.043l-2.594-1.3a.87.87 0 0 1-.389-1.17.87.87 0 0 1 1.17-.388l1.343.69v-8.05l-3.898-2.34-3.03-1.818V9.84c2.512.389 4.415 2.427 4.415 4.891 0 1.165-.91 3.246-2.766 6.152-.993 1.559-1.904 2.815-1.947 2.858a.63.63 0 0 1-.523.259.618.618 0 0 1-.523-.259C4.573 23.09.33 17.206.33 14.693c0-2.47 1.903-4.507 4.458-4.896v-4.2c0-.307.044-.523.432-.739l8.66-4.76a.914.914 0 0 1 .82 0ZM11.664 8.24l2.604 1.558 6.876-4.157-2.378-1.3-7.102 3.899Zm2.604-6.41 2.728 1.514-7.058 3.855L7.344 5.64l6.924-3.812Zm-7.27 18.316c1.64-2.556 2.595-4.55 2.595-5.457 0-2.038-1.77-3.673-3.98-3.673S1.63 12.66 1.63 14.693c0 1.424 2.248 5.107 3.984 7.533l.313-.463c.312-.46.69-1.018 1.073-1.618Zm8.133-.916v-7.964l6.924-4.153v7.921l-6.924 4.196ZM3.36 14.689a2.258 2.258 0 0 0 2.248 2.248c1.213 0 2.25-1.036 2.25-2.249S6.82 12.44 5.607 12.44a2.255 2.255 0 0 0-2.248 2.25Zm3.198 0a.96.96 0 0 1-.954.953.96.96 0 0 1-.955-.954.96.96 0 0 1 .955-.954.96.96 0 0 1 .954.954Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineTrash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineTrash",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M15.86 3.005h6.858c.466 0 .84.38.84.854a.85.85 0 0 1-.854.855h-1.709v16.713A2.576 2.576 0 0 1 18.422 24H5.568a2.576 2.576 0 0 1-2.573-2.573V4.714H1.286a.847.847 0 0 1-.854-.855c0-.48.38-.854.854-.854H8.15v-.427A2.574 2.574 0 0 1 10.714.005h2.572a2.576 2.576 0 0 1 2.573 2.573v.427Zm-5.151-1.287a.856.856 0 0 0-.855.855L9.85 3h4.286v-.427a.856.856 0 0 0-.854-.855h-2.573Zm8.582 19.71a.856.856 0 0 1-.854.854H5.568a.856.856 0 0 1-.854-.855V4.714h14.572v16.713h.005ZM9 6.431a.85.85 0 0 0-.854.854v12.428a.85.85 0 0 0 .854.854.85.85 0 0 0 .854-.854V7.286A.85.85 0 0 0 9 6.432Zm5.15.854v12.428c0 .475.38.854.855.854a.85.85 0 0 0 .854-.854V7.286a.85.85 0 0 0-.854-.854.85.85 0 0 0-.855.854Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineTripleOffer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineTripleOffer",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M19.83 6.758a9.489 9.489 0 0 0-2.572-2.572A9.412 9.412 0 0 0 9.43 0C4.23 0 0 4.23 0 9.43a9.421 9.421 0 0 0 4.18 7.828 9.492 9.492 0 0 0 2.573 2.573A9.42 9.42 0 0 0 14.57 24c5.2 0 9.43-4.23 9.43-9.43.006-3.248-1.657-6.117-4.17-7.812ZM1.718 9.43c0-4.251 3.462-7.713 7.713-7.713 4.251 0 7.713 3.462 7.713 7.713 0 4.251-3.462 7.713-7.713 7.713-4.251.005-7.713-3.456-7.713-7.713Zm7.713 9.43c5.2 0 9.43-4.23 9.43-9.43 0-.362-.022-.719-.06-1.07a7.638 7.638 0 0 1 .921 3.643c0 4.251-3.461 7.713-7.713 7.713a7.639 7.639 0 0 1-3.642-.922 8.48 8.48 0 0 0 1.064.066Zm5.146 3.428a7.64 7.64 0 0 1-3.643-.921c.351.038.708.06 1.07.06 5.2 0 9.43-4.23 9.43-9.43a9.83 9.83 0 0 0-.06-1.07 7.638 7.638 0 0 1 .92 3.643c-.005 4.257-3.466 7.718-7.717 7.718ZM12.43 10.675c0 1.53-1.509 2.732-3.434 2.732-.79 0-1.564-.214-2.173-.609a.859.859 0 0 1-.258-1.185.859.859 0 0 1 1.185-.258c.335.22.78.335 1.246.335 1.014 0 1.722-.537 1.722-1.02 0-.477-.735-1.02-1.722-1.032h-.423a.857.857 0 0 1 0-1.711h.423c1.07-.011 1.722-.527 1.722-.807 0-.323-.686-.817-1.722-.817a2.7 2.7 0 0 0-1.098.214.856.856 0 1 1-.69-1.569 4.441 4.441 0 0 1 1.782-.356c1.926 0 3.434 1.113 3.434 2.528 0 .664-.34 1.262-.9 1.707.566.499.906 1.146.906 1.848Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineTrusted = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineTrusted",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "m9.843 17.15-3.386-3.446a.884.884 0 0 1 0-1.235.847.847 0 0 1 1.213 0l2.19 2.23 6.256-6.168a.847.847 0 0 1 1.213.022c.329.346.318.9-.022 1.235L9.843 17.15Zm2.415 6.81C14.42 23.252 21 21.1 21 15.275V4.799a.865.865 0 0 0-.856-.872c-4.248 0-7.469-3.597-7.507-3.636A.855.855 0 0 0 12 0a.846.846 0 0 0-.637.29c-.032.04-3.26 3.637-7.507 3.637A.865.865 0 0 0 3 4.8v10.475c0 1.441 0 5.827 8.742 8.687a.862.862 0 0 0 .516 0ZM11.995 2.1c1.168 1.096 3.841 3.218 7.287 3.531v9.643c0 3.056-2.316 5.262-7.287 6.938-4.972-1.676-7.288-3.882-7.288-6.938V5.63c3.446-.313 6.119-2.435 7.288-3.53Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineTube = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineTube",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M22 9.515V22.92a.864.864 0 0 1-.863.863.864.864 0 0 1-.862-.863V9.515c0-4.29-3.49-7.783-7.775-7.783-4.286 0-7.775 3.493-7.775 7.783V22.92a.864.864 0 0 1-.862.863A.864.864 0 0 1 3 22.92V9.515C3 4.268 7.263 0 12.505 0 17.748 0 22 4.273 22 9.515Zm-2.997 13.378a.648.648 0 1 1-.918.919l-3.268-3.271h-4.645l-3.268 3.27a.644.644 0 0 1-.459.189.649.649 0 0 1-.459-1.107l2.367-2.369a2.384 2.384 0 0 1-2.124-2.364V8.22a2.382 2.382 0 0 1 2.378-2.38h7.775a2.382 2.382 0 0 1 2.378 2.38v9.946a2.38 2.38 0 0 1-2.124 2.363l2.367 2.364Zm-1.543-6.244a.432.432 0 1 0-.864.001.432.432 0 0 0 .864 0ZM7.53 8.22v4.108h9.937V8.22a1.08 1.08 0 0 0-1.079-1.08h-7.78c-.597 0-1.078.482-1.078 1.08Zm1.078 11.026h7.775c.542 0 .984-.398 1.061-.918-.132.033-.27.055-.414.055a1.728 1.728 0 0 1-1.725-1.727c0-.952.774-1.727 1.725-1.727.15 0 .293.028.431.06v-1.355H7.53v1.356a1.58 1.58 0 0 1 .431-.061 1.728 1.728 0 0 1 0 3.454c-.144 0-.282-.022-.415-.055.078.52.52.918 1.062.918Zm-.647-2.164a.432.432 0 1 0-.001-.864.432.432 0 0 0 .001.864Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineUndo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineUndo",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M13.286 1.286c-5.784 0-10.54 4.628-10.713 10.373l-1.114-1.113a.832.832 0 0 0-1.2 0 .833.833 0 0 0 0 1.2l3.173 3.172 3.173-3.172a.833.833 0 0 0 0-1.2.832.832 0 0 0-1.2 0l-1.119 1.07C4.502 6.859 8.443 3 13.286 3c4.973 0 9 4.027 9 9s-4.027 9-9 9a.858.858 0 1 0 .001 1.718C19.2 22.714 24 17.914 24 12S19.2 1.286 13.286 1.286Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineUnlimitedCallsAndSMS = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineUnlimitedCallsAndSMS",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "m22.438 4.062-1.349-1.326a2.522 2.522 0 0 0-1.646-.734 2.194 2.194 0 0 0-1.687.646l-2.02 2.03a2.19 2.19 0 0 0-.63 1.694 2.5 2.5 0 0 0 .753 1.635l1.413 1.39c.391.385.321 1.013.187 1.473-.24.85-.876 1.82-1.792 2.74-1.897 1.908-3.596 2.275-4.226 1.652l-1.413-1.39a2.521 2.521 0 0 0-1.646-.733 2.186 2.186 0 0 0-1.687.646l-2.02 2.03a2.191 2.191 0 0 0-.63 1.693 2.5 2.5 0 0 0 .753 1.635l1.348 1.333C7.127 21.44 8.57 22 10.273 22c2.662 0 5.977-1.356 9.2-4.602 2.23-2.246 3.759-4.824 4.307-7.267.549-2.473.059-4.678-1.342-6.069Zm-.444 5.661c-.473 2.112-1.833 4.382-3.823 6.383-4.29 4.323-8.832 4.951-10.746 3.066l-1.343-1.326a.659.659 0 0 1-.21-.442.378.378 0 0 1 .105-.309l2.02-2.03a.386.386 0 0 1 .28-.105H8.3a.688.688 0 0 1 .45.21l1.412 1.39c1.559 1.536 4.29.867 6.806-1.664 1.145-1.152 1.92-2.368 2.248-3.526.373-1.315.14-2.473-.66-3.264l-1.413-1.39a.658.658 0 0 1-.21-.443.399.399 0 0 1 .105-.308l2.02-2.03a.395.395 0 0 1 .31-.106.688.688 0 0 1 .449.21l1.348 1.332c.952.937 1.25 2.485.83 4.352Zm-14.75.466 1.208 1.204a3.528 3.528 0 0 0 2.498 1.03 3.525 3.525 0 1 0 0-7.046c-.945 0-1.832.367-2.498 1.03L7.244 7.61 6.036 6.407a3.552 3.552 0 0 0-5.003 0 3.525 3.525 0 0 0 2.498 6.016c.905 0 1.81-.343 2.499-1.03l1.214-1.204Zm2.498-2.49c.648-.646 1.775-.646 2.422 0a1.71 1.71 0 0 1 0 2.414 1.723 1.723 0 0 1-2.422 0l-1.208-1.21 1.208-1.204Zm-4.996 2.414a1.723 1.723 0 0 1-2.423 0 1.71 1.71 0 0 1 1.208-2.915c.438 0 .876.169 1.209.5l1.208 1.205-1.202 1.21Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineUnlimitedInternet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineUnlimitedInternet",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M12.858 1C7.56 1 3.116 4.676 1.997 9.58a2.46 2.46 0 0 0-1.262.671 2.445 2.445 0 0 0 0 3.498c.357.351.801.573 1.262.67C3.116 19.325 7.554 23 12.858 23 19.003 23 24 18.068 24 12.005 24.006 5.932 19.003 1 12.858 1ZM8.81 3.593C7.784 5.136 7.066 7.274 6.786 9.726c-.28.12-.549.287-.78.515l-.86.855-.862-.85a2.41 2.41 0 0 0-.587-.417c.664-2.755 2.579-5.04 5.113-6.236Zm-1.893 9.252-.86-.85.86-.85a1.233 1.233 0 0 1 1.728 0 1.188 1.188 0 0 1 0 1.7 1.233 1.233 0 0 1-1.728 0Zm-5.628-.85c0-.32.126-.623.357-.85a1.225 1.225 0 0 1 1.723 0l.86.85-.86.85a1.233 1.233 0 0 1-1.729 0 1.205 1.205 0 0 1-.35-.85Zm2.408 2.165c.209-.114.412-.244.587-.417l.862-.85.86.85c.231.227.495.395.78.514.28 2.453.998 4.596 2.024 6.134-2.534-1.191-4.449-3.476-5.113-6.231Zm8.306 6.945c-1.564-.682-3.034-3.172-3.49-6.756.38-.113.741-.308 1.043-.606.263-.26.455-.568.582-.904h1.865v8.266Zm0-9.955h-1.865a2.493 2.493 0 0 0-.582-.904 2.487 2.487 0 0 0-1.042-.606c.46-3.584 1.925-6.074 3.489-6.762v8.272Zm10.247 0h-3.193c-.126-3.053-.927-5.722-2.145-7.557 2.93 1.38 5.03 4.217 5.338 7.557Zm-8.536-8.266c1.772.774 3.429 3.876 3.62 8.266h-3.62V2.884Zm0 18.221V12.84h3.62c-.186 4.39-1.842 7.492-3.62 8.266Zm3.193-.709c1.218-1.835 2.019-4.504 2.145-7.557h3.193c-.302 3.34-2.403 6.177-5.338 7.557Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineUnrivalledService = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineUnrivalledService",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M20.09 11.574h1.328a2.578 2.578 0 0 0 2.572-2.572v-.26c0-4.667-3.685-8.563-8.267-8.736a8.447 8.447 0 0 0-6.252 2.399A8.547 8.547 0 0 0 6.857 8.57c0 .47.383.859.858.859.47 0 .86-.384.86-.859 0-1.885.729-3.641 2.096-4.927a7.008 7.008 0 0 1 5.009-1.929c3.642.13 6.597 3.296 6.597 7.024v.26a.86.86 0 0 1-.859.858h-.6c.087-.427.173-.859.173-1.286a5.554 5.554 0 0 0-5.565-5.565A5.557 5.557 0 0 0 9.86 8.57c0 1.756.816 3.34 2.097 4.37-.038.02-.076.03-.11.04-.044.012-.082.023-.106.047-.427.13-.686.643-.557 1.07.13.427.643.686 1.07.557a10.54 10.54 0 0 1 3.172-.47c3.982 0 6.851 2.015 6.851 4.754v4.198c0 .47.384.86.859.86.47 0 .859-.385.859-.86v-4.24c0-2.784-2.015-5.01-5.096-5.955.46-.38.893-.854 1.19-1.367Zm-8.522-3a3.837 3.837 0 0 1 3.853-3.852 3.837 3.837 0 0 1 3.852 3.853c0 .47-.086.897-.215 1.286h-2.783a.858.858 0 1 0 0 1.718h1.54a3.899 3.899 0 0 1-2.399.858 3.845 3.845 0 0 1-3.848-3.862Zm1.367 6.684-3.809-.383-1.497-3.426a.85.85 0 0 0-.772-.514.855.855 0 0 0-.773.514l-1.497 3.425-3.81.384c-.34.044-.642.298-.729.6-.086.302 0 .686.26.897l2.782 2.442-.772 3.771c-.086.341.086.687.34.86.26.215.643.215.94.043l3.297-1.843 3.296 1.843a.73.73 0 0 0 .427.129c.168 0 .34-.043.514-.173a.927.927 0 0 0 .34-.859l-.763-3.77 2.783-2.443c.26-.216.34-.6.26-.897-.174-.302-.471-.556-.817-.6Zm-3.809 2.999c-.216.216-.34.513-.26.816l.471 2.442-2.053-1.2a.725.725 0 0 0-.427-.13.715.715 0 0 0-.427.13l-2.06 1.152.47-2.442a.95.95 0 0 0-.259-.816l-1.67-1.459 2.357-.259a.861.861 0 0 0 .686-.513l.897-2.097.897 2.097c.13.298.384.47.686.513l2.356.26-1.665 1.506Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineUp",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M24.044 17.572a.842.842 0 0 1-.26.6.832.832 0 0 1-1.2 0L12.045 7.627 1.504 18.172a.832.832 0 0 1-1.2 0 .832.832 0 0 1 0-1.2l11.14-11.14a.832.832 0 0 1 1.2 0l11.14 11.14a.83.83 0 0 1 .26.6Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineUpdate = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineUpdate",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M16.253 20.841a9.95 9.95 0 0 1-4.253.96A9.788 9.788 0 0 1 2.198 12 9.72 9.72 0 0 1 3.95 6.45l.25 1.795c.043.418.418.71.835.71h.125c.46-.081.792-.499.71-.96l-.624-4.463-4.507.624c-.46.081-.797.499-.71.96.086.46.499.792.96.71l1.502-.206A11.483 11.483 0 0 0 .528 12c0 6.34 5.131 11.472 11.472 11.472 1.752 0 3.422-.375 4.963-1.128a.834.834 0 0 0 .374-1.128c-.163-.413-.667-.581-1.084-.375Zm7.718-1.958c-.081-.46-.5-.749-.96-.71l-1.502.206a11.47 11.47 0 0 0 1.92-6.384C23.472 5.659 18.34.528 11.999.528c-1.708 0-3.378.374-4.924 1.085a.891.891 0 0 0-.417 1.128.891.891 0 0 0 1.128.417c1.334-.624 2.712-.96 4.17-.96 5.468 0 9.846 4.378 9.846 9.802 0 2.001-.625 3.921-1.71 5.549l-.249-1.796c-.081-.46-.5-.748-.96-.71-.46.082-.792.5-.71.96l.624 4.464 4.464-.667a.778.778 0 0 0 .71-.917Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineUpgrade = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineUpgrade",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M6.32 23.998a.839.839 0 0 1-.596-1.435l10.698-10.697 4.454 4.453c.37.37.796.23.916.183.12-.053.523-.255.523-.778V1.686H8.283a.818.818 0 0 0-.777.523.82.82 0 0 0 .182.917l4.454 4.454L1.439 18.277a.842.842 0 1 1-1.19-1.19L9.755 7.58 6.492 4.316a2.486 2.486 0 0 1-.547-2.75A2.492 2.492 0 0 1 8.282.002H24v15.717c0 1.042-.6 1.935-1.56 2.333a2.495 2.495 0 0 1-2.755-.547l-3.263-3.264-9.507 9.512a.839.839 0 0 1-.596.245Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineUsage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineUsage",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M22 7.715c0-2.519-1.865-4.593-4.258-4.89C17.155 1.18 15.608 0 13.787 0H6.209C3.886 0 2 1.92 2 4.285v15.43C2 22.08 3.886 24 6.21 24h7.577c2.322 0 4.209-1.92 4.209-4.285v-7.15C20.265 12.154 22 10.14 22 7.715Zm-1.267 0c0 .773-.237 1.487-.64 2.08l-2.043-2.08 2.042-2.08a3.66 3.66 0 0 1 .642 2.08Zm-7.157 0c0-1.79 1.278-3.276 2.948-3.583v3.583c0 .164.06.329.184.455l2.49 2.535a3.519 3.519 0 0 1-2.043.653c-1.973 0-3.579-1.635-3.579-3.643Zm4.21-3.583c.517.093.996.301 1.412.592l-1.413 1.438v-2.03ZM6.208 1.712h7.578c.91 0 1.697.5 2.14 1.24a4.815 4.815 0 0 0-1.78.905H3.72c.205-1.218 1.24-2.145 2.49-2.145Zm7.578 20.576H6.209c-1.25 0-2.285-.927-2.49-2.145h12.557c-.204 1.218-1.24 2.145-2.49 2.145ZM3.68 18.431V5.569h9.12a5.006 5.006 0 0 0-.491 2.146c0 2.425 1.73 4.444 3.999 4.85v5.866H3.68Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineVideoChat2 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineVideoChat2",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M23.465 6.068a.923.923 0 0 0-.968.172l-5.605 5.262V7.3c0-.716-.598-1.298-1.332-1.298H1.332C.598 6.001 0 6.583 0 7.3v10.398c0 .715.598 1.297 1.332 1.297H15.56c.734 0 1.332-.582 1.332-1.297v-4.204l5.605 5.263a.902.902 0 0 0 .962.177.864.864 0 0 0 .54-.798V6.86a.844.844 0 0 0-.534-.793Zm-8.35 11.19H1.776V7.732h13.34v9.528Zm7.115-1.17-3.83-3.593 3.83-3.594v7.188Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineVideoChatOffline = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineVideoChatOffline",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M23.465 5.51a.892.892 0 0 0-.967.18l-5.605 5.5V6.798c0-.747-.598-1.356-1.332-1.356H6.593L1.518.265a.878.878 0 0 0-1.258 0 .918.918 0 0 0 0 1.281l5.332 5.431 9.52 9.697v.533H1.78V7.249h.887c.49 0 .888-.405.888-.904a.897.897 0 0 0-.888-.904H1.336c-.734 0-1.332.609-1.332 1.356v10.868c0 .748.598 1.356 1.332 1.356H15.56c.501 0 .933-.29 1.161-.707l5.32 5.42a.866.866 0 0 0 1.252 0 .918.918 0 0 0 0-1.282l-6.401-6.526v-2.66l5.605 5.5a.876.876 0 0 0 .961.186c.33-.145.54-.47.54-.835V6.339a.883.883 0 0 0-.534-.828ZM8.375 7.25h6.742v6.868L8.375 7.249Zm13.855 8.734-3.83-3.756 3.83-3.756v7.512Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineVideoChat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineVideoChat",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M12.44 0C6.06 0 .875 5.188.875 11.559c0 1.625.33 3.188.977 4.657l-1.82 6.678a.872.872 0 0 0 1.067 1.078l6.676-1.82a11.47 11.47 0 0 0 4.66.977C18.815 23.129 24 17.94 24 11.57 24 5.199 18.82 0 12.44 0Zm0 21.381a9.736 9.736 0 0 1-4.207-.944.9.9 0 0 0-.603-.055l-5.51 1.502 1.504-5.506a.867.867 0 0 0-.056-.603 9.74 9.74 0 0 1-.944-4.205c0-5.41 4.408-9.817 9.822-9.817 5.414 0 9.822 4.406 9.822 9.817-.006 5.405-4.414 9.811-9.828 9.811ZM18.9 7.053a.867.867 0 0 0-.944.167l-2.24 2.105V6.98H5.237v8.722h10.476v-2.345l2.24 2.105a.87.87 0 0 0 .945.162.873.873 0 0 0 .525-.799v-6.98a.871.871 0 0 0-.525-.792Zm-4.93 6.907H6.987V8.722h6.984v5.238Zm3.71-1.145-1.565-1.468 1.565-1.469v2.937Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineVoicemail = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineVoicemail",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M10.928 8.14a3.43 3.43 0 1 0 0 6.862h7.496a3.43 3.43 0 0 0 3.431-3.432 3.429 3.429 0 0 0-2.572-3.31V4.285A4.293 4.293 0 0 0 14.998 0H7.286A4.293 4.293 0 0 0 3 4.286v15.428A4.293 4.293 0 0 0 7.286 24h7.712a4.293 4.293 0 0 0 4.285-4.285V16.71a.85.85 0 0 0-.854-.854.85.85 0 0 0-.854.854v1.709H4.713V5.567H17.56v2.692a3.423 3.423 0 0 0-2.572 3.311c0 .624.173 1.205.466 1.709h-1.575a3.4 3.4 0 0 0 .466-1.709 3.428 3.428 0 0 0-3.417-3.43Zm-1.723 3.43c0-.94.768-1.708 1.709-1.708.94 0 1.708.768 1.708 1.708 0 .941-.768 1.709-1.708 1.709a1.713 1.713 0 0 1-1.709-1.709Zm-1.92-9.862h7.713c1.271 0 2.332.931 2.534 2.146H4.747a2.583 2.583 0 0 1 2.539-2.146Zm7.713 20.579H7.286a2.574 2.574 0 0 1-2.534-2.145h12.775a2.577 2.577 0 0 1-2.53 2.145Zm1.708-10.716c0-.941.768-1.709 1.709-1.709.94 0 1.708.768 1.708 1.708 0 .941-.768 1.709-1.709 1.709-.94 0-1.708-.768-1.708-1.709Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineVolumeUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineVolumeUp",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M16.142.12a.854.854 0 0 0-.872 0L4.128 6.664H.87a.88.88 0 0 0-.87.888v8.89c0 .49.391.888.871.888h3.257l11.142 6.55a.852.852 0 0 0 .872 0 .892.892 0 0 0 .435-.768V.888a.874.874 0 0 0-.436-.768Zm-1.307 21.46-10.038-5.9a.852.852 0 0 0-.436-.12h-2.62V8.447h2.62c.15 0 .302-.04.436-.12l10.037-5.902v19.157ZM24 12.003a.88.88 0 0 1-.871.888h-1.525v1.56a.88.88 0 0 1-.871.887.88.88 0 0 1-.872-.888v-1.554h-1.524a.88.88 0 0 1-.872-.888.88.88 0 0 1 .872-.887h1.524V9.556a.88.88 0 0 1 .872-.888.88.88 0 0 1 .87.888v1.553h1.526a.89.89 0 0 1 .871.894Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineVolume = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineVolume",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M21.1 17.855a.88.88 0 0 1-.6-.235.84.84 0 0 1-.034-1.205c2.423-2.504 2.373-6.37-.112-8.808a.84.84 0 0 1 0-1.206.884.884 0 0 1 1.231 0c3.164 3.093 3.226 8.007.145 11.186a.879.879 0 0 1-.63.268Zm-1.403-2.28a5.098 5.098 0 0 0-.156-7.172.884.884 0 0 0-1.231 0 .84.84 0 0 0 0 1.205 3.429 3.429 0 0 1 .106 4.816.841.841 0 0 0 .055 1.205.868.868 0 0 0 .59.224.86.86 0 0 0 .636-.278Zm-3.599 7.815a.849.849 0 0 0 .435-.736V1.351a.849.849 0 0 0-.435-.736.881.881 0 0 0-.868 0L4.117 6.887H.869a.861.861 0 0 0-.869.85v8.52c0 .469.39.85.869.85h3.248l11.113 6.278a.877.877 0 0 0 .434.114c.15.006.3-.032.434-.109ZM1.738 8.594H4.35c.15 0 .301-.038.435-.115l10.01-5.656v18.353l-10.01-5.65a.877.877 0 0 0-.435-.115H1.738V8.594Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineVolumeDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineVolumeDown",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M16 24a.88.88 0 0 1-.444-.12L4.205 17.338H.888A.889.889 0 0 1 0 16.45V7.556c0-.49.398-.887.888-.887h3.317L15.556.119a.889.889 0 0 1 1.331.768v22.225A.889.889 0 0 1 16 24ZM1.775 15.556h2.669a.88.88 0 0 1 .444.12l10.224 5.9V2.424l-10.224 5.9a.88.88 0 0 1-.444.12H1.775v7.112ZM24 12a.889.889 0 0 0-.888-.888H18.67a.889.889 0 0 0 0 1.776h4.443a.89.89 0 0 0 .888-.888Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineWANGateway = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineWANGateway",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M23.346 20.837H14.59a2.491 2.491 0 0 0-1.69-1.714v-2.794h4.221c3.021 0 5.558-2.481 5.558-5.454 0-2.932-2.491-5.367-5.42-5.454C16.77 2.9 14.59 1 11.968 1a5.37 5.37 0 0 0-5.29 4.375c-2.936 0-5.337 2.436-5.337 5.454 0 3.019 2.401 5.5 5.376 5.5h4.841v2.794c-.802.225-1.467.9-1.69 1.714H4.802c-.313-1.039-1.246-1.8-2.355-1.8C1.115 19.036 0 20.161 0 21.517 0 22.875 1.11 24 2.446 24c1.11 0 2.042-.768 2.355-1.8H9.87c.313 1.038 1.245 1.8 2.355 1.8 1.109 0 2.042-.768 2.355-1.8h8.754a.69.69 0 0 0 .666-.676c0-.358-.296-.687-.654-.687Zm-12.22-6.308H6.725c-2.003 0-3.601-1.622-3.601-3.7 0-2.032 1.598-3.653 3.6-3.653a3.72 3.72 0 0 1 2.003.588c.398.272.979.18 1.246-.225.267-.404.176-.992-.222-1.264-.398-.271-.842-.45-1.291-.629a3.543 3.543 0 0 1 3.51-2.84c2.002 0 3.6 1.622 3.6 3.654 0 .404-.045.675-.13.993-.131.45.09.992.58 1.125a.547.547 0 0 0 .267.046.89.89 0 0 0 .842-.629c.091-.225.131-.496.177-.767 1.956.092 3.6 1.714 3.6 3.653 0 1.986-1.735 3.653-3.777 3.653h-4.22v-1.442a2.51 2.51 0 0 0 1.774-2.39c0-1.35-1.11-2.482-2.446-2.482-1.337 0-2.446 1.126-2.446 2.482 0 1.126.757 2.072 1.775 2.39v1.442h-.438v-.005Zm-8.669 8.115c-.62 0-1.109-.497-1.109-1.126 0-.629.49-1.125 1.11-1.125.62 0 1.109.496 1.109 1.125 0 .63-.484 1.126-1.11 1.126Zm9.78 0c-.621 0-1.11-.497-1.11-1.126 0-.629.489-1.125 1.11-1.125.62 0 1.108.496 1.108 1.125 0 .63-.489 1.126-1.109 1.126Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineWAP = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineWAP",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M13.35 4.282a.854.854 0 0 0 0 1.708 4.68 4.68 0 0 1 4.685 4.704c0 .471.381.854.85.854.47 0 .85-.383.85-.854a6.383 6.383 0 0 0-6.384-6.412Zm0-4.282a.854.854 0 0 0 0 1.708c4.94 0 8.949 4.02 8.949 8.986 0 .471.381.854.85.854.47 0 .851-.383.851-.854C24.005 4.797 19.229 0 13.35 0ZM8.837 6.549l-.807-.728-.77.684c-.043 0-2.257 2.054-5.108 2.054H1v8.684c0 3.98 3.664 5.69 6.434 6.587l.595.17.594-.17c2.77-.898 6.434-2.612 6.434-6.587V8.559h-1.15c-2.857 0-5.071-2.01-5.071-2.01Zm4.515 10.694c0 2.223-1.62 3.767-5.284 4.961h-.083c-3.664-1.2-5.284-2.738-5.284-4.961v-6.97c2.514-.17 4.515-1.495 5.328-2.142.807.641 2.813 1.966 5.327 2.141v6.971h-.005ZM6.11 18.869l-2.595-2.612a.62.62 0 0 1 0-.898.614.614 0 0 1 .894 0l1.663 1.67 5.071-5.092a.615.615 0 0 1 .895 0 .62.62 0 0 1 0 .898L6.11 18.869Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineWIFI = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineWIFI",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M23.14 12.197a.842.842 0 0 1-.6-.26c-2.87-2.87-6.599-4.453-10.544-4.453-3.946 0-7.665 1.588-10.54 4.454a.833.833 0 0 1-1.2 0 .832.832 0 0 1 0-1.2C3.428 7.527 7.585 5.77 12 5.77s8.572 1.757 11.74 4.968c.34.34.34.902 0 1.2a.834.834 0 0 1-.6.259Zm-19.285 3a.842.842 0 0 1-.6-.26.832.832 0 0 1 0-1.2 12.226 12.226 0 0 1 8.746-3.686c3.302 0 6.426 1.325 8.74 3.687.34.34.34.902 0 1.2-.34.34-.902.34-1.2 0-2.016-2.055-4.67-3.173-7.54-3.173s-5.53 1.114-7.54 3.173c-.13.172-.39.259-.606.259Zm2.4 2.779c.173.13.384.216.6.216.216 0 .475-.082.639-.216 1.113-1.2 2.745-1.886 4.502-1.886 1.713 0 3.384.686 4.54 1.886.298.34.86.34 1.2 0 .341-.298.341-.86 0-1.2-1.454-1.54-3.552-2.4-5.74-2.4-2.27 0-4.33.86-5.784 2.4a.873.873 0 0 0 .043 1.2Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineWarning = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineWarning",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M12.5 18.853c-.827 0-1.5-.768-1.5-1.712V1.711C11 .769 11.673 0 12.5 0S14 .768 14 1.712v15.43c0 .943-.673 1.711-1.5 1.711Zm1.5 3.435c0-.944-.673-1.712-1.5-1.712s-1.5.768-1.5 1.712S11.673 24 12.5 24s1.5-.768 1.5-1.712Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineWatchFromTwoDevices = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineWatchFromTwoDevices",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M21.013 0h-5.325c-1.553 0-2.768 1.316-2.768 3H3.556C2.194 3 1 4.201 1 5.572v15.856C1 22.798 2.194 24 3.556 24h12.138c1.362 0 2.556-1.201 2.556-2.572V16.93h2.769c1.673 0 2.981-1.223 2.981-2.786V3c-.006-1.623-1.368-3-2.987-3Zm-5.32 1.717h5.326c.67 0 1.275.614 1.275 1.283v.214h-7.663V3c0-.636.365-1.283 1.063-1.283Zm-1.062 2.786h7.663v7.925h-7.663V4.503Zm-11.075.214h9.37v1.497H2.705v-.642c0-.433.425-.855.85-.855Zm12.138 17.566H3.556c-.43 0-.85-.422-.85-.855v-.642h13.838v.642c0 .433-.42.855-.85.855Zm.85-2.786H2.706V7.503h10.22v6.641c0 1.613 1.165 2.786 2.768 2.786h.85v2.567Zm4.47-4.283h-5.326c-.675 0-1.062-.39-1.062-1.07v-.427h7.663v.427c.005.702-.638 1.07-1.276 1.07Zm-.35-7.695-3.308-1.925a.95.95 0 0 0-.965 0 .973.973 0 0 0-.485.84v3.844c0 .345.186.669.486.839a.962.962 0 0 0 .97 0l3.368-1.969.103-.077a.978.978 0 0 0 .317-.822.99.99 0 0 0-.485-.73ZM17.183 9.74V6.982l2.37 1.376-2.37 1.382Zm-5.598 2.704-3.379-1.92a.983.983 0 0 0-.975.006.962.962 0 0 0-.48.84v3.838c0 .346.18.659.48.84a.987.987 0 0 0 .975.005l3.44-1.963.103-.072a.972.972 0 0 0 .321-.828.962.962 0 0 0-.485-.746Zm-3.553 2.232v-2.775l2.436 1.388-2.436 1.387Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineWorkflows = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineWorkflows",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M23.994 8.36h-6.787v8.28h2.719v6.253c0 .365.318.689.678.689.36 0 .678-.324.678-.689V16.64H24V8.36h-.006Zm-1.808 6.442h-3.17v-4.598h3.17v4.598Zm-10.189 3.221L9.731 20.05a.673.673 0 0 0-.046.966.648.648 0 0 0 .95.047l.678-.6v2.16H4.07V16.64h2.718V8.36H0v8.28h2.718V24h9.963v-3.545l.678.6c.133.095.273.183.452.183.18 0 .36-.094.499-.23.226-.276.226-.735-.047-.965l-2.266-2.02ZM1.808 10.198h3.17v4.598h-3.17v-4.598Zm10.867-7.82h7.245v2.16l-.678-.6c-.273-.23-.725-.23-.95.047-.227.277-.227.736.046.966l2.266 2.026L22.87 4.95a.673.673 0 0 0 .046-.966.648.648 0 0 0-.95-.047l-.678.6V1h-9.969v7.36H8.601v8.28h6.792V8.36h-2.718V2.378Zm.904 12.424h-3.17v-4.598h3.17v4.598Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineWorkshop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineWorkshop",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M9.424 11.93c.214 0 .428-.09.598-.264.044 0 .598-.53 1.97-.53 1.371 0 1.93.485 1.97.53a.89.89 0 0 0 1.2 0c.34-.35.34-.88 0-1.235-.087-.09-.515-.53-1.497-.794a3.109 3.109 0 0 0 1.328-2.554C14.992 5.364 13.665 4 11.992 4c-1.673 0-3 1.364-3 3.083 0 1.06.515 1.984 1.327 2.554-.944.265-1.416.704-1.498.794-.34.35-.34.925 0 1.235.176.175.39.265.603.265Zm2.573-6.166c.73 0 1.284.575 1.284 1.32 0 .743-.56 1.318-1.284 1.318s-1.283-.575-1.283-1.319.554-1.319 1.283-1.319ZM23.14 18.092a.869.869 0 0 0 .856-.88V15.41c0-1.455-.9-2.599-2.315-3.129.9-.575 1.459-1.629 1.459-2.773 0-1.804-1.46-3.303-3.215-3.303s-3.215 1.5-3.215 3.303c0 1.1.516 2.069 1.328 2.689-1.245.394-2.101 1.189-2.441 2.243l-3.17-1.939c-.259-.175-.599-.175-.9 0L8.4 14.44c-.34-1.06-1.246-1.849-2.441-2.243a3.347 3.347 0 0 0 1.327-2.689c0-1.804-1.46-3.303-3.215-3.303S.856 7.704.856 9.507c0 1.144.598 2.204 1.459 2.773C.9 12.81 0 14 0 15.41v1.803c0 .485.384.88.856.88a.869.869 0 0 0 .856-.88V15.41c0-1.015 1.07-1.72 2.572-1.72 1.503 0 2.573.705 2.573 1.72l-6.43 3.96c-.383.265-.559.795-.3 1.19.257.394.773.574 1.157.31l10.713-6.607 10.714 6.606a.79.79 0 0 0 .428.13c.302 0 .56-.13.73-.44.257-.394.126-.97-.302-1.189l-6.43-3.962c0-.97 1.07-1.72 2.573-1.72s2.573.705 2.573 1.72v1.803c0 .485.384.88.856.88ZM4.07 7.961c.812 0 1.498.705 1.498 1.54 0 .833-.686 1.538-1.498 1.538-.811 0-1.497-.704-1.497-1.539 0-.834.68-1.538 1.497-1.538Zm14.784.446c.302-.31.642-.44 1.07-.44.812 0 1.498.705 1.498 1.539s-.686 1.539-1.498 1.539c-.812 0-1.497-.705-1.497-1.539 0-.395.17-.795.427-1.1Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineYoungPeople = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineYoungPeople",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M20.045 8.011a4.349 4.349 0 0 0 1.152-4.382l2.188-.586a.831.831 0 0 0-.432-1.603l-2.558.687a4.358 4.358 0 0 0-7.737 2.75c0 1.262.537 2.4 1.401 3.197-.153.053-.302.11-.446.172a.832.832 0 0 0-.437 1.09.832.832 0 0 0 1.09.437c.82-.35 1.819-.538 2.88-.538 3.01 0 5.188 1.488 5.188 3.538v6.95c0 .461.37.83.83.83a.828.828 0 0 0 .831-.83v-6.95c.005-2.213-1.55-3.98-3.95-4.762Zm-.327-3.134a2.7 2.7 0 0 1-2.697 2.698 2.702 2.702 0 0 1-2.636-2.122l5.208-1.397c.082.26.125.533.125.82Zm-2.697-2.698c.552 0 1.065.168 1.492.452l-3.907 1.046a2.697 2.697 0 0 1 2.415-1.498Zm-6.418 8.775a4.351 4.351 0 0 0 1.373-3.173 4.361 4.361 0 0 0-5.851-4.094 2.469 2.469 0 0 0-2.467-2.4A2.473 2.473 0 0 0 1.19 3.754v2.544H0l.571 1.19c.043.096.466.926 1.416 1.2.163.048.36.082.59.082.226 0 .485-.034.773-.125a4.35 4.35 0 0 0 1.277 2.304c-2.352.797-3.873 2.549-3.873 4.737v6.884c0 .46.37.83.83.83.46 0 .83-.37.83-.83v-6.888c0-1.22.735-2.011 1.344-2.458.946-.696 2.314-1.08 3.84-1.08 3.01 0 5.19 1.488 5.19 3.538v6.95c0 .46.369.83.83.83.46 0 .83-.37.83-.83v-6.95c0-2.18-1.507-3.927-3.845-4.728ZM10.041 6.6a2.7 2.7 0 0 1-2.424 3.883A2.697 2.697 0 0 1 5.63 9.61c.72-1.344 1.925-2.29 3.576-2.803l.835-.207ZM8.582 5.26c-1.756.577-2.908 1.518-3.662 2.434A2.703 2.703 0 0 1 7.618 5.08c.34.004.667.067.964.182ZM2.741 7.086c.12-.288.12-.562.115-.7V3.748a.805.805 0 1 1 1.613 0v.749c0 .081.014.163.033.24a4.355 4.355 0 0 0-1.128 2.054c-.048.02-.09.043-.134.067a1.626 1.626 0 0 1-.5.226Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineESim = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineESim",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "m15.816.816 4.498 4.368c.513.514.902 1.373.897 2.102V24H2.827L2.784 2.784C2.784 1.2 3.902 0 5.357 0h8.573c.73 0 1.372.298 1.886.816ZM4.54 22.286h14.967v-15c0-.259-.168-.686-.384-.902l-4.502-4.373c-.216-.211-.428-.297-.687-.297H5.362c-.6 0-.86.556-.86 1.07l.039 19.502ZM9 16.243c-.13-.384-.173-.773-.216-1.243 0 0 0-.043-.01-.082v-.172c0-1.757 1.46-3.173 3.216-3.173 1.887 0 3.216 1.368 3.216 3.34a.663.663 0 0 1-.643.644h-4.416a.62.62 0 0 1 .043.151.62.62 0 0 0 .043.151c.044.125.13.298.216.427.303.476.86.773 1.46.816.643.087 1.286-.172 1.756-.6a.62.62 0 0 1 .903 0 .62.62 0 0 1 0 .903c-.6.643-1.54.984-2.443.984h-.341a3.305 3.305 0 0 1-2.4-1.373A3.407 3.407 0 0 1 9 16.243Zm4.843-1.968c-.216-.859-.902-1.416-1.843-1.416-.898 0-1.67.6-1.886 1.416h3.73Zm2.443-5.059H7.714A1.72 1.72 0 0 0 6 10.93v9.854h12V10.93c0-.946-.773-1.714-1.714-1.714Zm0 9.854H7.714v-8.14h8.572v8.14Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineIotSensorCo2 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineIotSensorCo2",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M17.956 8.971A6.066 6.066 0 0 0 12 4C9.088 4 6.603 6.137 6.088 8.971H6c-3.302 0-6 2.7-6 6.015C0 18.3 2.698 21 6 21h12c3.302 0 6-2.7 6-6.014 0-3.315-2.704-6.015-6.044-6.015ZM18 19.254H6c-2.358 0-4.283-1.92-4.283-4.274S3.647 10.706 6 10.706c.856 0 1.673.263 2.358.698.384.262.944.128 1.201-.262.258-.391.127-.96-.257-1.222a6.267 6.267 0 0 0-1.541-.742C8.144 7.214 9.905 5.69 12 5.69c2.314 0 4.201 1.785 4.283 4.056v.217c0 .39-.044.787-.17 1.133-.087.569.17 1.043.598 1.177.088.045.17.045.258.045.384 0 .73-.263.812-.609a6.73 6.73 0 0 0 .213-1.004c2.359 0 4.284 1.92 4.284 4.274A4.286 4.286 0 0 1 18 19.254Zm-5.66-7.103c-1.327 0-2.402 1.088-2.402 2.444 0 1.35 1.07 2.438 2.402 2.438 1.333 0 2.397-1.088 2.397-2.438.005-1.356-1.064-2.444-2.397-2.444Zm0 3.577c-.598 0-1.113-.525-1.113-1.133s.515-1.133 1.113-1.133 1.113.525 1.113 1.133a1.11 1.11 0 0 1-1.113 1.133Zm5.528 1.478h-.383a.729.729 0 0 1 .213-.173c.988-.96.856-1.785.686-2.181-.258-.609-.856-1.044-1.497-1.044-.9 0-1.63.742-1.63 1.657 0 .346.302.653.643.653.34 0 .641-.307.641-.653 0-.217.17-.345.34-.345.126 0 .302.089.34.217.044.173-.087.435-.384.742-.515.524-1.37 1.306-1.37 1.306-.215.173-.259.48-.17.742.087.262.34.435.597.435h2.013c.34 0 .641-.307.641-.653.006-.351-.334-.703-.68-.703Zm-10.195-3.75c.301 0 .56.13.773.308a.613.613 0 0 0 .9 0 .638.638 0 0 0 0-.915c-.472-.435-1.032-.698-1.673-.698-1.327 0-2.402 1.088-2.402 2.444 0 1.35 1.069 2.438 2.402 2.438.641 0 1.245-.262 1.673-.697a.638.638 0 0 0 0-.915.613.613 0 0 0-.9 0 1.03 1.03 0 0 1-.773.307c-.598 0-1.114-.525-1.114-1.133 0-.614.516-1.138 1.114-1.138Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineIotSensorHealth = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineIotSensorHealth",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M18.305 0c-2.442 0-4.028.944-6.3 3.774C9.778.987 8.017 0 5.531 0 2.875 0 0 1.8 0 5.7c0 5.825 7.67 14.054 11.358 18.042.17.17.384.258.642.258a.873.873 0 0 0 .642-.258c.944-1.031 3.556-3.944 3.556-3.988l3.17-3.944C22.498 11.652 24 8.355 24 5.694 24.01 1.974 21.136 0 18.305 0Zm-.297 14.833-3.127 3.9c-1.032 1.158-2.014 2.272-2.87 3.171C8.494 18.092 1.723 10.55 1.723 5.705c0-2.743 1.931-3.988 3.813-3.988 1.882 0 3.303.598 5.828 3.944a.893.893 0 0 0 1.371 0c2.486-3.384 3.731-3.944 5.575-3.944 1.931 0 3.989 1.245 3.989 3.988-.005 2.227-1.465 5.31-4.29 9.128Zm-2.145-3.258H12.86v-3a.857.857 0 0 0-1.712 0v3h-3a.857.857 0 0 0 0 1.711h3v3.001a.857.857 0 0 0 1.712 0v-3h3.002a.857.857 0 0 0 0-1.712Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineIotSensorHumidity = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineIotSensorHumidity",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M15.767 17.223V3.468c0-.366-.332-.691-.705-.691-.373 0-.704.325-.704.691v13.755c-.801.278-1.41 1.064-1.41 1.938 0 1.152.94 2.08 2.12 2.08 1.18 0 2.12-.922 2.12-2.08-.012-.922-.62-1.66-1.421-1.938Zm-.705 2.63c-.373 0-.704-.326-.704-.692 0-.366.33-.691.704-.691.373 0 .705.325.705.691 0 .366-.332.691-.705.691Zm3.529-4.018V3.557C18.59 1.572 17.037 0 15.062 0c-1.975 0-3.529 1.572-3.529 3.557v3.049c-.138-.23-2.354-3.829-2.354-3.829-.187-.278-.47-.46-.801-.46-.331 0-.657.182-.801.46L5.271 6.606C4.656 7.622 4 8.869 4 10.02c0 1.152.47 2.215 1.27 3.048.85.833 1.928 1.247 3.108 1.247 1.18 0 2.258-.46 3.107-1.247l.048-.047v2.813c-.89.921-1.409 2.12-1.409 3.32 0 2.677 2.21 4.845 4.938 4.845C17.79 24 20 21.832 20 19.155c0-1.193-.518-2.393-1.41-3.32Zm-8.467-4.107c-.47.461-1.084.739-1.74.739-.656 0-1.27-.278-1.74-.739-.47-.46-.753-1.063-.753-1.707 0-.739.566-1.755.987-2.446L8.384 5.08s.891 1.477 1.084 1.755c.614.969 1.457 2.31 1.457 3.185a2.697 2.697 0 0 1-.8 1.707Zm4.938 10.435c-1.692 0-3.059-1.342-3.059-3.002 0-.833.421-1.613 1.084-2.216.187-.183.331-.413.331-.69l-.096-12.692a1.72 1.72 0 0 1 1.74-1.708c.94 0 1.644.739 1.644 1.708v12.691a.82.82 0 0 0 .331.691c.705.603 1.084 1.43 1.084 2.216 0 1.66-1.367 3.002-3.059 3.002Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineIotSensorTemperature = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineIotSensorTemperature",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M15.638 15.778V3.556C15.638 1.6 14.002 0 12 0S8.362 1.599 8.362 3.556v12.222A4.81 4.81 0 0 0 7 19.112C7 21.827 9.23 24 12 24s5-2.18 5-4.888a4.81 4.81 0 0 0-1.362-3.334ZM12 22.225c-1.775 0-3.184-1.377-3.184-3.113 0-.887.408-1.735 1.048-2.31.18-.176.32-.398.32-.665V3.557c0-.98.82-1.776 1.816-1.776.995 0 1.816.802 1.816 1.775v12.58c0 .268.093.49.32.666.635.58 1.048 1.423 1.048 2.31 0 1.736-1.409 3.113-3.184 3.113Zm.681-5.2V3.555c0-.353-.32-.666-.681-.666-.36 0-.681.313-.681.666v13.468c-.908.268-1.59 1.11-1.59 2.088 0 1.247 1.002 2.225 2.277 2.225 1.275 0 2.276-.979 2.276-2.225-.006-.978-.693-1.82-1.601-2.088ZM12 20a.9.9 0 0 1-.908-.888.9.9 0 0 1 .908-.887.9.9 0 0 1 .908.887A.9.9 0 0 1 12 20Z",
            "clip-rule": "evenodd"
        }
    ]
};

const O2LineIotSensorWater = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "O2LineIotSensorWater",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "fill-rule": "evenodd",
            "d": "M15.18 18.86c1.34-1.372 2.053-3.17 2.053-5.102 0-2.403-1.672-5.145-3.012-7.373-.209-.384-2.304-4.07-3.392-5.957C10.663.17 10.411 0 10.116 0a.809.809 0 0 0-.712.428C8.316 2.315 6.264 6 6.012 6.34 4.672 8.57 3 11.355 3 13.758a7.37 7.37 0 0 0 2.095 5.146 6.979 6.979 0 0 0 5.027 2.1 7.379 7.379 0 0 0 5.058-2.144c-.043 0 0 0 0 0Zm-1.253-1.158a5.31 5.31 0 0 1-3.81 1.586c-1.464 0-2.803-.56-3.854-1.63-1.044-1.03-1.591-2.44-1.591-3.9 0-1.93 1.549-4.46 2.765-6.473.209-.34 1.758-3.045 2.68-4.712.921 1.673 2.47 4.372 2.679 4.712 1.216 2.057 2.765 4.586 2.765 6.473a5.685 5.685 0 0 1-1.634 3.944c.037-.044.037 0 0 0Zm6.446-.126h-1.672c-.332 0-.627.302-.627.642s.295.642.627.642h1.672c.332 0 .627-.302.627-.642s-.295-.642-.627-.642Zm-2.68 2.315a.596.596 0 0 0-.878 0 .63.63 0 0 0 0 .9l1.13 1.157c.124.127.295.17.461.17a.637.637 0 0 0 .461-.17.63.63 0 0 0 0-.9l-1.173-1.157Zm-2.765 1.114c-.332 0-.626.302-.626.642v1.711c0 .34.294.642.627.642.332 0 .627-.302.627-.642v-1.711a.646.646 0 0 0-.627-.642Z",
            "clip-rule": "evenodd"
        }
    ]
};

/**
 * Generated bundle index. Do not edit.
 */

export { O2Line3dView, O2Line4G, O2Line5G, O2LineAPI, O2LineAccessories, O2LineAdd, O2LineAddCaller, O2LineAirplane, O2LineAirtime, O2LineAlert, O2LineApps, O2LineArrowBottomLeft, O2LineArrowBottomRight, O2LineArrowDouble1, O2LineArrowDouble2, O2LineArrowDouble3, O2LineArrowDown, O2LineArrowLeft, O2LineArrowRight, O2LineArrowUp, O2LineAttachment, O2LineAwardWinningBusinessNetwork, O2LineBag, O2LineBatteryCharged, O2LineBenefit, O2LineBoltOns, O2LineBoost, O2LineBusiness, O2LineBusinessApps, O2LineBusinessPlan, O2LineCalendar, O2LineCallCentreOperator, O2LineCallback, O2LineCalls, O2LineCamera, O2LineCertificate, O2LineCharger, O2LineChat, O2LineCheck, O2LineCheckout, O2LineCircleCross, O2LineCircuits, O2LineCleaning, O2LineClickAndCollect, O2LineClose, O2LineCloudFriends, O2LineCocktail, O2LineComment, O2LineComputer, O2LineConferenceCall, O2LineContactUs, O2LineCreditCard, O2LineCross, O2LineCustomPlans, O2LineCyberSecurity, O2LineData, O2LineDataBonus, O2LineDataCentre, O2LineDataRollover, O2LineDelivery, O2LineDevice, O2LineDevices, O2LineDigitalBox, O2LineDigitalServices, O2LineDisabled, O2LineDisturb, O2LineDocument, O2LineDown, O2LineDownload, O2LineEShop, O2LineESim, O2LineEdit, O2LineEmail, O2LineEnvelope, O2LineEscalator, O2LineEyeClosed, O2LineEyeOpen, O2LineFAQ, O2LineFamily, O2LineFamilyOnSamePlan, O2LineFastForward, O2LineFavourite, O2LineFemale, O2LineFiberNetwork, O2LineFiberQuality, O2LineFile, O2LineFilter, O2LineFindAStore, O2LineFirewall, O2LineFixInternetConnection, O2LineFixedInternet, O2LineFood, O2LineFootball, O2LineFriendsCustomersPeople, O2LineGift, O2LineGreaterFlexibility, O2LineGreen, O2LineGuarantee, O2LineGuru, O2LineHDOption, O2LineHandsFree, O2LineHandsetInsurance, O2LineHeadphoneBluetooth, O2LineHeadphones, O2LineHelp, O2LineHockley, O2LineHome, O2LineHomespot, O2LineHotline, O2LineHotspot, O2LineIdea, O2LineInStore, O2LineInformation, O2LineInsurance, O2LineInternet, O2LineInternetOfThings, O2LineIotSensorCo2, O2LineIotSensorHealth, O2LineIotSensorHumidity, O2LineIotSensorTemperature, O2LineIotSensorWater, O2LineKeepItSimple, O2LineKeyboard, O2LineLandline, O2LineLaptop, O2LineLegal, O2LineLidar, O2LineLifts, O2LineList, O2LineLockClosed, O2LineLockOpen, O2LineLockOpen2, O2LineLogin, O2LineLostFound, O2LineMale, O2LineManagedLan, O2LineManagedWirelessLan, O2LineMap, O2LineMask, O2LineMast, O2LineMenu, O2LineMicrophone, O2LineMinus, O2LineMobileCoverage, O2LineMultiSave, O2LineMultiSim, O2LineMusic, O2LineMute, O2LineMyO2, O2LineNetworkStatus, O2LineNetworking, O2LineNew, O2LineNewsletter, O2LineNext, O2LineNotification, O2LineO2Angels, O2LineOffers, O2LineOfficeLarge, O2LineOfficeSmall, O2LinePackage, O2LineParking, O2LinePause, O2LinePenTest, O2LinePerson, O2LinePlanReport, O2LinePlanReportChart, O2LinePlasticSim, O2LinePlay, O2LinePlay2, O2LinePortal, O2LinePosition, O2LinePower, O2LinePreOrder, O2LinePrevious, O2LinePricingCreditBalance, O2LinePrinter, O2LinePriority, O2LinePriorityTickets, O2LineRadiusServer, O2LineRecording, O2LineRecycle, O2LineRefresh, O2LineRefurb, O2LineRewind, O2LineRoaming, O2LineRobotics, O2LineRouter, O2LineSMS, O2LineSearch, O2LineSend, O2LineServer, O2LineService, O2LineSettings, O2LineShareData, O2LineSignOut, O2LineSpeed, O2LineSport, O2LineStar, O2LineStreaming, O2LineSubscription, O2LineSubtitles, O2LineSuccess, O2LineSwitch, O2LineTV, O2LineTablet, O2LineTalkToPerson, O2LineTarget, O2LineTeamwork, O2LineTelephoneIP, O2LineTelephonePot, O2LineThermometer, O2LineTipsAndTricks, O2LineTopUp, O2LineTrackMyOrder, O2LineTrash, O2LineTripleOffer, O2LineTrusted, O2LineTube, O2LineUndo, O2LineUnlimitedCallsAndSMS, O2LineUnlimitedInternet, O2LineUnrivalledService, O2LineUp, O2LineUpdate, O2LineUpgrade, O2LineUsage, O2LineVideoChat, O2LineVideoChat2, O2LineVideoChatOffline, O2LineVoicemail, O2LineVolume, O2LineVolumeDown, O2LineVolumeUp, O2LineWANGateway, O2LineWAP, O2LineWIFI, O2LineWarning, O2LineWatchFromTwoDevices, O2LineWorkflows, O2LineWorkshop, O2LineYoungPeople };
//# sourceMappingURL=virginmediao2-momentum-icons-icons-o2-line.mjs.map
